var items = {
  "block.minecraft.acacia_button": "ಅಕೇಶಿಯ ಬಟನ್",
  "block.minecraft.acacia_door": "ಅಕೇಶಿಯ ಡೋರ್",
  "block.minecraft.acacia_fence": "\nಅಕೇಶಿಯ ಬೇಲಿ",
  "block.minecraft.acacia_fence_gate": "\nಅಕೇಶಿಯ ಬೇಲಿ ಗೇಟ್",
  "block.minecraft.acacia_hanging_sign": "ಅಕೇಶಿಯ ನೇತಾಡುವ ಚಿಹ್ನೆ",
  "block.minecraft.acacia_leaves": "\nಅಕೇಶಿಯ ಎಲೆಗಳು",
  "block.minecraft.acacia_log": "ಅಕೇಶಿಯ ಲಾಗ್",
  "block.minecraft.acacia_planks": "ಅಕೇಶಿಯ ಪ್ಲಾಂಕ್ಸ್",
  "block.minecraft.acacia_pressure_plate": "ಅಕೇಶಿಯ ಪ್ರೆಶರ್ ಪ್ಲೇಟ್",
  "block.minecraft.acacia_sapling": "ಅಕೇಶಿಯ ಸಸಿ",
  "block.minecraft.acacia_shelf": "Acacia Shelf",
  "block.minecraft.acacia_sign": "ಅಕೇಶಿಯ ಸೈನ್",
  "block.minecraft.acacia_slab": "ಅಕೇಶಿಯ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.acacia_stairs": "\nಅಕೇಶಿಯ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.acacia_trapdoor": "ಅಕೇಶಿಯ ಟ್ರ್ಯಾಪ್ಡೋರ್",
  "block.minecraft.acacia_wall_hanging_sign": "ಅಕೇಶಿಯ ವಾಲ್ ಹ್ಯಾಂಗಿಂಗ್ ಚಿಹ್ನೆ",
  "block.minecraft.acacia_wall_sign": "ಅಕೇಶಿಯ ವಾಲ್ ಸೈನ್",
  "block.minecraft.acacia_wood": "ಅಕೇಶಿಯ ವುಡ್",
  "block.minecraft.activator_rail": "ಆಕ್ಟಿವೇಟರ್ ರೈಲು",
  "block.minecraft.air": "ಗಾಳಿ",
  "block.minecraft.allium": "ಆಲಿಯಮ್",
  "block.minecraft.amethyst_block": "ಅಮೆಥಿಸ್ಟ್ನ ಬ್ಲಾಕ್",
  "block.minecraft.amethyst_cluster": "ಅಮೆಥಿಸ್ಟ್ ಕ್ಲಸ್ಟರ್",
  "block.minecraft.ancient_debris": "ಪ್ರಾಚೀನ ಶಿಲಾಖಂಡರಾಶಿಗಳು",
  "block.minecraft.andesite": "ಅಂಡಿಸೈಟ್",
  "block.minecraft.andesite_slab": "ಅಂಡಿಸೈಟ್ ಚಪ್ಪಡಿ",
  "block.minecraft.andesite_stairs": "ಅಂಡಿಸೈಟ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.andesite_wall": "ಅಂಡಿಸೈಟ್ ವಾಲ್",
  "block.minecraft.anvil": "ಬಡಿಗಲ್ಲು",
  "block.minecraft.attached_melon_stem": "\nಲಗತ್ತಿಸಲಾದ ಕಲ್ಲಂಗಡಿ ಕಾಂಡ",
  "block.minecraft.attached_pumpkin_stem": "ಲಗತ್ತಿಸಲಾದ ಕುಂಬಳಕಾಯಿ ಕಾಂಡ",
  "block.minecraft.azalea": "ಅಜೇಲಿಯಾ",
  "block.minecraft.azalea_leaves": "ಅಜೇಲಿಯಾ ಎಲೆಗಳು",
  "block.minecraft.azure_bluet": "\nಅಜುರೆ ಬ್ಲೂಟ್",
  "block.minecraft.bamboo": "ಬಿದಿರು",
  "block.minecraft.bamboo_block": "ಬಿದಿರು ಬ್ಲಾಕ್",
  "block.minecraft.bamboo_button": "ಬಿದಿರಿನ ಬಟನ್",
  "block.minecraft.bamboo_door": "ಮುಳಬಾಗಿಲು",
  "block.minecraft.bamboo_fence": "ಬಿದಿರಿನ ಬೇಲಿ",
  "block.minecraft.bamboo_fence_gate": "ಬಿದಿರಿನ ಬೇಲಿ ಗೇಟ್",
  "block.minecraft.bamboo_hanging_sign": "ಬಿದಿರು ನೇತಾಡುವ ಚಿಹ್ನೆ",
  "block.minecraft.bamboo_mosaic": "ಬಿದಿರು ಮೊಸಾಯಿಕ್",
  "block.minecraft.bamboo_mosaic_slab": "ಬಿದಿರಿನ ಮೊಸಾಯಿಕ್ ಚಪ್ಪಡಿ",
  "block.minecraft.bamboo_mosaic_stairs": "ಬಿದಿರಿನ ಮೊಸಾಯಿಕ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.bamboo_planks": "ಬಿದಿರಿನ ಹಲಗೆಗಳು",
  "block.minecraft.bamboo_pressure_plate": "ಬಿದಿರಿನ ಒತ್ತಡದ ತಟ್ಟೆ",
  "block.minecraft.bamboo_sapling": "ಬಿದಿರಿನ ಚಿಗುರು",
  "block.minecraft.bamboo_shelf": "Bamboo Shelf",
  "block.minecraft.bamboo_sign": "ಬಿದಿರಿನ ಚಿಹ್ನೆ",
  "block.minecraft.bamboo_slab": "ಬಿದಿರು ಚಪ್ಪಡಿ",
  "block.minecraft.bamboo_stairs": "ಬಿದಿರಿನ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.bamboo_trapdoor": "ಬಿದಿರಿನ ಟ್ರ್ಯಾಪ್ಡೋರ್",
  "block.minecraft.bamboo_wall_hanging_sign": "ಬಿದಿರಿನ ಗೋಡೆಯ ನೇತಾಡುವ ಚಿಹ್ನೆ",
  "block.minecraft.bamboo_wall_sign": "ಬಿದಿರಿನ ಗೋಡೆಯ ಚಿಹ್ನೆ",
  "block.minecraft.banner.base.black": "ಸಂಪೂರ್ಣ ಕಪ್ಪು ಕ್ಷೇತ್ರ",
  "block.minecraft.banner.base.blue": "ಸಂಪೂರ್ಣ ನೀಲಿ ಕ್ಷೇತ್ರ",
  "block.minecraft.banner.base.brown": "ಸಂಪೂರ್ಣ ಬ್ರೌನ್ ಫೀಲ್ಡ್",
  "block.minecraft.banner.base.cyan": "ಸಂಪೂರ್ಣ ಸಯಾನ್ ಕ್ಷೇತ್ರ",
  "block.minecraft.banner.base.gray": "ಸಂಪೂರ್ಣ ಗ್ರೇ ಫೀಲ್ಡ್",
  "block.minecraft.banner.base.green": "ಸಂಪೂರ್ಣ ಹಸಿರು ಕ್ಷೇತ್ರ",
  "block.minecraft.banner.base.light_blue": "ಸಂಪೂರ್ಣ ತಿಳಿ ನೀಲಿ ಕ್ಷೇತ್ರ",
  "block.minecraft.banner.base.light_gray": "ಸಂಪೂರ್ಣ ತಿಳಿ ಬೂದು ಕ್ಷೇತ್ರ",
  "block.minecraft.banner.base.lime": "ಸಂಪೂರ್ಣ ಸುಣ್ಣ ಕ್ಷೇತ್ರ",
  "block.minecraft.banner.base.magenta": "ಸಂಪೂರ್ಣ ಮೆಜೆಂಟಾ ಕ್ಷೇತ್ರ",
  "block.minecraft.banner.base.orange": "ಸಂಪೂರ್ಣ ಕಿತ್ತಳೆ ಕ್ಷೇತ್ರ",
  "block.minecraft.banner.base.pink": "ಸಂಪೂರ್ಣ ಗುಲಾಬಿ ಕ್ಷೇತ್ರ",
  "block.minecraft.banner.base.purple": "ಸಂಪೂರ್ಣ ನೇರಳೆ ಕ್ಷೇತ್ರ",
  "block.minecraft.banner.base.red": "ಸಂಪೂರ್ಣವಾಗಿ ಕೆಂಪು ಕ್ಷೇತ್ರ",
  "block.minecraft.banner.base.white": "ಸಂಪೂರ್ಣ ಬಿಳಿ ಕ್ಷೇತ್ರ",
  "block.minecraft.banner.base.yellow": "ಸಂಪೂರ್ಣ ಹಳದಿ ಕ್ಷೇತ್ರ",
  "block.minecraft.banner.border.black": "ಕಪ್ಪು ಗಡಿ",
  "block.minecraft.banner.border.blue": "ನೀಲಿ ಗಡಿ",
  "block.minecraft.banner.border.brown": "ಬ್ರೌನ್ ಬೋರ್ಡರ್",
  "block.minecraft.banner.border.cyan": "ಸಯಾನ್ ಬೋರ್ಡರ್",
  "block.minecraft.banner.border.gray": "ಬೂದು ಗಡಿ",
  "block.minecraft.banner.border.green": "ಹಸಿರು ಗಡಿ",
  "block.minecraft.banner.border.light_blue": "ತಿಳಿ ನೀಲಿ ಗಡಿ",
  "block.minecraft.banner.border.light_gray": "ತಿಳಿ ಬೂದು ಬೋರ್ಡರ್",
  "block.minecraft.banner.border.lime": "ಸುಣ್ಣದ ಗಡಿ",
  "block.minecraft.banner.border.magenta": "ಕೆನ್ನೇರಳೆ ಗಡಿ",
  "block.minecraft.banner.border.orange": "ಕಿತ್ತಳೆ ಗಡಿ",
  "block.minecraft.banner.border.pink": "ಗುಲಾಬಿ ಗಡಿ",
  "block.minecraft.banner.border.purple": "ಬ್ರೌನ್ ಬೋರ್ಡರ್",
  "block.minecraft.banner.border.red": "ಕೆಂಪು ಗಡಿ",
  "block.minecraft.banner.border.white": "ಬಿಳಿ ಗಡಿ",
  "block.minecraft.banner.border.yellow": "ಹಳದಿ ಗಡಿ",
  "block.minecraft.banner.bricks.black": "ಬ್ಲ್ಯಾಕ್ ಫೀಲ್ಡ್ ಮೇಸನ್ಡ್",
  "block.minecraft.banner.bricks.blue": "ಬ್ಲೂ ಫೀಲ್ಡ್ ಮೇಸನ್ಡ್",
  "block.minecraft.banner.bricks.brown": "ಬ್ರೌನ್ ಫೀಲ್ಡ್ ಮೇಸನ್ಡ್",
  "block.minecraft.banner.bricks.cyan": "ಸಯಾನ್ ಫೀಲ್ಡ್ ಮೇಸನ್ಡ್",
  "block.minecraft.banner.bricks.gray": "ಗ್ರೇ ಫೀಲ್ಡ್ ಮೇಸನ್ಡ್",
  "block.minecraft.banner.bricks.green": "ಗ್ರೀನ್ ಫೀಲ್ಡ್ ಮೇಸನ್ಡ್",
  "block.minecraft.banner.bricks.light_blue": "ತಿಳಿ ನೀಲಿ ಕ್ಷೇತ್ರ ಮೇಸನ್ಡ್",
  "block.minecraft.banner.bricks.light_gray": "ಲೈಟ್ ಗ್ರೇ ಫೀಲ್ಡ್ ಮೇಸನ್ಡ್",
  "block.minecraft.banner.bricks.lime": "ಲೈಮ್ ಫೀಲ್ಡ್ ಮೇಸನ್ಡ್",
  "block.minecraft.banner.bricks.magenta": "ಮೆಜೆಂಟಾ ಫೀಲ್ಡ್ ಮೇಸನ್ಡ್",
  "block.minecraft.banner.bricks.orange": "ಆರೆಂಜ್ ಫೀಲ್ಡ್ ಮೇಸನ್ಡ್",
  "block.minecraft.banner.bricks.pink": "ಪಿಂಕ್ ಫೀಲ್ಡ್ ಮೇಸನ್ಡ್",
  "block.minecraft.banner.bricks.purple": "ಪರ್ಪಲ್ ಫೀಲ್ಡ್ ಮೇಸನ್ಡ್",
  "block.minecraft.banner.bricks.red": "ರೆಡ್ ಫೀಲ್ಡ್ ಮೇಸನ್ಡ್",
  "block.minecraft.banner.bricks.white": "ವೈಟ್ ಫೀಲ್ಡ್ ಮೇಸನ್ಡ್",
  "block.minecraft.banner.bricks.yellow": "ಹಳದಿ ಕ್ಷೇತ್ರ ಮೇಸನ್ಡ್",
  "block.minecraft.banner.circle.black": "ಕಪ್ಪು ರೌಂಡೆಲ್",
  "block.minecraft.banner.circle.blue": "ನೀಲಿ ರೌಂಡೆಲ್",
  "block.minecraft.banner.circle.brown": "ಬ್ರೌನ್ ರೌಂಡೆಲ್",
  "block.minecraft.banner.circle.cyan": "ಸಯಾನ್ ರೌಂಡೆಲ್",
  "block.minecraft.banner.circle.gray": "ಗ್ರೇ ರೌಂಡೆಲ್",
  "block.minecraft.banner.circle.green": "ಹಸಿರು ರೌಂಡೆಲ್",
  "block.minecraft.banner.circle.light_blue": "ತಿಳಿ ನೀಲಿ ರೌಂಡೆಲ್",
  "block.minecraft.banner.circle.light_gray": "ತಿಳಿ ಬೂದು ರೌಂಡೆಲ್",
  "block.minecraft.banner.circle.lime": "ಸುಣ್ಣ ರೌಂಡೆಲ್",
  "block.minecraft.banner.circle.magenta": "ಮೆಜೆಂಟಾ ರೌಂಡೆಲ್",
  "block.minecraft.banner.circle.orange": "ಕಿತ್ತಳೆ ರೌಂಡೆಲ್",
  "block.minecraft.banner.circle.pink": "ಪಿಂಕ್ ರೌಂಡೆಲ್",
  "block.minecraft.banner.circle.purple": "ಪರ್ಪಲ್ ರೌಂಡೆಲ್",
  "block.minecraft.banner.circle.red": "ಕೆಂಪು ರೌಂಡೆಲ್",
  "block.minecraft.banner.circle.white": "ವೈಟ್ ರೌಂಡೆಲ್",
  "block.minecraft.banner.circle.yellow": "ಹಳದಿ ರೌಂಡೆಲ್",
  "block.minecraft.banner.creeper.black": "ಕಪ್ಪು ಕ್ರೀಪರ್",
  "block.minecraft.banner.creeper.blue": "ನೀಲಿ ಕ್ರೀಪರ್",
  "block.minecraft.banner.creeper.brown": "ಕಂದು ಕ್ರೀಪರ್",
  "block.minecraft.banner.creeper.cyan": "ವೈಡೂರ್ಯದ ಕ್ರೀಪರ್",
  "block.minecraft.banner.creeper.gray": "ಬೂದು ಕ್ರೀಪರ್",
  "block.minecraft.banner.creeper.green": "ಹಸಿರು ಕ್ರೀಪರ್",
  "block.minecraft.banner.creeper.light_blue": "\nತಿಳಿ ನೀಲಿ ಕ್ರೀಪರ್ ಚಾರ್ಜ್",
  "block.minecraft.banner.creeper.light_gray": "\nತಿಳಿ ಬೂದು ಕ್ರೀಪರ್ ಚಾರ್ಜ್",
  "block.minecraft.banner.creeper.lime": "ಸುಣ್ಣ ಕ್ರೀಪರ್ ಚಾರ್ಜ್",
  "block.minecraft.banner.creeper.magenta": "ಮೆಜೆಂಟಾ ಕ್ರೀಪರ್ ಚಾರ್ಜ್",
  "block.minecraft.banner.creeper.orange": "ಕಿತ್ತಳೆ ಕ್ರೀಪರ್ ಚಾರ್ಜ್",
  "block.minecraft.banner.creeper.pink": "ಗುಲಾಬಿ ಕ್ರೀಪರ್",
  "block.minecraft.banner.creeper.purple": "ನೇರಳೆ ಕ್ರೀಪರ್",
  "block.minecraft.banner.creeper.red": "ಕೆಂಪು ಕ್ರೀಪರ್",
  "block.minecraft.banner.creeper.white": "ವೈಟ್ ಕ್ರೀಪರ್ ಚಾರ್ಜ್",
  "block.minecraft.banner.creeper.yellow": "ಹಳದಿ ಕ್ರೀಪರ್",
  "block.minecraft.banner.cross.black": "ಕಪ್ಪು ಉಪ್ಪು",
  "block.minecraft.banner.cross.blue": "\nನೀಲಿ ಉಪ್ಪು",
  "block.minecraft.banner.cross.brown": "ಬ್ರೌನ್ ಸಾಲ್ಟೈರ್",
  "block.minecraft.banner.cross.cyan": "\nಸಯಾನ್ ಸಾಲ್ಟೈರ್",
  "block.minecraft.banner.cross.gray": "ಗ್ರೇ ಸಾಲ್ಟೈರ್",
  "block.minecraft.banner.cross.green": "\nಹಸಿರು ಉಪ್ಪು",
  "block.minecraft.banner.cross.light_blue": "\nತಿಳಿ ನೀಲಿ ಉಪ್ಪು",
  "block.minecraft.banner.cross.light_gray": "ತಿಳಿ ಬೂದು ಉಪ್ಪು",
  "block.minecraft.banner.cross.lime": "\nನಿಂಬೆ ಉಪ್ಪು",
  "block.minecraft.banner.cross.magenta": "ಮೆಜೆಂಟಾ ಸಾಲ್ಟೈರ್",
  "block.minecraft.banner.cross.orange": "ಕಿತ್ತಳೆ ಉಪ್ಪು",
  "block.minecraft.banner.cross.pink": "\nಗುಲಾಬಿ ಉಪ್ಪು",
  "block.minecraft.banner.cross.purple": "ನೇರಳೆ ಉಪ್ಪು",
  "block.minecraft.banner.cross.red": "ಕೆಂಪು ಉಪ್ಪು",
  "block.minecraft.banner.cross.white": "ಬಿಳಿ ಉಪ್ಪು",
  "block.minecraft.banner.cross.yellow": "ಹಳದಿ ಉಪ್ಪು",
  "block.minecraft.banner.curly_border.black": "ಕಪ್ಪು ಗಡಿ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.curly_border.blue": "ನೀಲಿ ಗಡಿ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.curly_border.brown": "ಬ್ರೌನ್ ಬೋರ್ಡರ್ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.curly_border.cyan": "ಸಯಾನ್ ಬೋರ್ಡರ್ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.curly_border.gray": "ಗ್ರೇ ಬೋರ್ಡರ್ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.curly_border.green": "ಹಸಿರು ಗಡಿ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.curly_border.light_blue": "ತಿಳಿ ನೀಲಿ ಗಡಿ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.curly_border.light_gray": "ತಿಳಿ ಬೂದು ಬೋರ್ಡರ್ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.curly_border.lime": "ಸುಣ್ಣದ ಗಡಿ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.curly_border.magenta": "ಮೆಜೆಂಟಾ ಬೋರ್ಡರ್ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.curly_border.orange": "ಕಿತ್ತಳೆ ಗಡಿ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.curly_border.pink": "ಗುಲಾಬಿ ಗಡಿ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.curly_border.purple": "ಪರ್ಪಲ್ ಬೋರ್ಡರ್ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.curly_border.red": "ಕೆಂಪು ಗಡಿ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.curly_border.white": "ಬಿಳಿ ಗಡಿ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.curly_border.yellow": "ಹಳದಿ ಗಡಿ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.diagonal_left.black": "\nಬ್ಲ್ಯಾಕ್ ಪರ್ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.diagonal_left.blue": "ನೀಲಿ ಪ್ರತಿ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.diagonal_left.brown": "ಬ್ರೌನ್ ಪರ್ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.diagonal_left.cyan": "ಸಯಾನ್ ಪರ್ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.diagonal_left.gray": "ಗ್ರೇ ಪರ್ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.diagonal_left.green": "ಗ್ರೀನ್ ಪರ್ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.diagonal_left.light_blue": "\nತಿಳಿ ನೀಲಿ ಪ್ರತಿ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.diagonal_left.light_gray": "\nಲಘು ಬೂದು ಪ್ರತಿ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.diagonal_left.lime": "ಸುಣ್ಣ ಪ್ರತಿ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.diagonal_left.magenta": "\nಮೆಜೆಂಟಾ ಪರ್ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.diagonal_left.orange": "\nಆರೆಂಜ್ ಪರ್ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.diagonal_left.pink": "ಪಿಂಕ್ ಪರ್ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.diagonal_left.purple": "\nಪರ್ಪಲ್ ಪರ್ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.diagonal_left.red": "\nರೆಡ್ ಪರ್ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.diagonal_left.white": "\nವೈಟ್ ಪರ್ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.diagonal_left.yellow": "\nಹಳದಿ ಪ್ರತಿ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.diagonal_right.black": "\nಕಪ್ಪು ಪ್ರತಿ ಬೆಂಡ್",
  "block.minecraft.banner.diagonal_right.blue": "ಪ್ರತಿ ಬೆಂಡ್‌ಗೆ ನೀಲಿ",
  "block.minecraft.banner.diagonal_right.brown": "\nಪ್ರತಿ ಬೆಂಡ್‌ಗೆ ಬ್ರೌನ್",
  "block.minecraft.banner.diagonal_right.cyan": "\nಸಯಾನ್ ಪರ್ ಬೆಂಡ್",
  "block.minecraft.banner.diagonal_right.gray": "ಗ್ರೇ ಪರ್ ಬೆಂಡ್",
  "block.minecraft.banner.diagonal_right.green": "\nಗ್ರೀನ್ ಪರ್ ಬೆಂಡ್",
  "block.minecraft.banner.diagonal_right.light_blue": "\nತಿಳಿ ನೀಲಿ ಪ್ರತಿ ಬೆಂಡ್",
  "block.minecraft.banner.diagonal_right.light_gray": "ಪ್ರತಿ ಬೆಂಡ್ಗೆ ತಿಳಿ ಬೂದು",
  "block.minecraft.banner.diagonal_right.lime": "\nಪ್ರತಿ ಬೆಂಡ್ಗೆ ಸುಣ್ಣ",
  "block.minecraft.banner.diagonal_right.magenta": "ಮೆಜೆಂಟಾ ಪರ್ ಬೆಂಡ್",
  "block.minecraft.banner.diagonal_right.orange": "\nಆರೆಂಜ್ ಪರ್ ಬೆಂಡ್",
  "block.minecraft.banner.diagonal_right.pink": "\nಪಿಂಕ್ ಪರ್ ಬೆಂಡ್",
  "block.minecraft.banner.diagonal_right.purple": "\nಪರ್ಪಲ್ ಪರ್ ಬೆಂಡ್",
  "block.minecraft.banner.diagonal_right.red": "ರೆಡ್ ಪರ್ ಬೆಂಡ್",
  "block.minecraft.banner.diagonal_right.white": "ವೈಟ್ ಪರ್ ಬೆಂಡ್",
  "block.minecraft.banner.diagonal_right.yellow": "\nಪ್ರತಿ ಬೆಂಡ್ಗೆ ಹಳದಿ",
  "block.minecraft.banner.diagonal_up_left.black": "\nಬ್ಲ್ಯಾಕ್ ಪರ್ ಬೆಂಡ್ ತಲೆಕೆಳಗಾದ",
  "block.minecraft.banner.diagonal_up_left.blue": "\nಬ್ಲೂ ಪರ್ ಬೆಂಡ್ ತಲೆಕೆಳಗಾದ",
  "block.minecraft.banner.diagonal_up_left.brown": "\nಬ್ರೌನ್ ಪರ್ ಬೆಂಡ್ ತಲೆಕೆಳಗಾದ",
  "block.minecraft.banner.diagonal_up_left.cyan": "ಸಯಾನ್ ಪರ್ ಬೆಂಡ್ ತಲೆಕೆಳಗಾದ",
  "block.minecraft.banner.diagonal_up_left.gray": "ಗ್ರೇ ಪರ್ ಬೆಂಡ್ ತಲೆಕೆಳಗಾದ",
  "block.minecraft.banner.diagonal_up_left.green": "ಗ್ರೀನ್ ಪರ್ ಬೆಂಡ್ ತಲೆಕೆಳಗಾದ",
  "block.minecraft.banner.diagonal_up_left.light_blue": "ತಿಳಿ ನೀಲಿ ಪ್ರತಿ ಬೆಂಡ್ ತಲೆಕೆಳಗಾದ",
  "block.minecraft.banner.diagonal_up_left.light_gray": "ಲೈಟ್ ಗ್ರೇ ಪರ್ ಬೆಂಡ್ ತಲೆಕೆಳಗಾದ",
  "block.minecraft.banner.diagonal_up_left.lime": "ಲೈಮ್ ಪರ್ ಬೆಂಡ್ ತಲೆಕೆಳಗಾದ",
  "block.minecraft.banner.diagonal_up_left.magenta": "ಮೆಜೆಂಟಾ ಪರ್ ಬೆಂಡ್ ತಲೆಕೆಳಗಾದ",
  "block.minecraft.banner.diagonal_up_left.orange": "ಆರೆಂಜ್ ಪರ್ ಬೆಂಡ್ ತಲೆಕೆಳಗಾದ",
  "block.minecraft.banner.diagonal_up_left.pink": "ಪಿಂಕ್ ಪರ್ ಬೆಂಡ್ ತಲೆಕೆಳಗಾದ",
  "block.minecraft.banner.diagonal_up_left.purple": "\nಪರ್ಪಲ್ ಪರ್ ಬೆಂಡ್ ತಲೆಕೆಳಗಾದ",
  "block.minecraft.banner.diagonal_up_left.red": "\nರೆಡ್ ಪರ್ ಬೆಂಡ್ ತಲೆಕೆಳಗಾದ",
  "block.minecraft.banner.diagonal_up_left.white": "ವೈಟ್ ಪರ್ ಬೆಂಡ್ ತಲೆಕೆಳಗಾದ",
  "block.minecraft.banner.diagonal_up_left.yellow": "ಹಳದಿ ಪ್ರತಿ ಬೆಂಡ್ ತಲೆಕೆಳಗಾದ",
  "block.minecraft.banner.diagonal_up_right.black": "ಬ್ಲ್ಯಾಕ್ ಪರ್ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ ತಲೆಕೆಳಗಾಗಿದೆ",
  "block.minecraft.banner.diagonal_up_right.blue": "ಬ್ಲೂ ಪರ್ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ ತಲೆಕೆಳಗಾಗಿದೆ",
  "block.minecraft.banner.diagonal_up_right.brown": "ಬ್ರೌನ್ ಪರ್ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ ತಲೆಕೆಳಗಾಗಿದೆ",
  "block.minecraft.banner.diagonal_up_right.cyan": "ಸಯಾನ್ ಪರ್ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ ತಲೆಕೆಳಗಾಗಿದೆ",
  "block.minecraft.banner.diagonal_up_right.gray": "ಗ್ರೇ ಪರ್ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ ತಲೆಕೆಳಗಾಗಿದೆ",
  "block.minecraft.banner.diagonal_up_right.green": "ಗ್ರೀನ್ ಪರ್ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ ತಲೆಕೆಳಗಾಗಿದೆ",
  "block.minecraft.banner.diagonal_up_right.light_blue": "ತಿಳಿ ನೀಲಿ ಪ್ರತಿ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ ತಲೆಕೆಳಗಾಗಿದೆ",
  "block.minecraft.banner.diagonal_up_right.light_gray": "ಲೈಟ್ ಗ್ರೇ ಪರ್ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ ತಲೆಕೆಳಗಾಗಿದೆ",
  "block.minecraft.banner.diagonal_up_right.lime": "ಲೈಮ್ ಪರ್ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ ತಲೆಕೆಳಗಾಗಿದೆ",
  "block.minecraft.banner.diagonal_up_right.magenta": "ಮೆಜೆಂಟಾ ಪರ್ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ ತಲೆಕೆಳಗಾಗಿದೆ",
  "block.minecraft.banner.diagonal_up_right.orange": "ಆರೆಂಜ್ ಪರ್ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ ತಲೆಕೆಳಗಾಗಿದೆ",
  "block.minecraft.banner.diagonal_up_right.pink": "ಪಿಂಕ್ ಪರ್ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ ತಲೆಕೆಳಗಾಗಿದೆ",
  "block.minecraft.banner.diagonal_up_right.purple": "ಪರ್ಪಲ್ ಪರ್ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ ತಲೆಕೆಳಗಾಗಿದೆ",
  "block.minecraft.banner.diagonal_up_right.red": "ರೆಡ್ ಪರ್ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ ತಲೆಕೆಳಗಾಗಿದೆ",
  "block.minecraft.banner.diagonal_up_right.white": "ವೈಟ್ ಪರ್ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ ತಲೆಕೆಳಗಾಗಿದೆ",
  "block.minecraft.banner.diagonal_up_right.yellow": "ಹಳದಿ ಪ್ರತಿ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ ತಲೆಕೆಳಗಾಗಿದೆ",
  "block.minecraft.banner.flow.black": "Black Flow",
  "block.minecraft.banner.flow.blue": "Blue Flow",
  "block.minecraft.banner.flow.brown": "Brown Flow",
  "block.minecraft.banner.flow.cyan": "Cyan Flow",
  "block.minecraft.banner.flow.gray": "Gray Flow",
  "block.minecraft.banner.flow.green": "Green Flow",
  "block.minecraft.banner.flow.light_blue": "Light Blue Flow",
  "block.minecraft.banner.flow.light_gray": "Light Gray Flow",
  "block.minecraft.banner.flow.lime": "Lime Flow",
  "block.minecraft.banner.flow.magenta": "Magenta Flow",
  "block.minecraft.banner.flow.orange": "Orange Flow",
  "block.minecraft.banner.flow.pink": "Pink Flow",
  "block.minecraft.banner.flow.purple": "Purple Flow",
  "block.minecraft.banner.flow.red": "Red Flow",
  "block.minecraft.banner.flow.white": "White Flow",
  "block.minecraft.banner.flow.yellow": "Yellow Flow",
  "block.minecraft.banner.flower.black": "ಕಪ್ಪು ಹೂವು",
  "block.minecraft.banner.flower.blue": "ನೀಲಿ ಹೂವು",
  "block.minecraft.banner.flower.brown": "ಕಂದು ಹೂವು",
  "block.minecraft.banner.flower.cyan": "ಸಯಾನ್ ಹೂ ಶುಲ್ಕ",
  "block.minecraft.banner.flower.gray": "ಬೂದು ಹೂವು",
  "block.minecraft.banner.flower.green": "ಹಸಿರು ಹೂವು",
  "block.minecraft.banner.flower.light_blue": "ತಿಳಿ ನೀಲಿ ಹೂವಿನ ಶುಲ್ಕ",
  "block.minecraft.banner.flower.light_gray": "ತಿಳಿ ಬೂದು ಹೂವಿನ ಶುಲ್ಕ",
  "block.minecraft.banner.flower.lime": "ಸುಣ್ಣದ ಹೂವಿನ ಶುಲ್ಕ",
  "block.minecraft.banner.flower.magenta": "ಕೆನ್ನೇರಳೆ ಹೂವಿನ ಶುಲ್ಕ",
  "block.minecraft.banner.flower.orange": "ಕಿತ್ತಳೆ ಹೂವಿನ ಶುಲ್ಕ",
  "block.minecraft.banner.flower.pink": "ಗುಲಾಬಿ ಹೂವಿನ ಶುಲ್ಕ",
  "block.minecraft.banner.flower.purple": "ನೇರಳೆ ಹೂವಿನ ಶುಲ್ಕ",
  "block.minecraft.banner.flower.red": "ಕೆಂಪು ಹೂವು",
  "block.minecraft.banner.flower.white": "ಬಿಳಿ ಹೂವು",
  "block.minecraft.banner.flower.yellow": "ಹಳದಿ ಹೂವು",
  "block.minecraft.banner.globe.black": "ಕಪ್ಪು ಗ್ಲೋಬ್",
  "block.minecraft.banner.globe.blue": "ಬ್ಲೂ ಗ್ಲೋಬ್",
  "block.minecraft.banner.globe.brown": "ಬ್ರೌನ್ ಗ್ಲೋಬ್",
  "block.minecraft.banner.globe.cyan": "ಸೈನ್ ಗ್ಲೋಬ್",
  "block.minecraft.banner.globe.gray": "ಗ್ರೇ ಗ್ಲೋಬ್",
  "block.minecraft.banner.globe.green": "ಗ್ರೀನ್ ಗ್ಲೋಬ್",
  "block.minecraft.banner.globe.light_blue": "ಲೈಟ್ ಬ್ಲೂ ಗ್ಲೋಬ್",
  "block.minecraft.banner.globe.light_gray": "ಲೈಟ್ ಗ್ರೇ ಗ್ಲೋಬ್",
  "block.minecraft.banner.globe.lime": "ಲೈಮ್ ಗ್ಲೋಬ್",
  "block.minecraft.banner.globe.magenta": "ಮ್ಯಾಜೆಂತಾ ಗ್ಲೋಬ್",
  "block.minecraft.banner.globe.orange": "ಕಿತ್ತಳೆ ಗ್ಲೋಬ್",
  "block.minecraft.banner.globe.pink": "ಪಿಂಕ್ ಗ್ಲೋಬ್",
  "block.minecraft.banner.globe.purple": "ಪರ್ಪಲ್ ಗ್ಲೋಬ್",
  "block.minecraft.banner.globe.red": "ಕೆಂಪು ಗ್ಲೋಬ್",
  "block.minecraft.banner.globe.white": "ವೈಟ್ ಗ್ಲೋಬ್",
  "block.minecraft.banner.globe.yellow": "ಹಳದಿ ಗ್ಲೋಬ್",
  "block.minecraft.banner.gradient.black": "ಕಪ್ಪು ಗ್ರೇಡಿಯಂಟ್",
  "block.minecraft.banner.gradient.blue": "\nನೀಲಿ ಗ್ರೇಡಿಯಂಟ್",
  "block.minecraft.banner.gradient.brown": "ಬ್ರೌನ್ ಗ್ರೇಡಿಯಂಟ್",
  "block.minecraft.banner.gradient.cyan": "ಸಯಾನ್ ಗ್ರೇಡಿಯಂಟ್",
  "block.minecraft.banner.gradient.gray": "ಗ್ರೇ ಗ್ರೇಡಿಯಂಟ್",
  "block.minecraft.banner.gradient.green": "ಹಸಿರು ಗ್ರೇಡಿಯಂಟ್",
  "block.minecraft.banner.gradient.light_blue": "ತಿಳಿ ನೀಲಿ ಗ್ರೇಡಿಯಂಟ್",
  "block.minecraft.banner.gradient.light_gray": "\nತಿಳಿ ಬೂದು ಗ್ರೇಡಿಯಂಟ್",
  "block.minecraft.banner.gradient.lime": "ನಿಂಬೆ ಗ್ರೇಡಿಯಂಟ್",
  "block.minecraft.banner.gradient.magenta": "ಮೆಜೆಂಟಾ ಗ್ರೇಡಿಯಂಟ್",
  "block.minecraft.banner.gradient.orange": "ಕಿತ್ತಳೆ ಗ್ರೇಡಿಯಂಟ್",
  "block.minecraft.banner.gradient.pink": "ಪಿಂಕ್ ಗ್ರೇಡಿಯಂಟ್",
  "block.minecraft.banner.gradient.purple": "ಪರ್ಪಲ್ ಗ್ರೇಡಿಯಂಟ್",
  "block.minecraft.banner.gradient.red": "\nಕೆಂಪು ಗ್ರೇಡಿಯಂಟ್",
  "block.minecraft.banner.gradient.white": "ವೈಟ್ ಗ್ರೇಡಿಯಂಟ್",
  "block.minecraft.banner.gradient.yellow": "\nಹಳದಿ ಗ್ರೇಡಿಯಂಟ್",
  "block.minecraft.banner.gradient_up.black": "\nಬ್ಲ್ಯಾಕ್ ಬೇಸ್ ಗ್ರೇಡಿಯಂಟ್",
  "block.minecraft.banner.gradient_up.blue": "ಬ್ಲೂ ಬೇಸ್ ಗ್ರೇಡಿಯಂಟ್",
  "block.minecraft.banner.gradient_up.brown": "ಬ್ರೌನ್ ಬೇಸ್ ಗ್ರೇಡಿಯಂಟ್",
  "block.minecraft.banner.gradient_up.cyan": "ಸಯಾನ್ ಬೇಸ್ ಗ್ರೇಡಿಯಂಟ್",
  "block.minecraft.banner.gradient_up.gray": "ಗ್ರೇ ಬೇಸ್ ಗ್ರೇಡಿಯಂಟ್",
  "block.minecraft.banner.gradient_up.green": "ಗ್ರೀನ್ ಬೇಸ್ ಗ್ರೇಡಿಯಂಟ್",
  "block.minecraft.banner.gradient_up.light_blue": "ತಿಳಿ ನೀಲಿ ಮೂಲ ಗ್ರೇಡಿಯಂಟ್",
  "block.minecraft.banner.gradient_up.light_gray": "ತಿಳಿ ಗ್ರೇ ಬೇಸ್ ಗ್ರೇಡಿಯಂಟ್",
  "block.minecraft.banner.gradient_up.lime": "ಲೈಮ್ ಬೇಸ್ ಗ್ರೇಡಿಯಂಟ್",
  "block.minecraft.banner.gradient_up.magenta": "ಮೆಜೆಂಟಾ ಬೇಸ್ ಗ್ರೇಡಿಯಂಟ್",
  "block.minecraft.banner.gradient_up.orange": "ಆರೆಂಜ್ ಬೇಸ್ ಗ್ರೇಡಿಯಂಟ್",
  "block.minecraft.banner.gradient_up.pink": "ಪಿಂಕ್ ಬೇಸ್ ಗ್ರೇಡಿಯಂಟ್",
  "block.minecraft.banner.gradient_up.purple": "ಪರ್ಪಲ್ ಬೇಸ್ ಗ್ರೇಡಿಯಂಟ್",
  "block.minecraft.banner.gradient_up.red": "\nರೆಡ್ ಬೇಸ್ ಗ್ರೇಡಿಯಂಟ್",
  "block.minecraft.banner.gradient_up.white": "ವೈಟ್ ಬೇಸ್ ಗ್ರೇಡಿಯಂಟ್",
  "block.minecraft.banner.gradient_up.yellow": "ಹಳದಿ ಮೂಲ ಗ್ರೇಡಿಯಂಟ್",
  "block.minecraft.banner.guster.black": "Black Guster",
  "block.minecraft.banner.guster.blue": "Blue Guster",
  "block.minecraft.banner.guster.brown": "Brown Guster",
  "block.minecraft.banner.guster.cyan": "Cyan Guster",
  "block.minecraft.banner.guster.gray": "Gray Guster",
  "block.minecraft.banner.guster.green": "Green Guster",
  "block.minecraft.banner.guster.light_blue": "Light Blue Guster",
  "block.minecraft.banner.guster.light_gray": "Light Gray Guster",
  "block.minecraft.banner.guster.lime": "Lime Guster",
  "block.minecraft.banner.guster.magenta": "Magenta Guster",
  "block.minecraft.banner.guster.orange": "Orange Guster",
  "block.minecraft.banner.guster.pink": "Pink Guster",
  "block.minecraft.banner.guster.purple": "Purple Guster",
  "block.minecraft.banner.guster.red": "Red Guster",
  "block.minecraft.banner.guster.white": "White Guster",
  "block.minecraft.banner.guster.yellow": "Yellow Guster",
  "block.minecraft.banner.half_horizontal.black": "\nಬ್ಲ್ಯಾಕ್ ಪರ್ ಫೆಸ್",
  "block.minecraft.banner.half_horizontal.blue": "ಫೆಸ್ಗಾಗಿ ನೀಲಿ",
  "block.minecraft.banner.half_horizontal.brown": "\nಫೆಸ್ಗಾಗಿ ಬ್ರೌನ್",
  "block.minecraft.banner.half_horizontal.cyan": "ಸಯಾನ್ ಫಾರ್ ಫೆಸ್",
  "block.minecraft.banner.half_horizontal.gray": "\nಫೆಸ್ಗಾಗಿ ಗ್ರೇ",
  "block.minecraft.banner.half_horizontal.green": "ಗ್ರೀನ್ ಪರ್ ಫೆಸ್",
  "block.minecraft.banner.half_horizontal.light_blue": "ಫೆಸ್ಗಾಗಿ ತಿಳಿ ನೀಲಿ",
  "block.minecraft.banner.half_horizontal.light_gray": "ಫೆಸ್ಗೆ ತಿಳಿ ಬೂದು",
  "block.minecraft.banner.half_horizontal.lime": "\nಫೆಸ್ಗಾಗಿ ಸುಣ್ಣ",
  "block.minecraft.banner.half_horizontal.magenta": "ಮೆಜೆಂಟಾ ಪರ್ ಫೆಸ್",
  "block.minecraft.banner.half_horizontal.orange": "ಆರೆಂಜ್ ಪರ್ ಫೆಸ್",
  "block.minecraft.banner.half_horizontal.pink": "ಫೆಸ್ಗಾಗಿ ಗುಲಾಬಿ",
  "block.minecraft.banner.half_horizontal.purple": "ಪರ್ಪಲ್ ಪರ್ ಫೆಸ್",
  "block.minecraft.banner.half_horizontal.red": "\nರೆಡ್ ಪರ್ ಫೆಸ್",
  "block.minecraft.banner.half_horizontal.white": "ವೈಟ್ ಪರ್ ಫೆಸ್",
  "block.minecraft.banner.half_horizontal.yellow": "ಹಳದಿ ಪ್ರತಿ ಫೆಸ್",
  "block.minecraft.banner.half_horizontal_bottom.black": "ಬ್ಲ್ಯಾಕ್ ಪರ್ ಫೆಸ್ ತಲೆಕೆಳಗಾದ",
  "block.minecraft.banner.half_horizontal_bottom.blue": "ಬ್ಲೂ ಪರ್ ಫೆಸ್ ತಲೆಕೆಳಗಾಗಿದೆ",
  "block.minecraft.banner.half_horizontal_bottom.brown": "ಬ್ರೌನ್ ಪರ್ ಫೆಸ್ ತಲೆಕೆಳಗಾದ",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "\nಸಯಾನ್ ಪರ್ ಫೆಸ್ ತಲೆಕೆಳಗಾದ",
  "block.minecraft.banner.half_horizontal_bottom.gray": "\nಗ್ರೇ ಪರ್ ಫೆಸ್ ತಲೆಕೆಳಗಾದ",
  "block.minecraft.banner.half_horizontal_bottom.green": "\nಗ್ರೀನ್ ಪರ್ ಫೆಸ್ ತಲೆಕೆಳಗಾಗಿದೆ",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "ತಿಳಿ ನೀಲಿ ಪ್ರತಿ ಫೆಸ್ ತಲೆಕೆಳಗಾಗಿದೆ",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "ಪ್ರತಿ ಫೆಸ್ ತಲೆಕೆಳಗಾದ ತಿಳಿ ಬೂದು",
  "block.minecraft.banner.half_horizontal_bottom.lime": "\nಸುಣ್ಣಕ್ಕೆ ಪ್ರತಿ ಫೆಸ್ ತಲೆಕೆಳಗಾಗಿದೆ",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "ಮೆಜೆಂಟಾ ಪರ್ ಫೆಸ್ ತಲೆಕೆಳಗಾದ",
  "block.minecraft.banner.half_horizontal_bottom.orange": "ಆರೆಂಜ್ ಪರ್ ಫೆಸ್ ತಲೆಕೆಳಗಾಗಿದೆ",
  "block.minecraft.banner.half_horizontal_bottom.pink": "ಪಿಂಕ್ ಪರ್ ಫೆಸ್ ತಲೆಕೆಳಗಾಗಿದೆ",
  "block.minecraft.banner.half_horizontal_bottom.purple": "ಪರ್ಪಲ್ ಪರ್ ಫೆಸ್ ತಲೆಕೆಳಗಾಗಿದೆ",
  "block.minecraft.banner.half_horizontal_bottom.red": "\nರೆಡ್ ಪರ್ ಫೆಸ್ ತಲೆಕೆಳಗಾಗಿದೆ",
  "block.minecraft.banner.half_horizontal_bottom.white": "ವೈಟ್ ಪರ್ ಫೆಸ್ ತಲೆಕೆಳಗಾಗಿದೆ",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "\nಹಳದಿ ಪ್ರತಿ ಫೆಸ್ ತಲೆಕೆಳಗಾಗಿದೆ",
  "block.minecraft.banner.half_vertical.black": "ಬ್ಲ್ಯಾಕ್ ಪರ್ ಪೇಲ್",
  "block.minecraft.banner.half_vertical.blue": "ನೀಲಿ ಬಣ್ಣಕ್ಕೆ ನೀಲಿ",
  "block.minecraft.banner.half_vertical.brown": "ಬ್ರೌನ್ ಪರ್ ಪೇಲ್",
  "block.minecraft.banner.half_vertical.cyan": "ಸಯಾನ್ ಪರ್ ಪೇಲ್",
  "block.minecraft.banner.half_vertical.gray": "ಗ್ರೇ ಪರ್ ಪೇಲ್",
  "block.minecraft.banner.half_vertical.green": "ಗ್ರೀನ್ ಪರ್ ಪೇಲ್",
  "block.minecraft.banner.half_vertical.light_blue": "\nತಿಳಿ ನೀಲಿ ಪ್ರತಿ ತೆಳು",
  "block.minecraft.banner.half_vertical.light_gray": "ತಿಳಿ ಬೂದು ಪ್ರತಿ ತೆಳು",
  "block.minecraft.banner.half_vertical.lime": "\nಲೈಮ್ ಪರ್ ಪೇಲ್",
  "block.minecraft.banner.half_vertical.magenta": "ಮೆಜೆಂಟಾ ಪರ್ ಪೇಲ್",
  "block.minecraft.banner.half_vertical.orange": "ಕಿತ್ತಳೆಗಾಗಿ ಕಿತ್ತಳೆ",
  "block.minecraft.banner.half_vertical.pink": "\nಪಿಂಕ್ ಪರ್ ಪೇಲ್",
  "block.minecraft.banner.half_vertical.purple": "ಪರ್ಲ್ ಪರ್ ಪೇಲ್",
  "block.minecraft.banner.half_vertical.red": "ರೆಡ್ ಪರ್ ಪೇಲ್",
  "block.minecraft.banner.half_vertical.white": "\nಮಸುಕಾದ ಬಿಳಿ",
  "block.minecraft.banner.half_vertical.yellow": "ಹಳದಿ ಪ್ರತಿ ತೆಳು",
  "block.minecraft.banner.half_vertical_right.black": "ಬ್ಲ್ಯಾಕ್ ಪರ್ ಪೇಲ್ ತಲೆಕೆಳಗಾದ",
  "block.minecraft.banner.half_vertical_right.blue": "ನೀಲಿ ಬಣ್ಣವು ತಲೆಕೆಳಗಾಗಿದೆ",
  "block.minecraft.banner.half_vertical_right.brown": "ಬ್ರೌನ್ ಪರ್ ಪೇಲ್ ತಲೆಕೆಳಗಾದ",
  "block.minecraft.banner.half_vertical_right.cyan": "ಸಯಾನ್ ಪರ್ ಪೇಲ್ ತಲೆಕೆಳಗಾದ",
  "block.minecraft.banner.half_vertical_right.gray": "\nಗ್ರೇ ಪರ್ ಪೇಲ್ ತಲೆಕೆಳಗಾದ",
  "block.minecraft.banner.half_vertical_right.green": "\nಗ್ರೀನ್ ಪರ್ ಪೇಲ್ ತಲೆಕೆಳಗಾದ",
  "block.minecraft.banner.half_vertical_right.light_blue": "ತಿಳಿ ನೀಲಿ ಪ್ರತಿ ತೆಳು ತಲೆಕೆಳಗಾದ",
  "block.minecraft.banner.half_vertical_right.light_gray": "\nತಿಳಿ ಬೂದು ಪ್ರತಿ ತೆಳು ತಲೆಕೆಳಗಾದ",
  "block.minecraft.banner.half_vertical_right.lime": "ಲೈಮ್ ಪರ್ ಪೇಲ್ ತಲೆಕೆಳಗಾದ",
  "block.minecraft.banner.half_vertical_right.magenta": "\nಮೆಜೆಂಟಾ ಪರ್ ಪೇಲ್ ತಲೆಕೆಳಗಾದ",
  "block.minecraft.banner.half_vertical_right.orange": "\nಕಿತ್ತಳೆ ಪ್ರತಿ ತೆಳು ತಲೆಕೆಳಗಾದ",
  "block.minecraft.banner.half_vertical_right.pink": "ಪಿಂಕ್ ಪರ್ ಪೇಲ್ ತಲೆಕೆಳಗಾದ",
  "block.minecraft.banner.half_vertical_right.purple": "\nಪರ್ಪಲ್ ಪರ್ ಪೇಲ್ ತಲೆಕೆಳಗಾದ",
  "block.minecraft.banner.half_vertical_right.red": "ರೆಡ್ ಪರ್ ಪೇಲ್ ತಲೆಕೆಳಗಾದ",
  "block.minecraft.banner.half_vertical_right.white": "ವೈಟ್ ಪರ್ ಪೇಲ್ ತಲೆಕೆಳಗಾದ",
  "block.minecraft.banner.half_vertical_right.yellow": "ಹಳದಿ ಪ್ರತಿ ತೆಳು ತಲೆಕೆಳಗಾದ",
  "block.minecraft.banner.mojang.black": "ಕಪ್ಪು ವಿಷಯ",
  "block.minecraft.banner.mojang.blue": "ನೀಲಿ ವಿಷಯ",
  "block.minecraft.banner.mojang.brown": "ಕಂದು ವಿಷಯ",
  "block.minecraft.banner.mojang.cyan": "ವೈಡೂರ್ಯದ ವಿಷಯ",
  "block.minecraft.banner.mojang.gray": "ಬೂದು ವಿಷಯ",
  "block.minecraft.banner.mojang.green": "ಹಸಿರು ವಿಷಯ",
  "block.minecraft.banner.mojang.light_blue": "ತಿಳಿ ನೀಲಿ ವಿಷಯ",
  "block.minecraft.banner.mojang.light_gray": "ಲೈಟ್ ಗ್ರೇ ಥಿಂಗ್",
  "block.minecraft.banner.mojang.lime": "ಲೈಮ್ ಥಿಂಗ್",
  "block.minecraft.banner.mojang.magenta": "ಮೆಜೆಂಟಾ ಥಿಂಗ್",
  "block.minecraft.banner.mojang.orange": "ಆರೆಂಜ್ ಥಿಂಗ್",
  "block.minecraft.banner.mojang.pink": "ಲೈಟ್ ಗ್ರೇ ಥಿಂಗ್",
  "block.minecraft.banner.mojang.purple": "ಪರ್ಪಲ್ ಥಿಂಗ್",
  "block.minecraft.banner.mojang.red": "ಕೆಂಪು ವಿಷಯ",
  "block.minecraft.banner.mojang.white": "ಬಿಳಿ ವಿಷಯ",
  "block.minecraft.banner.mojang.yellow": "ಹಳದಿ ವಿಷಯ",
  "block.minecraft.banner.piglin.black": "ಕಪ್ಪು ಸ್ನೂಟ್",
  "block.minecraft.banner.piglin.blue": "ನೀಲಿ ಸ್ನೂಟ್",
  "block.minecraft.banner.piglin.brown": "ಬ್ರೌನ್ ಸ್ನೂಟ್",
  "block.minecraft.banner.piglin.cyan": "ಸಯಾನ್ ಸ್ನೂಟ್",
  "block.minecraft.banner.piglin.gray": "ಗ್ರೇ ಸ್ನೂಟ್",
  "block.minecraft.banner.piglin.green": "ಹಸಿರು ಸ್ನೂಟ್",
  "block.minecraft.banner.piglin.light_blue": "ತಿಳಿ ನೀಲಿ ಸ್ನೂಟ್",
  "block.minecraft.banner.piglin.light_gray": "ತಿಳಿ ಬೂದು ಸ್ನೂಟ್",
  "block.minecraft.banner.piglin.lime": "ನಿಂಬೆ ಸ್ನೂಟ್",
  "block.minecraft.banner.piglin.magenta": "ಮೆಜೆಂಟಾ ಸ್ನೂಟ್",
  "block.minecraft.banner.piglin.orange": "ಕಿತ್ತಳೆ ಸ್ನೂಟ್",
  "block.minecraft.banner.piglin.pink": "ಗುಲಾಬಿ ಸ್ನೂಟ್",
  "block.minecraft.banner.piglin.purple": "ಪರ್ಪಲ್ ಸ್ನೂಟ್",
  "block.minecraft.banner.piglin.red": "ಕೆಂಪು ಸ್ನೂಟ್",
  "block.minecraft.banner.piglin.white": "ಬಿಳಿ ಸ್ನೂಟ್",
  "block.minecraft.banner.piglin.yellow": "ಹಳದಿ ಸ್ನೂಟ್",
  "block.minecraft.banner.rhombus.black": "ಕಪ್ಪು ಲೋಜೆಂಜ್",
  "block.minecraft.banner.rhombus.blue": "ನೀಲಿ ಲೋಜೆಂಜ್",
  "block.minecraft.banner.rhombus.brown": "ಬ್ರೌನ್ ಲೋಜೆಂಜ್",
  "block.minecraft.banner.rhombus.cyan": "ಪರ್ಪಲ್ ಲೋಜೆಂಜ್",
  "block.minecraft.banner.rhombus.gray": "\nಗ್ರೇ ಲೋಜೆಂಜ್",
  "block.minecraft.banner.rhombus.green": "ಹಸಿರು ಲೋ zen ೆಂಜ್",
  "block.minecraft.banner.rhombus.light_blue": "ತಿಳಿ ನೀಲಿ ಬಣ್ಣ",
  "block.minecraft.banner.rhombus.light_gray": "ತಿಳಿ ಬೂದು ಬಣ್ಣ",
  "block.minecraft.banner.rhombus.lime": "ನಿಂಬೆ ಲೋಜೆಂಜ್",
  "block.minecraft.banner.rhombus.magenta": "ಮೆಜೆಂಟಾ ಲೊಜೆಂಜ್",
  "block.minecraft.banner.rhombus.orange": "\nಕಿತ್ತಳೆ ಲೋಜೆಂಜ್",
  "block.minecraft.banner.rhombus.pink": "ಪಿಂಕ್ ಲೋಜೆಂಜ್",
  "block.minecraft.banner.rhombus.purple": "ಪರ್ಪಲ್ ಲೋಜೆಂಜ್",
  "block.minecraft.banner.rhombus.red": "ಕೆಂಪು ಲೋಜೆಂಜ್",
  "block.minecraft.banner.rhombus.white": "ಬಿಳಿ ಲೋ zen ೆಂಜ್",
  "block.minecraft.banner.rhombus.yellow": "ಹಳದಿ ಲೋ zen ೆಂಜ್",
  "block.minecraft.banner.skull.black": "ಕಪ್ಪು ತಲೆಬುರುಡೆ",
  "block.minecraft.banner.skull.blue": "ನೀಲಿ ತಲೆಬುರುಡೆ",
  "block.minecraft.banner.skull.brown": "ಕಂದು ತಲೆಬುರುಡೆ",
  "block.minecraft.banner.skull.cyan": "ಸಯಾನ್ ಸ್ಕಲ್ ಚಾರ್ಜ್",
  "block.minecraft.banner.skull.gray": "ಬೂದು ತಲೆಬುರುಡೆ",
  "block.minecraft.banner.skull.green": "ಹಸಿರು ತಲೆಬುರುಡೆ",
  "block.minecraft.banner.skull.light_blue": "ತಿಳಿ ನೀಲಿ ತಲೆಬುರುಡೆ ಚಾರ್ಜ್",
  "block.minecraft.banner.skull.light_gray": "ತಿಳಿ ಬೂದು ತಲೆಬುರುಡೆ ಚಾರ್ಜ್",
  "block.minecraft.banner.skull.lime": "ಸುಣ್ಣದ ತಲೆಬುರುಡೆ ಚಾರ್ಜ್",
  "block.minecraft.banner.skull.magenta": "ಮೆಜೆಂಟಾ ಸ್ಕಲ್ ಚಾರ್ಜ್",
  "block.minecraft.banner.skull.orange": "ಕಿತ್ತಳೆ ತಲೆಬುರುಡೆ ಚಾರ್ಜ್",
  "block.minecraft.banner.skull.pink": "ಗುಲಾಬಿ ತಲೆಬುರುಡೆ",
  "block.minecraft.banner.skull.purple": "ನೇರಳೆ ತಲೆಬುರುಡೆ ಚಾರ್ಜ್",
  "block.minecraft.banner.skull.red": "ಕೆಂಪು ತಲೆಬುರುಡೆ",
  "block.minecraft.banner.skull.white": "ಬಿಳಿ ತಲೆಬುರುಡೆ",
  "block.minecraft.banner.skull.yellow": "ಹಳದಿ ತಲೆಬುರುಡೆ",
  "block.minecraft.banner.small_stripes.black": "ಕಪ್ಪು ಪಾಲಿ",
  "block.minecraft.banner.small_stripes.blue": "ನೀಲಿ ಪಾಲಿ",
  "block.minecraft.banner.small_stripes.brown": "\nಬ್ರೌನ್ ಪಾಲಿ",
  "block.minecraft.banner.small_stripes.cyan": "\nಸಯಾನ್ ಪಾಲಿ",
  "block.minecraft.banner.small_stripes.gray": "ಗ್ರೇ ಪಾಲಿ",
  "block.minecraft.banner.small_stripes.green": "ಹಸಿರು ಪಾಲಿ",
  "block.minecraft.banner.small_stripes.light_blue": "\nತಿಳಿ ನೀಲಿ ಪಾಲಿ",
  "block.minecraft.banner.small_stripes.light_gray": "ತಿಳಿ ಬೂದು ಪಾಲಿ",
  "block.minecraft.banner.small_stripes.lime": "\nಲೈಮ್ ಪ್ಲೇ",
  "block.minecraft.banner.small_stripes.magenta": "ಮೆಜೆಂಟಾ ಪಾಲಿ",
  "block.minecraft.banner.small_stripes.orange": "ಕಿತ್ತಳೆ ಪಾಲಿ",
  "block.minecraft.banner.small_stripes.pink": "ಪಿಂಕ್ ಪಾಲಿ",
  "block.minecraft.banner.small_stripes.purple": "\nಪರ್ಪಲ್ ಪಾಲಿ",
  "block.minecraft.banner.small_stripes.red": "ಕೆಂಪು ಪಾಲಿ",
  "block.minecraft.banner.small_stripes.white": "ವೈಟ್ ಪಾಲಿ",
  "block.minecraft.banner.small_stripes.yellow": "\nಹಳದಿ ಪ್ಲೇ",
  "block.minecraft.banner.square_bottom_left.black": "ಬ್ಲ್ಯಾಕ್ ಬೇಸ್ ಡೆಕ್ಸ್ಟರ್ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_bottom_left.blue": "ಬ್ಲೂ ಬೇಸ್ ಡೆಕ್ಸ್ಟರ್ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_bottom_left.brown": "ಬ್ರೌನ್ ಬೇಸ್ ಡೆಕ್ಸ್ಟರ್ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_bottom_left.cyan": "ಸಯಾನ್ ಬೇಸ್ ಡೆಕ್ಸ್ಟರ್ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_bottom_left.gray": "\nಗ್ರೇ ಬೇಸ್ ಡೆಕ್ಸ್ಟರ್ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_bottom_left.green": "ಗ್ರೀನ್ ಬೇಸ್ ಡೆಕ್ಸ್ಟರ್ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_bottom_left.light_blue": "ತಿಳಿ ನೀಲಿ ಬೇಸ್ ಡೆಕ್ಸ್ಟರ್ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_bottom_left.light_gray": "ಲೈಟ್ ಗ್ರೇ ಬೇಸ್ ಡೆಕ್ಸ್ಟರ್ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_bottom_left.lime": "\nಲೈಮ್ ಬೇಸ್ ಡೆಕ್ಸ್ಟರ್ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_bottom_left.magenta": "ಮೆಜೆಂಟಾ ಬೇಸ್ ಡೆಕ್ಸ್ಟರ್ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_bottom_left.orange": "\nಆರೆಂಜ್ ಬೇಸ್ ಡೆಕ್ಸ್ಟರ್ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_bottom_left.pink": "\nಪಿಂಕ್ ಬೇಸ್ ಡೆಕ್ಸ್ಟರ್ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_bottom_left.purple": "ಪರ್ಪಲ್ ಬೇಸ್ ಡೆಕ್ಸ್ಟರ್ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_bottom_left.red": "\nರೆಡ್ ಬೇಸ್ ಡೆಕ್ಸ್ಟರ್ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_bottom_left.white": "\nವೈಟ್ ಬೇಸ್ ಡೆಕ್ಸ್ಟರ್ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_bottom_left.yellow": "ಹಳದಿ ಬೇಸ್ ಡೆಕ್ಸ್ಟರ್ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_bottom_right.black": "\nಬ್ಲ್ಯಾಕ್ ಬೇಸ್ ಕೆಟ್ಟದಾಗಿ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_bottom_right.blue": "ಬ್ಲೂ ಬೇಸ್ ಕೆಟ್ಟದಾಗಿ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_bottom_right.brown": "ಬ್ರೌನ್ ಬೇಸ್ ಕೆಟ್ಟದಾಗಿ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_bottom_right.cyan": "\nಸಯಾನ್ ಬೇಸ್ ಕೆಟ್ಟದಾಗಿ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_bottom_right.gray": "ಗ್ರೇ ಬೇಸ್ ಕೆಟ್ಟದಾಗಿ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_bottom_right.green": "\nಗ್ರೀನ್ ಬೇಸ್ ಕೆಟ್ಟದಾಗಿ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_bottom_right.light_blue": "\nತಿಳಿ ನೀಲಿ ಬೇಸ್ ಕೆಟ್ಟದಾಗಿ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_bottom_right.light_gray": "\nಲೈಟ್ ಗ್ರೇ ಬೇಸ್ ಕೆಟ್ಟದಾಗಿ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_bottom_right.lime": "ಲೈಮ್ ಬೇಸ್ ಕೆಟ್ಟದಾಗಿ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_bottom_right.magenta": "ಮೆಜೆಂಟಾ ಬೇಸ್ ಕೆಟ್ಟದಾಗಿ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_bottom_right.orange": "ಆರೆಂಜ್ ಬೇಸ್ ಕೆಟ್ಟದಾಗಿ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_bottom_right.pink": "\nಪಿಂಕ್ ಬೇಸ್ ಕೆಟ್ಟದಾಗಿ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_bottom_right.purple": "ಪರ್ಪಲ್ ಬೇಸ್ ಕೆಟ್ಟದಾಗಿ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_bottom_right.red": "\nರೆಡ್ ಬೇಸ್ ಕೆಟ್ಟದಾಗಿ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_bottom_right.white": "ವೈಟ್ ಬೇಸ್ ಕೆಟ್ಟದಾಗಿ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_bottom_right.yellow": "\nಹಳದಿ ಮೂಲ ಕೆಟ್ಟದಾಗಿ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_top_left.black": "\nಬ್ಲ್ಯಾಕ್ ಚೀಫ್ ಡೆಕ್ಸ್ಟರ್ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_top_left.blue": "ಬ್ಲೂ ಚೀಫ್ ಡೆಕ್ಸ್ಟರ್ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_top_left.brown": "ಬ್ರೌನ್ ಚೀಫ್ ಡೆಕ್ಸ್ಟರ್ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_top_left.cyan": "ಸಯಾನ್ ಚೀಫ್ ಡೆಕ್ಸ್ಟರ್ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_top_left.gray": "\nಗ್ರೇ ಚೀಫ್ ಡೆಕ್ಸ್ಟರ್ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_top_left.green": "\nಗ್ರೀನ್ ಚೀಫ್ ಡೆಕ್ಸ್ಟರ್ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_top_left.light_blue": "ತಿಳಿ ನೀಲಿ ಮುಖ್ಯ ಡೆಕ್ಸ್ಟರ್ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_top_left.light_gray": "ಲೈಟ್ ಗ್ರೇ ಚೀಫ್ ಡೆಕ್ಸ್ಟರ್ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_top_left.lime": "\nಲೈಮ್ ಚೀಫ್ ಡೆಕ್ಸ್ಟರ್ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_top_left.magenta": "ಮೆಜೆಂಟಾ ಚೀಫ್ ಡೆಕ್ಸ್ಟರ್ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_top_left.orange": "\nಆರೆಂಜ್ ಚೀಫ್ ಡೆಕ್ಸ್ಟರ್ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_top_left.pink": "ಪಿಂಕ್ ಚೀಫ್ ಡೆಕ್ಸ್ಟರ್ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_top_left.purple": "ಪರ್ಪಲ್ ಚೀಫ್ ಡೆಕ್ಸ್ಟರ್ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_top_left.red": "ರೆಡ್ ಚೀಫ್ ಡೆಕ್ಸ್ಟರ್ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_top_left.white": "ವೈಟ್ ಚೀಫ್ ಡೆಕ್ಸ್ಟರ್ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_top_left.yellow": "\nಹಳದಿ ಮುಖ್ಯ ಡೆಕ್ಸ್ಟರ್ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_top_right.black": "ಬ್ಲ್ಯಾಕ್ ಚೀಫ್ ಕೆಟ್ಟದಾಗಿ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_top_right.blue": "ಬ್ಲೂ ಚೀಫ್ ಕೆಟ್ಟದಾಗಿ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_top_right.brown": "\nಬ್ರೌನ್ ಚೀಫ್ ಕೆಟ್ಟದಾಗಿ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_top_right.cyan": "ಸಿಯಾನ್ ಮುಖ್ಯ ಕೆಟ್ಟದಾಗಿ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_top_right.gray": "ಗ್ರೇ ಚೀಫ್ ಕೆಟ್ಟದಾಗಿ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_top_right.green": "\nಗ್ರೀನ್ ಚೀಫ್ ಕೆಟ್ಟದಾಗಿ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_top_right.light_blue": "ತಿಳಿ ನೀಲಿ ಮುಖ್ಯ ಕೆಟ್ಟದಾಗಿ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_top_right.light_gray": "ಲೈಟ್ ಗ್ರೇ ಚೀಫ್ ಕೆಟ್ಟದಾಗಿ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_top_right.lime": "ಲೈಮ್ ಚೀಫ್ ಕೆಟ್ಟದಾಗಿ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_top_right.magenta": "\nಮೆಜೆಂಟಾ ಮುಖ್ಯ ಕೆಟ್ಟದಾಗಿ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_top_right.orange": "ಆರೆಂಜ್ ಮುಖ್ಯ ಕೆಟ್ಟದಾಗಿ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_top_right.pink": "ಪಿಂಕ್ ಚೀಫ್ ಕೆಟ್ಟದಾಗಿ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_top_right.purple": "ಪರ್ಪಲ್ ಚೀಫ್ ಕೆಟ್ಟದಾಗಿ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_top_right.red": "\nರೆಡ್ ಚೀಫ್ ಕೆಟ್ಟದಾಗಿ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_top_right.white": "\nವೈಟ್ ಚೀಫ್ ಕೆಟ್ಟದಾಗಿ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.square_top_right.yellow": "\nಹಳದಿ ಮುಖ್ಯ ಕೆಟ್ಟದಾಗಿ ಕ್ಯಾಂಟನ್",
  "block.minecraft.banner.straight_cross.black": "ಕಪ್ಪು ಶಿಲುಬೆ",
  "block.minecraft.banner.straight_cross.blue": "ನೀಲಿ ಶಿಲುಬೆ",
  "block.minecraft.banner.straight_cross.brown": "ಬ್ರೌನ್ ಶಿಲುಬೆ",
  "block.minecraft.banner.straight_cross.cyan": "ವೈಡೂರ್ಯ ಶಿಲುಬೆ",
  "block.minecraft.banner.straight_cross.gray": "ಬೂದು ಶಿಲುಬೆ",
  "block.minecraft.banner.straight_cross.green": "ಹಸಿರು ಶಿಲುಬೆ",
  "block.minecraft.banner.straight_cross.light_blue": "ತಿಳಿ ನೀಲಿ ಕ್ರಾಸ್",
  "block.minecraft.banner.straight_cross.light_gray": "ಲೈಟ್ ಗ್ರೇ ಕ್ರಾಸ್",
  "block.minecraft.banner.straight_cross.lime": "ಲೈಮ್ ಕ್ರಾಸ್",
  "block.minecraft.banner.straight_cross.magenta": "ಮೆಜೆಂಟಾ ಕ್ರಾಸ್",
  "block.minecraft.banner.straight_cross.orange": "ಆರೆಂಜ್ ಕ್ರಾಸ್",
  "block.minecraft.banner.straight_cross.pink": "ಗುಲಾಬಿ ಶಿಲುಬೆ",
  "block.minecraft.banner.straight_cross.purple": "ಪರ್ಪಲ್ ಶಿಲುಬೆ",
  "block.minecraft.banner.straight_cross.red": "ಕೆಂಪು ಶಿಲುಬೆ",
  "block.minecraft.banner.straight_cross.white": "\nವೈಟ್ ಕ್ರಾಸ್",
  "block.minecraft.banner.straight_cross.yellow": "ಹಳದಿ ಶಿಲುಬೆ",
  "block.minecraft.banner.stripe_bottom.black": "ಕಪ್ಪು ನೆಲೆ",
  "block.minecraft.banner.stripe_bottom.blue": "ನೀಲಿ ನೆಲೆ",
  "block.minecraft.banner.stripe_bottom.brown": "ಬ್ರೌನ್ ಬೇಸ್",
  "block.minecraft.banner.stripe_bottom.cyan": "ಸಯಾನ್ ಬೇಸ್",
  "block.minecraft.banner.stripe_bottom.gray": "ಗ್ರೇ ಬೇಸ್",
  "block.minecraft.banner.stripe_bottom.green": "\nಗ್ರೀನ್ ಬೇಸ್",
  "block.minecraft.banner.stripe_bottom.light_blue": "ತಿಳಿ ನೀಲಿ ಬೇಸ್",
  "block.minecraft.banner.stripe_bottom.light_gray": "ತಿಳಿ ಬೂದು ಬೇಸ್",
  "block.minecraft.banner.stripe_bottom.lime": "ನಿಂಬೆ ಬೇಸ್",
  "block.minecraft.banner.stripe_bottom.magenta": "ಮೆಜೆಂಟಾ ಬೇಸ್",
  "block.minecraft.banner.stripe_bottom.orange": "ಕಿತ್ತಳೆ ಬೇಸ್",
  "block.minecraft.banner.stripe_bottom.pink": "ಪಿಂಕ್ ಬೇಸ್",
  "block.minecraft.banner.stripe_bottom.purple": "ಪರ್ಪಲ್ ಬೇಸ್",
  "block.minecraft.banner.stripe_bottom.red": "ರೆಡ್ ಬೇಸ್",
  "block.minecraft.banner.stripe_bottom.white": "ವೈಟ್ ಬೇಸ್",
  "block.minecraft.banner.stripe_bottom.yellow": "ಹಳದಿ ಬೇಸ್",
  "block.minecraft.banner.stripe_center.black": "ಕಪ್ಪು ಮಸುಕಾದ",
  "block.minecraft.banner.stripe_center.blue": "ನೀಲಿ ಮಸುಕಾದ",
  "block.minecraft.banner.stripe_center.brown": "ಬ್ರೌನ್ ಪೇಲ್",
  "block.minecraft.banner.stripe_center.cyan": "ಸಯಾನ್ ಪೇಲ್",
  "block.minecraft.banner.stripe_center.gray": "\nಗ್ರೇ ಪೇಲ್",
  "block.minecraft.banner.stripe_center.green": "ಹಸಿರು ಮಸುಕಾದ",
  "block.minecraft.banner.stripe_center.light_blue": "\nತಿಳಿ ನೀಲಿ ತೆಳು",
  "block.minecraft.banner.stripe_center.light_gray": "ತಿಳಿ ಬೂದು ತೆಳು",
  "block.minecraft.banner.stripe_center.lime": "\nನಿಂಬೆ ತೆಳು",
  "block.minecraft.banner.stripe_center.magenta": "ಮೆಜೆಂಟಾ ಪೇಲ್",
  "block.minecraft.banner.stripe_center.orange": "\nಕಿತ್ತಳೆ ತಿಳಿ",
  "block.minecraft.banner.stripe_center.pink": "ಗುಲಾಬಿ ತೆಳು",
  "block.minecraft.banner.stripe_center.purple": "ನೇರಳೆ ತೆಳು",
  "block.minecraft.banner.stripe_center.red": "\nಕೆಂಪು ಮಸುಕಾದ",
  "block.minecraft.banner.stripe_center.white": "ಬಿಳಿ ತೆಳು",
  "block.minecraft.banner.stripe_center.yellow": "ಹಳದಿ ತೆಳು",
  "block.minecraft.banner.stripe_downleft.black": "ಕಪ್ಪು ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.stripe_downleft.blue": "ನೀಲಿ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.stripe_downleft.brown": "\nಬ್ರೌನ್ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.stripe_downleft.cyan": "\nಸಯಾನ್ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.stripe_downleft.gray": "ಗ್ರೇ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.stripe_downleft.green": "ಗ್ರೀನ್ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.stripe_downleft.light_blue": "\nತಿಳಿ ನೀಲಿ ಬೆಂಡ್ ಕೆಟ್ಟದು",
  "block.minecraft.banner.stripe_downleft.light_gray": "ತಿಳಿ ಬೂದು ಬೆಂಡ್ ಕೆಟ್ಟದು",
  "block.minecraft.banner.stripe_downleft.lime": "ಲೈಮ್ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.stripe_downleft.magenta": "\nಮೆಜೆಂಟಾ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.stripe_downleft.orange": "ಕಿತ್ತಳೆ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.stripe_downleft.pink": "\nಪಿಂಕ್ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.stripe_downleft.purple": "ಪರ್ಪಲ್ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.stripe_downleft.red": "ರೆಡ್ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.stripe_downleft.white": "ವೈಟ್ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.stripe_downleft.yellow": "ಹಳದಿ ಬೆಂಡ್ ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.stripe_downright.black": "\nಕಪ್ಪು ಬೆಂಡ್",
  "block.minecraft.banner.stripe_downright.blue": "\nನೀಲಿ ಬೆಂಡ್",
  "block.minecraft.banner.stripe_downright.brown": "ಬ್ರೌನ್ ಬೆಂಡ್",
  "block.minecraft.banner.stripe_downright.cyan": "\nಸಯಾನ್ ಬೆಂಡ್",
  "block.minecraft.banner.stripe_downright.gray": "ಗ್ರೇ ಬೆಂಡ್",
  "block.minecraft.banner.stripe_downright.green": "ಹಸಿರು ಬೆಂಡ್",
  "block.minecraft.banner.stripe_downright.light_blue": "ತಿಳಿ ನೀಲಿ ಬೆಂಡ್",
  "block.minecraft.banner.stripe_downright.light_gray": "ತಿಳಿ ಬೂದು ಬೆಂಡ್",
  "block.minecraft.banner.stripe_downright.lime": "ನಿಂಬೆ ಬೆಂಡ್",
  "block.minecraft.banner.stripe_downright.magenta": "ಮೆಜೆಂಟಾ ಬೆಂಡ್",
  "block.minecraft.banner.stripe_downright.orange": "\nಕಿತ್ತಳೆ ಬೆಂಡ್",
  "block.minecraft.banner.stripe_downright.pink": "ಪಿಂಕ್ ಬೆಂಡ್",
  "block.minecraft.banner.stripe_downright.purple": "ಪರ್ಪಲ್ ಬೆಂಡ್\n",
  "block.minecraft.banner.stripe_downright.red": "ಕೆಂಪು ಬೆಂಡ್",
  "block.minecraft.banner.stripe_downright.white": "\nವೈಟ್ ಬೆಂಡ್",
  "block.minecraft.banner.stripe_downright.yellow": "ಹಳದಿ ಬೆಂಡ್",
  "block.minecraft.banner.stripe_left.black": "ಕಪ್ಪು ಮಸುಕಾದ ಡೆಕ್ಸ್ಟರ್",
  "block.minecraft.banner.stripe_left.blue": "ನೀಲಿ ಮಸುಕಾದ ಡೆಕ್ಸ್ಟರ್",
  "block.minecraft.banner.stripe_left.brown": "ಬ್ರೌನ್ ಪೇಲ್ ಡೆಕ್ಸ್ಟರ್",
  "block.minecraft.banner.stripe_left.cyan": "\nಸಯಾನ್ ಪೇಲ್ ಡೆಕ್ಸ್ಟರ್",
  "block.minecraft.banner.stripe_left.gray": "\nಗ್ರೇ ಪೇಲ್ ಡೆಕ್ಸ್ಟರ್",
  "block.minecraft.banner.stripe_left.green": "ಹಸಿರು ಪೇಲ್ ಡೆಕ್ಸ್ಟರ್",
  "block.minecraft.banner.stripe_left.light_blue": "\nತಿಳಿ ನೀಲಿ ತೆಳು ಡೆಕ್ಸ್ಟರ್",
  "block.minecraft.banner.stripe_left.light_gray": "ತಿಳಿ ಬೂದು ತೆಳು ಡೆಕ್ಸ್ಟರ್",
  "block.minecraft.banner.stripe_left.lime": "ನಿಂಬೆ ಪೇಲ್ ಡೆಕ್ಸ್ಟರ್",
  "block.minecraft.banner.stripe_left.magenta": "ಮೆಜೆಂಟಾ ಪೇಲ್ ಡೆಕ್ಸ್ಟರ್",
  "block.minecraft.banner.stripe_left.orange": "ಕಿತ್ತಳೆ ಪೇಲ್ ಡೆಕ್ಸ್ಟರ್",
  "block.minecraft.banner.stripe_left.pink": "\nಪಿಂಕ್ ಪೇಲ್ ಡೆಕ್ಸ್ಟರ್",
  "block.minecraft.banner.stripe_left.purple": "ಪರ್ಪಲ್ ಪೇಲ್ ಡೆಕ್ಸ್ಟರ್",
  "block.minecraft.banner.stripe_left.red": "\nಕೆಂಪು ತೆಳು ಡೆಕ್ಸ್ಟರ್",
  "block.minecraft.banner.stripe_left.white": "\nಬಿಳಿ ತೆಳು ಡೆಕ್ಸ್ಟರ್",
  "block.minecraft.banner.stripe_left.yellow": "ಹಳದಿ ತೆಳು ಡೆಕ್ಸ್ಟರ್",
  "block.minecraft.banner.stripe_middle.black": "ಕಪ್ಪು ಫೆಸ್",
  "block.minecraft.banner.stripe_middle.blue": "\nನೀಲಿ ಫೆಸ್",
  "block.minecraft.banner.stripe_middle.brown": "\nಬ್ರೌನ್ ಫೆಸ್",
  "block.minecraft.banner.stripe_middle.cyan": "\nಸಯಾನ್ ಫೆಸ್",
  "block.minecraft.banner.stripe_middle.gray": "ಗ್ರೇ ಫೆಸ್",
  "block.minecraft.banner.stripe_middle.green": "ಹಸಿರು ಶುಲ್ಕ",
  "block.minecraft.banner.stripe_middle.light_blue": "ತಿಳಿ ನೀಲಿ ಫೆಸ್",
  "block.minecraft.banner.stripe_middle.light_gray": "\nತಿಳಿ ಬೂದು ಫೆಸ್",
  "block.minecraft.banner.stripe_middle.lime": "ನಿಂಬೆ ಫೆಸ್",
  "block.minecraft.banner.stripe_middle.magenta": "ಮೆಜೆಂಟಾ ಫೆಸ್",
  "block.minecraft.banner.stripe_middle.orange": "\nಕಿತ್ತಳೆ ಫೆಸ್",
  "block.minecraft.banner.stripe_middle.pink": "ಪಿಂಕ್ ಫೆಸ್",
  "block.minecraft.banner.stripe_middle.purple": "\nಪರ್ಪಲ್ ಫೆಸ್",
  "block.minecraft.banner.stripe_middle.red": "\nಕೆಂಪು ಫೆಸ್",
  "block.minecraft.banner.stripe_middle.white": "\nವೈಟ್ ಫೆಸ್",
  "block.minecraft.banner.stripe_middle.yellow": "\nಹಳದಿ ಫೆಸ್",
  "block.minecraft.banner.stripe_right.black": "ಕಪ್ಪು ತೆಳು ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.stripe_right.blue": "\nನೀಲಿ ಮಸುಕಾದ ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.stripe_right.brown": "ಬ್ರೌನ್ ಪೇಲ್ ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.stripe_right.cyan": "\nಸಯಾನ್ ಪೇಲ್ ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.stripe_right.gray": "ಗ್ರೇ ಪೇಲ್ ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.stripe_right.green": "ಹಸಿರು ತೆಳು ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.stripe_right.light_blue": "ತಿಳಿ ನೀಲಿ ತೆಳು ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.stripe_right.light_gray": "ತಿಳಿ ಬೂದು ತೆಳು ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.stripe_right.lime": "ಸುಣ್ಣದ ತೆಳು ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.stripe_right.magenta": "ಕೆನ್ನೇರಳೆ ತೆಳು ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.stripe_right.orange": "ಕಿತ್ತಳೆ ತೆಳು ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.stripe_right.pink": "\nಗುಲಾಬಿ ತೆಳು ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.stripe_right.purple": "\nನೇರಳೆ ತೆಳು ಕೆಟ್ಟದಾಗಿ\n",
  "block.minecraft.banner.stripe_right.red": "ಕೆಂಪು ತೆಳು ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.stripe_right.white": "ಬಿಳಿ ತೆಳು ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.stripe_right.yellow": "ಹಳದಿ ತೆಳು ಕೆಟ್ಟದಾಗಿ",
  "block.minecraft.banner.stripe_top.black": "\nಕಪ್ಪು ಮುಖ್ಯಸ್ಥ",
  "block.minecraft.banner.stripe_top.blue": "\nಬ್ಲೂ ಚೀಫ್",
  "block.minecraft.banner.stripe_top.brown": "\nಬ್ರೌನ್ ಚೀಫ್",
  "block.minecraft.banner.stripe_top.cyan": "\nಸಯಾನ್ ಮುಖ್ಯಸ್ಥ",
  "block.minecraft.banner.stripe_top.gray": "ಗ್ರೇ ಚೀಫ್",
  "block.minecraft.banner.stripe_top.green": "\nಗ್ರೀನ್ ಚೀಫ್",
  "block.minecraft.banner.stripe_top.light_blue": "ತಿಳಿ ನೀಲಿ ಮುಖ್ಯಸ್ಥ",
  "block.minecraft.banner.stripe_top.light_gray": "ಲೈಟ್ ಗ್ರೇ ಚೀಫ್",
  "block.minecraft.banner.stripe_top.lime": "ನಿಂಬೆ ಮುಖ್ಯಸ್ಥ",
  "block.minecraft.banner.stripe_top.magenta": "ಮೆಜೆಂಟಾ ಮುಖ್ಯಸ್ಥ",
  "block.minecraft.banner.stripe_top.orange": "ಆರೆಂಜ್ ಚೀಫ್",
  "block.minecraft.banner.stripe_top.pink": "ಪಿಂಕ್ ಚೀಫ್",
  "block.minecraft.banner.stripe_top.purple": "\nಪರ್ಪಲ್ ಚೀಫ್",
  "block.minecraft.banner.stripe_top.red": "ರೆಡ್ ಚೀಫ್",
  "block.minecraft.banner.stripe_top.white": "\nವೈಟ್ ಚೀಫ್",
  "block.minecraft.banner.stripe_top.yellow": "ಹಳದಿ ಮುಖ್ಯಸ್ಥ",
  "block.minecraft.banner.triangle_bottom.black": "\nಕಪ್ಪು ಚೆವ್ರಾನ್",
  "block.minecraft.banner.triangle_bottom.blue": "ನೀಲಿ ಚೆವ್ರಾನ್",
  "block.minecraft.banner.triangle_bottom.brown": "\nಬ್ರೌನ್ ಚೆವ್ರಾನ್",
  "block.minecraft.banner.triangle_bottom.cyan": "ಸಯಾನ್ ಚೆವ್ರಾನ್",
  "block.minecraft.banner.triangle_bottom.gray": "ಗ್ರೇ ಚೆವ್ರಾನ್",
  "block.minecraft.banner.triangle_bottom.green": "ಹಸಿರು ಚೆವ್ರಾನ್",
  "block.minecraft.banner.triangle_bottom.light_blue": "ತಿಳಿ ನೀಲಿ ಚೆವ್ರಾನ್",
  "block.minecraft.banner.triangle_bottom.light_gray": "ತಿಳಿ ಬೂದು ಚೆವ್ರಾನ್",
  "block.minecraft.banner.triangle_bottom.lime": "\nನಿಂಬೆ ಚೆವ್ರಾನ್",
  "block.minecraft.banner.triangle_bottom.magenta": "ಮೆಜೆಂಟಾ ಚೆವ್ರಾನ್",
  "block.minecraft.banner.triangle_bottom.orange": "ಕಿತ್ತಳೆ ಚೆವ್ರಾನ್",
  "block.minecraft.banner.triangle_bottom.pink": "\nಗುಲಾಬಿ ಚೆವ್ರಾನ್",
  "block.minecraft.banner.triangle_bottom.purple": "ಪರ್ಪಲ್ ಚೆವ್ರಾನ್",
  "block.minecraft.banner.triangle_bottom.red": "ಕೆಂಪು ಚೆವ್ರಾನ್",
  "block.minecraft.banner.triangle_bottom.white": "\nಬಿಳಿ ಚೆವ್ರಾನ್",
  "block.minecraft.banner.triangle_bottom.yellow": "ಹಳದಿ ಚೆವ್ರಾನ್",
  "block.minecraft.banner.triangle_top.black": "\nಕಪ್ಪು ತಲೆಕೆಳಗಾದ ಚೆವ್ರಾನ್",
  "block.minecraft.banner.triangle_top.blue": "ನೀಲಿ ತಲೆಕೆಳಗಾದ ಚೆವ್ರಾನ್",
  "block.minecraft.banner.triangle_top.brown": "\nಬ್ರೌನ್ ತಲೆಕೆಳಗಾದ ಚೆವ್ರಾನ್",
  "block.minecraft.banner.triangle_top.cyan": "ಸಯಾನ್ ತಲೆಕೆಳಗಾದ ಚೆವ್ರಾನ್",
  "block.minecraft.banner.triangle_top.gray": "ಗ್ರೇ ತಲೆಕೆಳಗಾದ ಚೆವ್ರಾನ್",
  "block.minecraft.banner.triangle_top.green": "\nಹಸಿರು ತಲೆಕೆಳಗಾದ ಚೆವ್ರಾನ್",
  "block.minecraft.banner.triangle_top.light_blue": "\nತಿಳಿ ನೀಲಿ ತಲೆಕೆಳಗಾದ ಚೆವ್ರಾನ್",
  "block.minecraft.banner.triangle_top.light_gray": "\nತಿಳಿ ಬೂದು ತಲೆಕೆಳಗಾದ ಚೆವ್ರಾನ್",
  "block.minecraft.banner.triangle_top.lime": "ನಿಂಬೆ ತಲೆಕೆಳಗಾದ ಚೆವ್ರಾನ್",
  "block.minecraft.banner.triangle_top.magenta": "\nಮೆಜೆಂಟಾ ತಲೆಕೆಳಗಾದ ಚೆವ್ರಾನ್",
  "block.minecraft.banner.triangle_top.orange": "ಕಿತ್ತಳೆ ತಲೆಕೆಳಗಾದ ಚೆವ್ರಾನ್",
  "block.minecraft.banner.triangle_top.pink": "ಗುಲಾಬಿ ತಲೆಕೆಳಗಾದ ಚೆವ್ರಾನ್",
  "block.minecraft.banner.triangle_top.purple": "\nನೇರಳೆ ತಲೆಕೆಳಗಾದ ಚೆವ್ರಾನ್",
  "block.minecraft.banner.triangle_top.red": "\nಕೆಂಪು ತಲೆಕೆಳಗಾದ ಚೆವ್ರಾನ್",
  "block.minecraft.banner.triangle_top.white": "\nಬಿಳಿ ತಲೆಕೆಳಗಾದ ಚೆವ್ರಾನ್",
  "block.minecraft.banner.triangle_top.yellow": "ಹಳದಿ ತಲೆಕೆಳಗಾದ ಚೆವ್ರಾನ್",
  "block.minecraft.banner.triangles_bottom.black": "ಬ್ಲ್ಯಾಕ್ ಬೇಸ್ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.triangles_bottom.blue": "\nಬ್ಲೂ ಬೇಸ್ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.triangles_bottom.brown": "ಬ್ರೌನ್ ಬೇಸ್ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.triangles_bottom.cyan": "ಸಯಾನ್ ಬೇಸ್ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.triangles_bottom.gray": "ಗ್ರೇ ಬೇಸ್ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.triangles_bottom.green": "\nಗ್ರೀನ್ ಬೇಸ್ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.triangles_bottom.light_blue": "\nಹಳದಿ ಬೇಸ್ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.triangles_bottom.light_gray": "\nತಿಳಿ ಬೂದು ಬೇಸ್ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.triangles_bottom.lime": "\nಲೈಮ್ ಬೇಸ್ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.triangles_bottom.magenta": "ಮೆಜೆಂಟಾ ಬೇಸ್ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.triangles_bottom.orange": "ಆರೆಂಜ್ ಬೇಸ್ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.triangles_bottom.pink": "\nಪಿಂಕ್ ಬೇಸ್ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.triangles_bottom.purple": "ಪರ್ಪಲ್ ಬೇಸ್ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.triangles_bottom.red": "ರೆಡ್ ಬೇಸ್ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.triangles_bottom.white": "\nವೈಟ್ ಬೇಸ್ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.triangles_bottom.yellow": "\nಹಳದಿ ಬೇಸ್ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.triangles_top.black": "\nಬ್ಲ್ಯಾಕ್ ಚೀಫ್ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.triangles_top.blue": "\nಬ್ಲೂ ಚೀಫ್ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.triangles_top.brown": "ಬ್ರೌನ್ ಚೀಫ್ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.triangles_top.cyan": "ಸಿಯಾನ್ ಚೀಫ್ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.triangles_top.gray": "ಗ್ರೇ ಚೀಫ್ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.triangles_top.green": "\nಗ್ರೀನ್ ಚೀಫ್ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.triangles_top.light_blue": "\nತಿಳಿ ನೀಲಿ ಮುಖ್ಯ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.triangles_top.light_gray": "\nಲೈಟ್ ಗ್ರೇ ಚೀಫ್ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.triangles_top.lime": "ಲೈಮ್ ಚೀಫ್ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.triangles_top.magenta": "\nಮೆಜೆಂಟಾ ಚೀಫ್ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.triangles_top.orange": "\nಆರೆಂಜ್ ಚೀಫ್ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.triangles_top.pink": "\nಪಿಂಕ್ ಚೀಫ್ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.triangles_top.purple": "\nಪರ್ಪಲ್ ಚೀಫ್ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.triangles_top.red": "ರೆಡ್ ಚೀಫ್ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.triangles_top.white": "\nವೈಟ್ ಚೀಫ್ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.banner.triangles_top.yellow": "ಹಳದಿ ಮುಖ್ಯ ಇಂಡೆಂಟ್ ಮಾಡಲಾಗಿದೆ",
  "block.minecraft.barrel": "ಬ್ಯಾರೆಲ್",
  "block.minecraft.barrier": "ತಡೆಗೋಡೆ",
  "block.minecraft.basalt": "ಬಸಾಲ್ಟ್",
  "block.minecraft.beacon": "ಬೀಕನ್",
  "block.minecraft.beacon.primary": "ಪ್ರಾಥಮಿಕ ಶಕ್ತಿ",
  "block.minecraft.beacon.secondary": "ಮಾಧ್ಯಮಿಕ ಶಕ್ತಿ",
  "block.minecraft.bed.no_sleep": "ನೀವು ರಾತ್ರಿಯಲ್ಲಿ ಅಥವಾ ಗುಡುಗು ಸಹಿತ ಮಲಗಬಹುದು",
  "block.minecraft.bed.not_safe": "ನೀವು ಈಗ ವಿಶ್ರಾಂತಿ ಪಡೆಯದಿರಬಹುದು; ಹತ್ತಿರದಲ್ಲಿ ರಾಕ್ಷಸರಿದ್ದಾರೆ",
  "block.minecraft.bed.obstructed": "ಈ ಹಾಸಿಗೆ ತಡೆಯೊಡ್ಡುತ್ತದೆ",
  "block.minecraft.bed.occupied": "ಈ ಹಾಸಿಗೆ ತಡೆಯೊಡ್ಡುತ್ತದೆ",
  "block.minecraft.bed.too_far_away": "ನೀವು ಈಗ ವಿಶ್ರಾಂತಿ ಪಡೆಯದಿರಬಹುದು; ಹಾಸಿಗೆ ತುಂಬಾ ದೂರದಲ್ಲಿದೆ",
  "block.minecraft.bedrock": "ಕಲ್ಲುಹಾಸನ್ನು",
  "block.minecraft.bee_nest": "ಜೇನುನೊಣ ಗೂಡು",
  "block.minecraft.beehive": "ಬೀಹೈವ್",
  "block.minecraft.beetroots": "\nಬೀಟ್‌ರೂಟ್‌ಗಳು",
  "block.minecraft.bell": "ಗಂಟೆ",
  "block.minecraft.big_dripleaf": "ದೊಡ್ಡ ಚುಟುಕು ಎಲೆ",
  "block.minecraft.big_dripleaf_stem": "ದೊಡ್ಡ ಡ್ರಿಪ್ಲೀಫ್ ಕಾಂಡ",
  "block.minecraft.birch_button": "ಬರ್ಚ್ ಬಟನ್",
  "block.minecraft.birch_door": "ಬರ್ಚ್ ಬಾಗಿಲು",
  "block.minecraft.birch_fence": "ಬಿರ್ಚ್ ಬೇಲಿ",
  "block.minecraft.birch_fence_gate": "\nಬಿರ್ಚ್ ಬೇಲಿ ಗೇಟ್",
  "block.minecraft.birch_hanging_sign": "ಬರ್ಚ್ ಹ್ಯಾಂಗಿಂಗ್ ಚಿಹ್ನೆ",
  "block.minecraft.birch_leaves": "ಬಿರ್ಚ್ ಎಲೆಗಳು",
  "block.minecraft.birch_log": "ಬಿರ್ಚ್ ಲಾಗ್",
  "block.minecraft.birch_planks": "ಬರ್ಚ್ ಹಲಗೆಗಳು",
  "block.minecraft.birch_pressure_plate": "ಬಿರ್ಚ್ ಪ್ರೆಶರ್ ಪ್ಲೇಟ್",
  "block.minecraft.birch_sapling": "ಬರ್ಚ್ ಸಸಿ",
  "block.minecraft.birch_shelf": "Birch Shelf",
  "block.minecraft.birch_sign": "ಬಿರ್ಚ್ ಸೈನ್",
  "block.minecraft.birch_slab": "ಬಿರ್ಚ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.birch_stairs": "ಬರ್ಚ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.birch_trapdoor": "ಬಿರ್ಚ್ ಟ್ರ್ಯಾಪ್ಡೋರ್",
  "block.minecraft.birch_wall_hanging_sign": "ಬಿರ್ಚ್ ವಾಲ್ ಹ್ಯಾಂಗಿಂಗ್ ಚಿಹ್ನೆ",
  "block.minecraft.birch_wall_sign": "ಬಿರ್ಚ್ ವಾಲ್ ಚಿಹ್ನೆ",
  "block.minecraft.birch_wood": "ಬರ್ಚ್ ಕಟ್ಟಿಗೆ",
  "block.minecraft.black_banner": "ಕಪ್ಪು ಬ್ಯಾನರ್",
  "block.minecraft.black_bed": "ಕಪ್ಪು ಹಾಸಿಗೆ",
  "block.minecraft.black_candle": "ಕಪ್ಪು ಕ್ಯಾಂಡಲ್",
  "block.minecraft.black_candle_cake": "ಕಪ್ಪು ಕ್ಯಾಂಡಲ್ನೊಂದಿಗೆ ಕೇಕ್",
  "block.minecraft.black_carpet": "ಕಪ್ಪು ಕಾರ್ಪೆಟ್",
  "block.minecraft.black_concrete": "ಕಪ್ಪು ಕಾಂಕ್ರೀಟ್",
  "block.minecraft.black_concrete_powder": "ಕಪ್ಪು ಕಾಂಕ್ರೀಟ್ ಪುಡಿ",
  "block.minecraft.black_glazed_terracotta": "ಕಪ್ಪು ಮೆರುಗಿನ ಟೆರಾಕೋಟಾ",
  "block.minecraft.black_shulker_box": "ಕಪ್ಪು ಶಲ್ಕರ್ ಬಾಕ್ಸ್",
  "block.minecraft.black_stained_glass": "ಕಪ್ಪು ಬಣ್ಣದ ಗಾಜು",
  "block.minecraft.black_stained_glass_pane": "ಕಪ್ಪು ಬಣ್ಣದ ಗಾಜಿನ ಫಲಕ",
  "block.minecraft.black_terracotta": "ಕಪ್ಪು ಟೆರಾಕೋಟಾ",
  "block.minecraft.black_wool": "ಕಪ್ಪು ಉಣ್ಣೆ",
  "block.minecraft.blackstone": "ಕಪ್ಪು ಕಲ್ಲಿನ",
  "block.minecraft.blackstone_slab": "ಬ್ಲಾಕ್‌ಸ್ಟೋನ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.blackstone_stairs": "ಬ್ಲಾಕ್‌ಸ್ಟೋನ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.blackstone_wall": "ಬ್ಲಾಕ್ಸ್ಟೋನ್ ವಾಲ್",
  "block.minecraft.blast_furnace": "ಬ್ಲಾಸ್ಟ್ ಫರ್ನೇಸ್",
  "block.minecraft.blue_banner": "ನೀಲಿ ಬ್ಯಾನರ್",
  "block.minecraft.blue_bed": "ನೀಲಿ ಹಾಸಿಗೆ",
  "block.minecraft.blue_candle": "ನೀಲಿ ಕ್ಯಾಂಡಲ್",
  "block.minecraft.blue_candle_cake": "Nīli kyāṇḍalnondige kēk",
  "block.minecraft.blue_carpet": "ನೀಲಿ ಕಾರ್ಪೆಟ್",
  "block.minecraft.blue_concrete": "ನೀಲಿ ಕಾಂಕ್ರೀಟ್",
  "block.minecraft.blue_concrete_powder": "ನೀಲಿ ಕಾಂಕ್ರೀಟ್ ಪುಡಿ",
  "block.minecraft.blue_glazed_terracotta": "ನೀಲಿ ಮೆರುಗಿನ ಟೆರಾಕೋಟಾ",
  "block.minecraft.blue_ice": "ನೀಲಿ ಐಸ್",
  "block.minecraft.blue_orchid": "\nನೀಲಿ ಆರ್ಕಿಡ್",
  "block.minecraft.blue_shulker_box": "\nನೀಲಿ ಶಲ್ಕರ್ ಬಾಕ್ಸ್",
  "block.minecraft.blue_stained_glass": "ನೀಲಿ ಬಣ್ಣದ ಗಾಜು",
  "block.minecraft.blue_stained_glass_pane": "ನೀಲಿ ಬಣ್ಣದ ಗಾಜಿನ ಫಲಕ",
  "block.minecraft.blue_terracotta": "ಬ್ಲೂ ಟೆರಾಕೋಟಾ",
  "block.minecraft.blue_wool": "ನೀಲಿ ಉಣ್ಣೆ",
  "block.minecraft.bone_block": "ಮೂಳೆ ಬ್ಲಾಕ್",
  "block.minecraft.bookshelf": "ಪುಸ್ತಕದ ಕಪಾಟು",
  "block.minecraft.brain_coral": "\nಮೆದುಳಿನ ಹವಳ",
  "block.minecraft.brain_coral_block": "ಡೆಡ್ ಬ್ರೈನ್ ಕೋರಲ್ ಬ್ಲಾಕ್",
  "block.minecraft.brain_coral_fan": "ಬ್ರೈನ್ ಕೋರಲ್ ಫ್ಯಾನ್",
  "block.minecraft.brain_coral_wall_fan": "ಬ್ರೈನ್ ಕೋರಲ್ ವಾಲ್ ಫ್ಯಾನ್",
  "block.minecraft.brewing_stand": "\nಬ್ರೂಯಿಂಗ್ ಸ್ಟ್ಯಾಂಡ್",
  "block.minecraft.brick_slab": "ಇಟ್ಟಿಗೆ ಚಪ್ಪಡಿ",
  "block.minecraft.brick_stairs": "ಇಟ್ಟಿಗೆ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.brick_wall": "ಇಟ್ಟಿಗೆ ಗೋಡೆ",
  "block.minecraft.bricks": "ಇಟ್ಟಿಗೆಗಳು",
  "block.minecraft.brown_banner": "ಕಂದು ಬ್ಯಾನರ್",
  "block.minecraft.brown_bed": "ಕಂದು ಹಾಸಿಗೆ",
  "block.minecraft.brown_candle": "ಬ್ರೌನ್ ಕ್ಯಾಂಡಲ್",
  "block.minecraft.brown_candle_cake": "Braun kyāṇḍalnondige kēk",
  "block.minecraft.brown_carpet": "ಕಂದು ಕಾರ್ಪೆಟ್",
  "block.minecraft.brown_concrete": "ಕಂದು ಕಾಂಕ್ರೀಟ್",
  "block.minecraft.brown_concrete_powder": "ಕಂದು ಕಾಂಕ್ರೀಟ್ ಪುಡಿ",
  "block.minecraft.brown_glazed_terracotta": "ಬ್ರೌನ್ ಮೆರುಗುಗೊಳಿಸಲಾದ ಟೆರಾಕೋಟಾ",
  "block.minecraft.brown_mushroom": "ಬ್ರೌನ್ ಮಶ್ರೂಮ್",
  "block.minecraft.brown_mushroom_block": "\nಬ್ರೌನ್ ಮಶ್ರೂಮ್ ಬ್ಲಾಕ್",
  "block.minecraft.brown_shulker_box": "ಬ್ರೌನ್ ಶಲ್ಕರ್ ಬಾಕ್ಸ್",
  "block.minecraft.brown_stained_glass": "ಬ್ರೌನ್ ಸ್ಟೇನ್ಡ್ ಗ್ಲಾಸ್",
  "block.minecraft.brown_stained_glass_pane": "ಬ್ರೌನ್ ಸ್ಟೇನ್ಡ್ ಗ್ಲಾಸ್ ಪೇನ್",
  "block.minecraft.brown_terracotta": "ಬ್ರೌನ್ ಟೆರಾಕೋಟಾ",
  "block.minecraft.brown_wool": "ಕಂದು ಉಣ್ಣೆ",
  "block.minecraft.bubble_column": "\nಬಬಲ್ ಕಾಲಮ್",
  "block.minecraft.bubble_coral": "\nಬಬಲ್ ಹವಳ",
  "block.minecraft.bubble_coral_block": "ಟ್ಯೂಬ್ ಕೋರಲ್ ಬ್ಲಾಕ್",
  "block.minecraft.bubble_coral_fan": "\nಬಬಲ್ ಕೋರಲ್ ಫ್ಯಾನ್",
  "block.minecraft.bubble_coral_wall_fan": "ಬಬಲ್ ಕೋರಲ್ ವಾಲ್ ಫ್ಯಾನ್",
  "block.minecraft.budding_amethyst": "ಬಡ್ಡಿಂಗ್ ಅಮೆಥಿಸ್ಟ್",
  "block.minecraft.bush": "Bush",
  "block.minecraft.cactus": "ಕಳ್ಳಿ",
  "block.minecraft.cactus_flower": "Cactus Flower",
  "block.minecraft.cake": "ಕೇಕ್",
  "block.minecraft.calcite": "ಕ್ಯಾಲ್ಸೈಟ್",
  "block.minecraft.calibrated_sculk_sensor": "ಮಾಪನಾಂಕ ನಿರ್ಣಯಿಸಿದ ಸ್ಕಲ್ಕ್ ಸಂವೇದಕ",
  "block.minecraft.campfire": "ಕ್ಯಾಂಪ್ಫೈರ್",
  "block.minecraft.candle": "ಮೋಂಬತ್ತಿ",
  "block.minecraft.candle_cake": "ಕ್ಯಾಂಡಲ್ ಕೇಕ್",
  "block.minecraft.carrots": "ಕ್ಯಾರೆಟ್",
  "block.minecraft.cartography_table": "ಕಾರ್ಟೋಗ್ರಫಿ ಟೇಬಲ್",
  "block.minecraft.carved_pumpkin": "\nಕೆತ್ತಿದ ಕುಂಬಳಕಾಯಿ",
  "block.minecraft.cauldron": "ಕೌಲ್ಡ್ರನ್",
  "block.minecraft.cave_air": "ಗುಹೆ ಗಾಳಿ",
  "block.minecraft.cave_vines": "ಗುಹೆ ಬಳ್ಳಿಗಳು",
  "block.minecraft.cave_vines_plant": "ಗುಹೆ ಬಳ್ಳಿ ಗಿಡ",
  "block.minecraft.chain": "ಚೈನ್",
  "block.minecraft.chain_command_block": "\nಚೈನ್ ಕಮಾಂಡ್ ಬ್ಲಾಕ್",
  "block.minecraft.cherry_button": "ಚೆರ್ರಿ ಬಟನ್",
  "block.minecraft.cherry_door": "ಚೆರ್ರಿ ಬಾಗಿಲು",
  "block.minecraft.cherry_fence": "ಚೆರ್ರಿ ಬೇಲಿ",
  "block.minecraft.cherry_fence_gate": "ಚೆರ್ರಿ ಫೆನ್ಸ್ ಗೇಟ್",
  "block.minecraft.cherry_hanging_sign": "ಚೆರ್ರಿ ಹ್ಯಾಂಗಿಂಗ್ ಚಿಹ್ನೆ",
  "block.minecraft.cherry_leaves": "ಚೆರ್ರಿ ಎಲೆಗಳು",
  "block.minecraft.cherry_log": "ಚೆರ್ರಿ ಲಾಗ್",
  "block.minecraft.cherry_planks": "ಚೆರ್ರಿ ಹಲಗೆಗಳು",
  "block.minecraft.cherry_pressure_plate": "ಚೆರ್ರಿ ಪ್ರೆಶರ್ ಪ್ಲೇಟ್",
  "block.minecraft.cherry_sapling": "ಚೆರ್ರಿ ಸಸಿ",
  "block.minecraft.cherry_shelf": "Cherry Shelf",
  "block.minecraft.cherry_sign": "ಚೆರ್ರಿ ಚಿಹ್ನೆ",
  "block.minecraft.cherry_slab": "ಚೆರ್ರಿ ಚಪ್ಪಡಿ",
  "block.minecraft.cherry_stairs": "ಚೆರ್ರಿ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.cherry_trapdoor": "ಚೆರ್ರಿ ಟ್ರ್ಯಾಪ್ಡೋರ್",
  "block.minecraft.cherry_wall_hanging_sign": "ಚೆರ್ರಿ ವಾಲ್ ಹ್ಯಾಂಗಿಂಗ್ ಚಿಹ್ನೆ",
  "block.minecraft.cherry_wall_sign": "ಚೆರ್ರಿ ಗೋಡೆಯ ಚಿಹ್ನೆ",
  "block.minecraft.cherry_wood": "ಚೆರ್ರಿ ವುಡ್",
  "block.minecraft.chest": "\nಎದೆ",
  "block.minecraft.chipped_anvil": "ಚಿಪ್ಡ್ ಅನ್ವಿಲ್",
  "block.minecraft.chiseled_bookshelf": "ಕತ್ತರಿಸಿದ ಪುಸ್ತಕದ ಕಪಾಟು",
  "block.minecraft.chiseled_copper": "Chiseled Copper",
  "block.minecraft.chiseled_deepslate": "ಚಿಸೆಲ್ಡ್ ಡೀಪ್ಸ್ಲೇಟ್",
  "block.minecraft.chiseled_nether_bricks": "ಕತ್ತರಿಸಿದ ನೆದರ್ ಇಟ್ಟಿಗೆಗಳು",
  "block.minecraft.chiseled_polished_blackstone": "ಕತ್ತರಿಸಿದ ನಯಗೊಳಿಸಿದ ಬ್ಲಾಕ್‌ಸ್ಟೋನ್",
  "block.minecraft.chiseled_quartz_block": "ಕತ್ತರಿಸಿದ ಸ್ಫಟಿಕ ಬ್ಲಾಕ್",
  "block.minecraft.chiseled_red_sandstone": "ಕತ್ತರಿಸಿದ ಕೆಂಪು ಮರಳುಗಲ್ಲು",
  "block.minecraft.chiseled_resin_bricks": "Chiseled Resin Bricks",
  "block.minecraft.chiseled_sandstone": "ಕತ್ತರಿಸಿದ ಮರಳುಗಲ್ಲು",
  "block.minecraft.chiseled_stone_bricks": "ಕತ್ತರಿಸಿದ ಕಲ್ಲು ಇಟ್ಟಿಗೆಗಳು",
  "block.minecraft.chiseled_tuff": "Chiseled Tuff",
  "block.minecraft.chiseled_tuff_bricks": "Chiseled Tuff Bricks",
  "block.minecraft.chorus_flower": "ಕೋರಸ್ ಹೂ",
  "block.minecraft.chorus_plant": "\nಕೋರಸ್ ಸಸ್ಯ",
  "block.minecraft.clay": "ಮಣ್ಣಿನ",
  "block.minecraft.closed_eyeblossom": "Closed Eyeblossom",
  "block.minecraft.coal_block": "ಕಲ್ಲಿದ್ದಲು ಘನಗ",
  "block.minecraft.coal_ore": "ಕಲ್ಲಿದ್ದಲು ಅದಿರು",
  "block.minecraft.coarse_dirt": "\nಒರಟಾದ ಕೊಳಕು",
  "block.minecraft.cobbled_deepslate": "ಕೋಬಲ್ಡ್ ಡೀಪ್ಸ್ಲೇಟ್",
  "block.minecraft.cobbled_deepslate_slab": "ಕೋಬಲ್ಡ್ ಡೀಪ್ಸ್ಲೇಟ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.cobbled_deepslate_stairs": "ಕೋಬಲ್ಡ್ ಡೀಪ್ಸ್ಲೇಟ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.cobbled_deepslate_wall": "ಕಲ್ಲಿನಿಂದ ಕೂಡಿದ ಆಳವಾದ ಗೋಡೆ",
  "block.minecraft.cobblestone": "ನುಣುಪುಗಲ್ಲು",
  "block.minecraft.cobblestone_slab": "ಕೋಬ್ಲೆಸ್ಟೋನ್ ಚಪ್ಪಡಿ",
  "block.minecraft.cobblestone_stairs": "\nಕೋಬ್ಲೆಸ್ಟೋನ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.cobblestone_wall": "\nಕೋಬ್ಲೆಸ್ಟೋನ್ ವಾಲ್",
  "block.minecraft.cobweb": "ಜೇಡನ ಬಲೆ",
  "block.minecraft.cocoa": "ಕೊಕೊ",
  "block.minecraft.command_block": "ಕಮಾಂಡ್ ಬ್ಲಾಕ್",
  "block.minecraft.comparator": "\nರೆಡ್‌ಸ್ಟೋನ್ ಹೋಲಿಕೆದಾರ",
  "block.minecraft.composter": "ಸಂಯೋಜಕ",
  "block.minecraft.conduit": "ಕಂಡ್ಯೂಟ್",
  "block.minecraft.copper_bars": "Copper Bars",
  "block.minecraft.copper_block": "ತಾಮ್ರದ ಬ್ಲಾಕ್",
  "block.minecraft.copper_bulb": "Copper Bulb",
  "block.minecraft.copper_chain": "Copper Chain",
  "block.minecraft.copper_chest": "Copper Chest",
  "block.minecraft.copper_door": "Copper Door",
  "block.minecraft.copper_golem_statue": "Copper Golem Statue",
  "block.minecraft.copper_grate": "Copper Grate",
  "block.minecraft.copper_lantern": "Copper Lantern",
  "block.minecraft.copper_ore": "ತಾಮ್ರದ ಅದಿರು",
  "block.minecraft.copper_torch": "Copper Torch",
  "block.minecraft.copper_trapdoor": "Copper Trapdoor",
  "block.minecraft.copper_wall_torch": "Copper Wall Torch",
  "block.minecraft.cornflower": "ಕಾರ್ನ್ಫ್ಲವರ್",
  "block.minecraft.cracked_deepslate_bricks": "ಬಿರುಕುಗೊಂಡ ಆಳವಾದ ಇಟ್ಟಿಗೆಗಳನ್ನು",
  "block.minecraft.cracked_deepslate_tiles": "ಕ್ರ್ಯಾಕ್ಡ್ ಡೀಪ್ಸ್ಲೇಟ್ ಟೈಲ್ಸ್",
  "block.minecraft.cracked_nether_bricks": "ಕ್ರ್ಯಾಕ್ಡ್ ನೆದರ್ ಬ್ರಿಕ್ಸ್",
  "block.minecraft.cracked_polished_blackstone_bricks": "ಕ್ರ್ಯಾಕ್ಡ್ ಪಾಲಿಶ್ಡ್ ಬ್ಲಾಕ್ಸ್ಟೋನ್ ಇಟ್ಟಿಗೆಗಳು",
  "block.minecraft.cracked_stone_bricks": "ಬಿರುಕು ಬಿಟ್ಟ ಕಲ್ಲು ಇಟ್ಟಿಗೆಗಳು",
  "block.minecraft.crafter": "Crafter",
  "block.minecraft.crafting_table": "\nಕ್ರಾಫ್ಟಿಂಗ್ ಟೇಬಲ್",
  "block.minecraft.creaking_heart": "Creaking Heart",
  "block.minecraft.creeper_head": "ಕ್ರೀಪರ್ ತಲೆ",
  "block.minecraft.creeper_wall_head": "ಕ್ರೀಪರ್ ವಾಲ್ ಹೆಡ್",
  "block.minecraft.crimson_button": "ಕ್ರಿಮ್ಸನ್ ಬಟನ್",
  "block.minecraft.crimson_door": "ಕ್ರಿಮ್ಸನ್ ಡೋರ್",
  "block.minecraft.crimson_fence": "ಕ್ರಿಮ್ಸನ್ ಬೇಲಿ",
  "block.minecraft.crimson_fence_gate": "ಕ್ರಿಮ್ಸನ್ ಬೇಲಿ ಗೇಟ್",
  "block.minecraft.crimson_fungus": "ಕ್ರಿಮ್ಸನ್ ಶಿಲೀಂಧ್ರ",
  "block.minecraft.crimson_hanging_sign": "ಕ್ರಿಮ್ಸನ್ ಹ್ಯಾಂಗಿಂಗ್ ಚಿಹ್ನೆ",
  "block.minecraft.crimson_hyphae": "ಕ್ರಿಮ್ಸನ್ ಹೈಫೇ",
  "block.minecraft.crimson_nylium": "ಕ್ರಿಮ್ಸನ್ ನೈಲಿಯಮ್",
  "block.minecraft.crimson_planks": "ಕ್ರಿಮ್ಸನ್ ಹಲಗೆಗಳು",
  "block.minecraft.crimson_pressure_plate": "ಕ್ರಿಮ್ಸನ್ ಪ್ರೆಶರ್ ಪ್ಲೇಟ್",
  "block.minecraft.crimson_roots": "ಕ್ರಿಮ್ಸನ್ ರೂಟ್ಸ್",
  "block.minecraft.crimson_shelf": "Crimson Shelf",
  "block.minecraft.crimson_sign": "ಕ್ರಿಮ್ಸನ್ ಚಿಹ್ನೆ",
  "block.minecraft.crimson_slab": "ಕ್ರಿಮ್ಸನ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.crimson_stairs": "ಕ್ರಿಮ್ಸನ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.crimson_stem": "ಕ್ರಿಮ್ಸನ್ ಸ್ಟೆಮ್",
  "block.minecraft.crimson_trapdoor": "ಕ್ರಿಮ್ಸನ್ ಟ್ರ್ಯಾಪ್ಡೋರ್",
  "block.minecraft.crimson_wall_hanging_sign": "ಕ್ರಿಮ್ಸನ್ ವಾಲ್ ಹ್ಯಾಂಗಿಂಗ್ ಚಿಹ್ನೆ",
  "block.minecraft.crimson_wall_sign": "ಕ್ರಿಮ್ಸನ್ ವಾಲ್ ಸೈನ್",
  "block.minecraft.crying_obsidian": "ಅಳುವುದು ಅಬ್ಸಿಡಿಯನ್",
  "block.minecraft.cut_copper": "ತಾಮ್ರವನ್ನು ಕತ್ತರಿಸಿ",
  "block.minecraft.cut_copper_slab": "ತಾಮ್ರದ ಚಪ್ಪಡಿ ಕತ್ತರಿಸಿ",
  "block.minecraft.cut_copper_stairs": "ತಾಮ್ರದ ಮೆಟ್ಟಿಲುಗಳನ್ನು ಕತ್ತರಿಸಿ",
  "block.minecraft.cut_red_sandstone": "ಕಟ್ ರೆಡ್ ಸ್ಯಾಂಡ್ಸ್ಟೋನ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.cut_red_sandstone_slab": "ಕಟ್ ರೆಡ್ ಸ್ಯಾಂಡ್ಸ್ಟೋನ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.cut_sandstone": "ಮರಳುಗಲ್ಲು ಕತ್ತರಿಸಿ",
  "block.minecraft.cut_sandstone_slab": "ಕಲ್ಲಿನ ಮರಳುಗಲ್ಲಿನ ಚಪ್ಪಡಿ",
  "block.minecraft.cyan_banner": "ವೈಡೂರ್ಯದ ಬ್ಯಾನರ್",
  "block.minecraft.cyan_bed": "ವೈಡೂರ್ಯ ಹಾಸಿಗೆ",
  "block.minecraft.cyan_candle": "ಸಯಾನ್ ಕ್ಯಾಂಡಲ್",
  "block.minecraft.cyan_candle_cake": "Sayān kyāṇḍalnondige kēk",
  "block.minecraft.cyan_carpet": "ವೈಡೂರ್ಯ ಕಾರ್ಪೆಟ್",
  "block.minecraft.cyan_concrete": "ವೈಡೂರ್ಯದ ಕಾಂಕ್ರೀಟ್",
  "block.minecraft.cyan_concrete_powder": "ವೈಡೂರ್ಯದ ಕಾಂಕ್ರೀಟ್ ಪುಡಿ",
  "block.minecraft.cyan_glazed_terracotta": "ಸೈನ್ ಮೆರುಗುಗೊಳಿಸಲಾದ ಟೆರಾಕೋಟಾ",
  "block.minecraft.cyan_shulker_box": "ಸಯಾನ್ ಶುಲ್ಕರ್ ಬಾಕ್ಸ್",
  "block.minecraft.cyan_stained_glass": "ಸಯಾನ್ ಸ್ಟೇನ್ಡ್ ಗ್ಲಾಸ್",
  "block.minecraft.cyan_stained_glass_pane": "ಸಯಾನ್ ಸ್ಟೇನ್ಡ್ ಗ್ಲಾಸ್ ಪೇನ್",
  "block.minecraft.cyan_terracotta": "ಸೈನ್ ಟೆರಾಕೋಟಾ",
  "block.minecraft.cyan_wool": "ವೈಡೂರ್ಯ ಉಣ್ಣೆ",
  "block.minecraft.damaged_anvil": "\nಹಾನಿಗೊಳಗಾದ ಅನ್ವಿಲ್",
  "block.minecraft.dandelion": "ಡ್ಯಾಂಡಲಿಯನ್",
  "block.minecraft.dark_oak_button": "ಡಾರ್ಕ್ ಓಕ್ ಬಟನ್",
  "block.minecraft.dark_oak_door": "ಡಾರ್ಕ್ ಓಕ್ ಡೋರ್",
  "block.minecraft.dark_oak_fence": "ಡಾರ್ಕ್ ಓಕ್ ಫೆನ್ಸ್",
  "block.minecraft.dark_oak_fence_gate": "ಡಾರ್ಕ್ ಓಕ್ ಫೆನ್ಸ್ ಗೇಟ್",
  "block.minecraft.dark_oak_hanging_sign": "ಡಾರ್ಕ್ ಓಕ್ ಹ್ಯಾಂಗಿಂಗ್ ಚಿಹ್ನೆ",
  "block.minecraft.dark_oak_leaves": "ಡಾರ್ಕ್ ಓಕ್ ಎಲೆಗಳು",
  "block.minecraft.dark_oak_log": "ಡಾರ್ಕ್ ಓಕ್ ಲಾಗ್",
  "block.minecraft.dark_oak_planks": "ಡಾರ್ಕ್ ಓಕ್ ಹಲಗೆಗಳು",
  "block.minecraft.dark_oak_pressure_plate": "ಡಾರ್ಕ್ ಓಕ್ ಒತ್ತಡದ ಪ್ಲೇಟ್",
  "block.minecraft.dark_oak_sapling": "ಡಾರ್ಕ್ ಓಕ್ ಸಸಿಂಗ್",
  "block.minecraft.dark_oak_shelf": "Dark Oak Shelf",
  "block.minecraft.dark_oak_sign": "ಡಾರ್ಕ್ ಓಕ್ ಸೈನ್",
  "block.minecraft.dark_oak_slab": "ಡಾರ್ಕ್ ಓಕ್ ಚಪ್ಪಡಿ",
  "block.minecraft.dark_oak_stairs": "ಡಾರ್ಕ್ ಓಕ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.dark_oak_trapdoor": "ಡಾರ್ಕ್ ಓಕ್ ಟ್ರ್ಯಾಪ್ಡೂರ್",
  "block.minecraft.dark_oak_wall_hanging_sign": "ಡಾರ್ಕ್ ಓಕ್ ವಾಲ್ ಹ್ಯಾಂಗಿಂಗ್ ಚಿಹ್ನೆ",
  "block.minecraft.dark_oak_wall_sign": "ಡಾರ್ಕ್ ಓಕ್ ವಾಲ್ ಚಿಹ್ನೆ",
  "block.minecraft.dark_oak_wood": "ಡಾರ್ಕ್ ಓಕ್ ವುಡ್",
  "block.minecraft.dark_prismarine": "ಡಾರ್ಕ್ ಪ್ರಿಸ್ಮರಿನ್",
  "block.minecraft.dark_prismarine_slab": "ಡಾರ್ಕ್ ಪ್ರಿಸ್ಮರಿನ್ ಚಪ್ಪಡಿ",
  "block.minecraft.dark_prismarine_stairs": "ಡಾರ್ಕ್ ಪ್ರಿಸ್ಮರಿನ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.daylight_detector": "\nಡೇಲೈಟ್ ಡಿಟೆಕ್ಟರ್",
  "block.minecraft.dead_brain_coral": "\nಡೆಡ್ ಬ್ರೈನ್ ಕೋರಲ್",
  "block.minecraft.dead_brain_coral_block": "ಡೆಡ್ ಬ್ರೈನ್ ಕೋರಲ್ ಬ್ಲಾಕ್",
  "block.minecraft.dead_brain_coral_fan": "\nಡೆಡ್ ಬ್ರೈನ್ ಕೋರಲ್",
  "block.minecraft.dead_brain_coral_wall_fan": "ಡೆಡ್ ಬ್ರೈನ್ ಕೋರಲ್ ವಾಲ್ ಫ್ಯಾನ್",
  "block.minecraft.dead_bubble_coral": "ಡೆಡ್ ಬಬಲ್ ಕೋರಲ್",
  "block.minecraft.dead_bubble_coral_block": "ಡೆಡ್ ಬಬಲ್ ಕೋರಲ್ ಬ್ಲಾಕ್",
  "block.minecraft.dead_bubble_coral_fan": "ಡೆಡ್ ಟ್ಯೂಬ್ ಕೋರಲ್",
  "block.minecraft.dead_bubble_coral_wall_fan": "ಡೆಡ್ ಬಬಲ್ ಕೋರಲ್ ವಾಲ್ ಫ್ಯಾನ್",
  "block.minecraft.dead_bush": "\nಡೆಡ್ ಬುಷ್",
  "block.minecraft.dead_fire_coral": "\nಡೆಡ್ ಫೈರ್ ಕೋರಲ್",
  "block.minecraft.dead_fire_coral_block": "\nಡೆಡ್ ಫೈರ್ ಕೋರಲ್ ಬ್ಲಾಕ್",
  "block.minecraft.dead_fire_coral_fan": "ಡೆಡ್ ಟ್ಯೂಬ್ ಕೋರಲ್",
  "block.minecraft.dead_fire_coral_wall_fan": "ಡೆಡ್ ಫೈರ್ ಕೋರಲ್ ವಾಲ್ ಫ್ಯಾನ್",
  "block.minecraft.dead_horn_coral": "\nಡೆಡ್ ಹಾರ್ನ್ ಕೋರಲ್",
  "block.minecraft.dead_horn_coral_block": "\nಡೆಡ್ ಹಾರ್ನ್ ಕೋರಲ್ ಬ್ಲಾಕ್",
  "block.minecraft.dead_horn_coral_fan": "ಡೆಡ್ ಟ್ಯೂಬ್ ಕೋರಲ್",
  "block.minecraft.dead_horn_coral_wall_fan": "\nಡೆಡ್ ಹಾರ್ನ್ ಕೋರಲ್ ವಾಲ್ ಫ್ಯಾನ್",
  "block.minecraft.dead_tube_coral": "ಡೆಡ್ ಟ್ಯೂಬ್ ಕೋರಲ್",
  "block.minecraft.dead_tube_coral_block": "ಡೆಡ್ ಟ್ಯೂಬ್ ಕೋರಲ್ ಬ್ಲಾಕ್",
  "block.minecraft.dead_tube_coral_fan": "ಡೆಡ್ ಟ್ಯೂಬ್ ಕೋರಲ್",
  "block.minecraft.dead_tube_coral_wall_fan": "\nಡೆಡ್ ಟ್ಯೂಬ್ ಕೋರಲ್ ವಾಲ್ ಫ್ಯಾನ್",
  "block.minecraft.decorated_pot": "ಅಲಂಕರಿಸಿದ ಮಡಕೆ",
  "block.minecraft.deepslate": "ಆಳವಾದ",
  "block.minecraft.deepslate_brick_slab": "ಡೀಪ್ಸ್ಲೇಟ್ ಬ್ರಿಕ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.deepslate_brick_stairs": "ಡೀಪ್ಸ್ಲೇಟ್ ಇಟ್ಟಿಗೆ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.deepslate_brick_wall": "ಡೀಪ್ಲೇಟ್ ಇಟ್ಟಿಗೆ ಗೋಡೆ",
  "block.minecraft.deepslate_bricks": "ಡೀಪ್ಸ್ಲೇಟ್ ಇಟ್ಟಿಗೆಗಳು",
  "block.minecraft.deepslate_coal_ore": "ಡೀಪ್ಲೇಟ್ ಕಲ್ಲಿದ್ದಲು ಅದಿರು",
  "block.minecraft.deepslate_copper_ore": "ಡೀಪ್ಲೇಟ್ ತಾಮ್ರದ ಅದಿರು",
  "block.minecraft.deepslate_diamond_ore": "ಡೀಪ್ಲೇಟ್ ಡೈಮಂಡ್ ಅದಿರು",
  "block.minecraft.deepslate_emerald_ore": "ಡೀಪ್ಲೇಟ್ ಪಚ್ಚೆ ಅದಿರು",
  "block.minecraft.deepslate_gold_ore": "ಡೀಪ್ಲೇಟ್ ಚಿನ್ನದ ಅದಿರು",
  "block.minecraft.deepslate_iron_ore": "ಡೀಪ್ಲೇಟ್ ಕಬ್ಬಿಣದ ಅದಿರು",
  "block.minecraft.deepslate_lapis_ore": "ಡೀಪ್ಲೇಟ್ ಲ್ಯಾಪಿಸ್ ಲಾ z ುಲಿ ಅದಿರು",
  "block.minecraft.deepslate_redstone_ore": "Deepslate Redstone ಅದಿರು",
  "block.minecraft.deepslate_tile_slab": "ಡೀಪ್ಸ್ಲೇಟ್ ಟೈಲ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.deepslate_tile_stairs": "ಡೀಪ್ಸ್ಲೇಟ್ ಟೈಲ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.deepslate_tile_wall": "ಡೀಪ್ಸ್ಲೇಟ್ ಟೈಲ್ ವಾಲ್",
  "block.minecraft.deepslate_tiles": "ಡೀಪ್ಸ್ಲೇಟ್ ಟೈಲ್ಸ್",
  "block.minecraft.detector_rail": "\nಡಿಟೆಕ್ಟರ್ ರೈಲು",
  "block.minecraft.diamond_block": "ಡೈಮಂಡ್ನ ಬ್ಲಾಕ್",
  "block.minecraft.diamond_ore": "ಡೈಮಂಡ್ ಅದಿರು",
  "block.minecraft.diorite": "ಡಿಯೊರೈಟ್",
  "block.minecraft.diorite_slab": "ಡಿಯೊರೈಟ್ ಚಪ್ಪಡಿ",
  "block.minecraft.diorite_stairs": "ಡಿಯೊರೈಟ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.diorite_wall": "ಡಿಯೊರೈಟ್ ಗೋಡೆ",
  "block.minecraft.dirt": "ಮಣ್ಣು",
  "block.minecraft.dirt_path": "ಕೊಳಕು ಮಾರ್ಗ",
  "block.minecraft.dispenser": "ವಿತರಕ",
  "block.minecraft.dragon_egg": "ಡ್ರ್ಯಾಗನ್ ಮೊಟ್ಟೆ",
  "block.minecraft.dragon_head": "ಡ್ರ್ಯಾಗನ್ ತಲೆ",
  "block.minecraft.dragon_wall_head": "ಡ್ರ್ಯಾಗನ್ ವಾಲ್ ಹೆಡ್",
  "block.minecraft.dried_ghast": "Dried Ghast",
  "block.minecraft.dried_kelp_block": "ಒಣಗಿದ ಕೆಲ್ಪ್ ಬ್ಲಾಕ್",
  "block.minecraft.dripstone_block": "ಡ್ರಿಪ್ಸ್ಟೋನ್ ಬ್ಲಾಕ್",
  "block.minecraft.dropper": "\nಡ್ರಾಪರ್",
  "block.minecraft.emerald_block": "ಪಚ್ಚೆ ಘನಗ",
  "block.minecraft.emerald_ore": "ಪಚ್ಚೆ ಅದಿರು",
  "block.minecraft.enchanting_table": "ಮೋಡಿಮಾಡುವ ಟೇಬಲ್",
  "block.minecraft.end_gateway": "ಗೇಟ್‌ವೇ ಅಂತ್ಯ",
  "block.minecraft.end_portal": "ಎಂಡ್ ಪೋರ್ಟಲ್",
  "block.minecraft.end_portal_frame": "\nಪೋರ್ಟಲ್ ಫ್ರೇಮ್ ಅನ್ನು ಕೊನೆಗೊಳಿಸಿ",
  "block.minecraft.end_rod": "ಎಂಡ್ ರಾಡ್",
  "block.minecraft.end_stone": "ಎಂಡ್ ಸ್ಟೋನ್",
  "block.minecraft.end_stone_brick_slab": "ಎಂಡ್ ಸ್ಟೋನ್ ಬ್ರಿಕ್ ಚಪ್ಪಡಿ",
  "block.minecraft.end_stone_brick_stairs": "ಎಂಡ್ ಸ್ಟೋನ್ ಬ್ರಿಕ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.end_stone_brick_wall": "ಎಂಡ್ ಸ್ಟೋನ್ ಬ್ರಿಕ್ ವಾಲ್",
  "block.minecraft.end_stone_bricks": "ಸ್ಟೋನ್ ಬ್ರಿಕ್ಸ್ ಅನ್ನು ಕೊನೆಗೊಳಿಸಿ",
  "block.minecraft.ender_chest": "ಎಂಡರ್ ಎದೆ",
  "block.minecraft.exposed_chiseled_copper": "Exposed Chiseled Copper",
  "block.minecraft.exposed_copper": "ಒಡ್ಡಿದ ತಾಮ್ರ",
  "block.minecraft.exposed_copper_bars": "Exposed Copper Bars",
  "block.minecraft.exposed_copper_bulb": "Exposed Copper Bulb",
  "block.minecraft.exposed_copper_chain": "Exposed Copper Chain",
  "block.minecraft.exposed_copper_chest": "Exposed Copper Chest",
  "block.minecraft.exposed_copper_door": "Exposed Copper Door",
  "block.minecraft.exposed_copper_golem_statue": "Exposed Copper Golem Statue",
  "block.minecraft.exposed_copper_grate": "Exposed Copper Grate",
  "block.minecraft.exposed_copper_lantern": "Exposed Copper Lantern",
  "block.minecraft.exposed_copper_trapdoor": "Exposed Copper Trapdoor",
  "block.minecraft.exposed_cut_copper": "ಒಡ್ಡಿದ ಗಾಯ ತಾಮ್ರ",
  "block.minecraft.exposed_cut_copper_slab": "ಬಹಿರಂಗವಾದ ತಾಮ್ರದ ಚಪ್ಪಡಿ",
  "block.minecraft.exposed_cut_copper_stairs": "ಬಹಿರಂಗವಾದ ತಾಮ್ರದ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.exposed_lightning_rod": "Exposed Lightning Rod",
  "block.minecraft.farmland": "\nಕೃಷಿಭೂಮಿ",
  "block.minecraft.fern": "ಜರೀಗಿಡ",
  "block.minecraft.fire": "ಬೆಂಕಿ",
  "block.minecraft.fire_coral": "\nಫೈರ್ ಕೋರಲ್",
  "block.minecraft.fire_coral_block": "ಟ್ಯೂಬ್ ಕೋರಲ್ ಬ್ಲಾಕ್",
  "block.minecraft.fire_coral_fan": "ಫೈರ್ ಕೋರಲ್ ಫ್ಯಾನ್",
  "block.minecraft.fire_coral_wall_fan": "\nಟ್ಯೂಬ್ ಕೋರಲ್ ವಾಲ್ ಫ್ಯಾನ್",
  "block.minecraft.firefly_bush": "Firefly Bush",
  "block.minecraft.fletching_table": "ಫ್ಲೆಚಿಂಗ್ ಟೇಬಲ್",
  "block.minecraft.flower_pot": "ಹೂ ಕುಂಡ",
  "block.minecraft.flowering_azalea": "ಹೂಬಿಡುವ ಅಜೇಲಿಯಾ",
  "block.minecraft.flowering_azalea_leaves": "ಹೂಬಿಡುವ ಅಜೇಲಿಯಾ ಎಲೆಗಳು",
  "block.minecraft.frogspawn": "ಫ್ರಾಗ್ಸ್ಪಾನ್",
  "block.minecraft.frosted_ice": "ಫ್ರಾಸ್ಟೆಡ್ ಐಸ್",
  "block.minecraft.furnace": "ಕುಲುಮೆ",
  "block.minecraft.gilded_blackstone": "ಗಿಲ್ಡೆಡ್ ಬ್ಲಾಕ್‌ಸ್ಟೋನ್",
  "block.minecraft.glass": "ಗಾಜು",
  "block.minecraft.glass_pane": "ಗ್ಲಾಸ್ ಪೇನ್",
  "block.minecraft.glow_lichen": "ಬ್ಲಾಕ್ ಮಿನೆಕ್ರಾಫ್ಟ್. ಹೊಳಪು_ಲಿಚೆನ್",
  "block.minecraft.glowstone": "ಗ್ಲೋಸ್ಟೋನ್",
  "block.minecraft.gold_block": "ಗೋಲ್ಡ್ ಬ್ಲಾಕ್",
  "block.minecraft.gold_ore": "ಚಿನ್ನದ ಅದಿರು",
  "block.minecraft.golden_dandelion": "Golden Dandelion",
  "block.minecraft.granite": "ಗ್ರಾನೈಟ್",
  "block.minecraft.granite_slab": "ಗ್ರಾನೈಟ್ ಚಪ್ಪಡಿ",
  "block.minecraft.granite_stairs": "ಗ್ರಾನೈಟ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.granite_wall": "ಗ್ರಾನೈಟ್ ಗೋಡೆ",
  "block.minecraft.grass": "ಹುಲ್ಲು",
  "block.minecraft.grass_block": "ಹುಲ್ಲು ಘನಗ",
  "block.minecraft.gravel": "ಜಲ್ಲಿ",
  "block.minecraft.gray_banner": "ಬೂದು ಬ್ಯಾನರ್",
  "block.minecraft.gray_bed": "ಬೂದು ಹಾಸಿಗೆ",
  "block.minecraft.gray_candle": "ಗ್ರೇ ಕ್ಯಾಂಡಲ್",
  "block.minecraft.gray_candle_cake": "Grē kyāṇḍalnondige kēk",
  "block.minecraft.gray_carpet": "ಬೂದು ಕಾರ್ಪೆಟ್",
  "block.minecraft.gray_concrete": "ಬೂದು ಕಾಂಕ್ರೀಟ್",
  "block.minecraft.gray_concrete_powder": "ಬೂದು ಕಾಂಕ್ರೀಟ್ ಪುಡಿ",
  "block.minecraft.gray_glazed_terracotta": "ಗ್ರೇ ಮೆರುಗಿನ ಟೆರಾಕೋಟಾ",
  "block.minecraft.gray_shulker_box": "\nಗ್ರೇ ಶಲ್ಕರ್ ಬಾಕ್ಸ್\n",
  "block.minecraft.gray_stained_glass": "ಗ್ರೇ ಸ್ಟೇನ್ಡ್ ಗ್ಲಾಸ್",
  "block.minecraft.gray_stained_glass_pane": "ಗ್ರೇ ಸ್ಟೇನ್ಡ್ ಗ್ಲಾಸ್ ಪೇನ್",
  "block.minecraft.gray_terracotta": "ಗ್ರೇ ಟೆರಾಕೋಟಾ",
  "block.minecraft.gray_wool": "ಹಸಿರು ಉಣ್ಣೆ",
  "block.minecraft.green_banner": "ಹಸಿರು ಬ್ಯಾನರ್",
  "block.minecraft.green_bed": "ಹಸಿರು ಹಾಸಿಗೆ",
  "block.minecraft.green_candle": "ಹಸಿರು ಕ್ಯಾಂಡಲ್",
  "block.minecraft.green_candle_cake": "Hasiru kyāṇḍalnondige kēk",
  "block.minecraft.green_carpet": "ಹಸಿರು ಕಾರ್ಪೆಟ್",
  "block.minecraft.green_concrete": "ಹಸಿರು ಕಾಂಕ್ರೀಟ್",
  "block.minecraft.green_concrete_powder": "ಹಸಿರು ಕಾಂಕ್ರೀಟ್ ಪುಡಿ",
  "block.minecraft.green_glazed_terracotta": "ಹಸಿರು ಮೆರುಗಿನ ಟೆರಾಕೋಟಾ",
  "block.minecraft.green_shulker_box": "ಹಸಿರು ಶಲ್ಕರ್ ಬಾಕ್ಸ್",
  "block.minecraft.green_stained_glass": "ಹಸಿರು ಬಣ್ಣದ ಗಾಜು",
  "block.minecraft.green_stained_glass_pane": "ಹಸಿರು ಬಣ್ಣದ ಗಾಜಿನ ಫಲಕ",
  "block.minecraft.green_terracotta": "ಗ್ರೀನ್ ಟೆರ್ರಾಕೋಟಾ",
  "block.minecraft.green_wool": "ಹಸಿರು ಉಣ್ಣೆ",
  "block.minecraft.grindstone": "ಗ್ರಿಂಡ್ಸ್ಟೋನ್",
  "block.minecraft.hanging_roots": "ಬ್ಲಾಕ್ ಮಿನೆಕ್ರಾಫ್ಟ್. ನೇತಾಡುವ_ಬೇರುಗಳು",
  "block.minecraft.hay_block": "ಹೇ ಬೇಲ್",
  "block.minecraft.heavy_core": "Heavy Core",
  "block.minecraft.heavy_weighted_pressure_plate": "\nಹೆವಿ ತೂಕದ ಒತ್ತಡದ ಫಲಕ",
  "block.minecraft.honey_block": "\nಹನಿ ಬ್ಲಾಕ್",
  "block.minecraft.honeycomb_block": "\nಜೇನುಗೂಡು ಬ್ಲಾಕ್",
  "block.minecraft.hopper": "\nಹಾಪರ್",
  "block.minecraft.horn_coral": "\nಹಾರ್ನ್ ಕೋರಲ್",
  "block.minecraft.horn_coral_block": "ಟ್ಯೂಬ್ ಕೋರಲ್ ಬ್ಲಾಕ್",
  "block.minecraft.horn_coral_fan": "ಹಾರ್ನ್ ಕೋರಲ್ ಫ್ಯಾನ್",
  "block.minecraft.horn_coral_wall_fan": "ಹಾರ್ನ್ ಕೋರಲ್ ವಾಲ್ ಫ್ಯಾನ್",
  "block.minecraft.ice": "ಐಸ್",
  "block.minecraft.infested_chiseled_stone_bricks": "ಮುತ್ತಿಕೊಂಡಿರುವ ಕತ್ತರಿಸಿದ ಕಲ್ಲು ಇಟ್ಟಿಗೆಗಳು",
  "block.minecraft.infested_cobblestone": "ಸೋಂಕಿತ ಕೋಬ್ಲೆಸ್ಟೋನ್",
  "block.minecraft.infested_cracked_stone_bricks": "ಮುತ್ತಿಕೊಂಡಿರುವ ಕಲ್ಲಿನ ಇಟ್ಟಿಗೆಗಳು",
  "block.minecraft.infested_deepslate": "ಮುತ್ತಿಕೊಂಡಿರುವ ಆಳವಾದ",
  "block.minecraft.infested_mossy_stone_bricks": "ಮುತ್ತಿಕೊಂಡಿರುವ ಪಾಚಿ ಕಲ್ಲು ಇಟ್ಟಿಗೆಗಳು",
  "block.minecraft.infested_stone": "\nಮುತ್ತಿಕೊಂಡಿರುವ ಕಲ್ಲು",
  "block.minecraft.infested_stone_bricks": "ಮುತ್ತಿಕೊಂಡಿರುವ ಕಲ್ಲು ಇಟ್ಟಿಗೆಗಳು",
  "block.minecraft.iron_bars": "ಐರನ್ ಬಾರ್ಸ್",
  "block.minecraft.iron_block": "ಐರನ್ ಬ್ಲಾಕ್",
  "block.minecraft.iron_chain": "Iron Chain",
  "block.minecraft.iron_door": "ಕಬ್ಬಿಣದ ಬಾಗಿಲು",
  "block.minecraft.iron_ore": "ಕಬ್ಬಿಣದ ಅದಿರು",
  "block.minecraft.iron_trapdoor": "ಐರನ್ ಟ್ರಾಪ್ಡೂರ್",
  "block.minecraft.jack_o_lantern": "ಜ್ಯಾಕ್ ಒ ಲ್ಯಾಂಟರ್ನ್",
  "block.minecraft.jigsaw": "ಜಿಗ್ಸಾ ಬ್ಲಾಕ್",
  "block.minecraft.jukebox": "ಜೂಕ್ಬಾಕ್ಸ್",
  "block.minecraft.jungle_button": "ಜಂಗಲ್ ಬಟನ್",
  "block.minecraft.jungle_door": "ಜಂಗಲ್ ಡೋರ್",
  "block.minecraft.jungle_fence": "ಜಂಗಲ್ ಫೆನ್ಸ್",
  "block.minecraft.jungle_fence_gate": "ಜಂಗಲ್ ಫೆನ್ಸ್ ಗೇಟ್",
  "block.minecraft.jungle_hanging_sign": "ಜಂಗಲ್ ಹ್ಯಾಂಗಿಂಗ್ ಚಿಹ್ನೆ",
  "block.minecraft.jungle_leaves": "ಜಂಗಲ್ ಎಲೆಗಳು",
  "block.minecraft.jungle_log": "ಜಂಗಲ್ ಲಾಗ್",
  "block.minecraft.jungle_planks": "ಜಂಗಲ್ ಹಲಗೆಗಳು",
  "block.minecraft.jungle_pressure_plate": "ಜಂಗಲ್ ಒತ್ತಡ ಪ್ಲೇಟ್",
  "block.minecraft.jungle_sapling": "ಜಂಗಲ್ ಸಪ್ಲಿಂಗ್",
  "block.minecraft.jungle_shelf": "Jungle Shelf",
  "block.minecraft.jungle_sign": "ಜಂಗಲ್ ಸೈನ್",
  "block.minecraft.jungle_slab": "ಜಂಗಲ್ ಚಪ್ಪಡಿ",
  "block.minecraft.jungle_stairs": "ಜಂಗಲ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.jungle_trapdoor": "ಜಂಗಲ್ ಟ್ರ್ಯಾಪ್ಡೂರ್",
  "block.minecraft.jungle_wall_hanging_sign": "ಜಂಗಲ್ ವಾಲ್ ಹ್ಯಾಂಗಿಂಗ್ ಚಿಹ್ನೆ",
  "block.minecraft.jungle_wall_sign": "ಜಂಗಲ್ ವಾಲ್ ಚಿಹ್ನೆ",
  "block.minecraft.jungle_wood": "ಜಂಗಲ್ ವುಡ್",
  "block.minecraft.kelp": "\nಕೆಲ್ಪ್",
  "block.minecraft.kelp_plant": "ಕೆಲ್ಪ್ ಪ್ಲಾಂಟ್",
  "block.minecraft.ladder": "ಏಣಿ",
  "block.minecraft.lantern": "ಲ್ಯಾಂಟರ್ನ್",
  "block.minecraft.lapis_block": "ಲ್ಯಾಪಿಸ್ ಲಾಜುಲಿಯ ಬ್ಲಾಕ್",
  "block.minecraft.lapis_ore": "ಲ್ಯಾಪಿಸ್ ಲಾಝುಲಿ ಅದಿರು",
  "block.minecraft.large_amethyst_bud": "ದೊಡ್ಡ ಅಮೆಥಿಸ್ಟ್ ಬಡ್",
  "block.minecraft.large_fern": "\nದೊಡ್ಡ ಜರೀಗಿಡ",
  "block.minecraft.lava": "ಲಾವಾ",
  "block.minecraft.lava_cauldron": "ಲಾವಾ ಕೌಲ್ಡ್ರನ್",
  "block.minecraft.leaf_litter": "Leaf Litter",
  "block.minecraft.lectern": "ಲೆಕ್ಟರ್ನ್",
  "block.minecraft.lever": "\nಲಿವರ್",
  "block.minecraft.light": "ಬೆಳಕಿನ",
  "block.minecraft.light_blue_banner": "ತಿಳಿ ನೀಲಿ ಬ್ಯಾನರ್",
  "block.minecraft.light_blue_bed": "ತಿಳಿ ನೀಲಿ ಹಾಸಿಗೆ",
  "block.minecraft.light_blue_candle": "ತಿಳಿ ನೀಲಿ ಕ್ಯಾಂಡಲ್",
  "block.minecraft.light_blue_candle_cake": "Tiḷi nīli mēṇadabattiyondige kēk",
  "block.minecraft.light_blue_carpet": "ತಿಳಿ ನೀಲಿ ಕಾರ್ಪೆಟ್",
  "block.minecraft.light_blue_concrete": "ತಿಳಿ ನೀಲಿ ಕಾಂಕ್ರೀಟ್",
  "block.minecraft.light_blue_concrete_powder": "\nತಿಳಿ ನೀಲಿ ಕಾಂಕ್ರೀಟ್ ಪುಡಿ",
  "block.minecraft.light_blue_glazed_terracotta": "ಲೈಟ್ ಬ್ಲೂ ಮೆರುಗುಗೊಳಿಸಲಾದ ಟೆರಾಕೋಟಾ",
  "block.minecraft.light_blue_shulker_box": "ತಿಳಿ ನೀಲಿ ಶಲ್ಕರ್ ಬಾಕ್ಸ್",
  "block.minecraft.light_blue_stained_glass": "ತಿಳಿ ನೀಲಿ ಬಣ್ಣದ ಗಾಜು",
  "block.minecraft.light_blue_stained_glass_pane": "ತಿಳಿ ನೀಲಿ ಬಣ್ಣದ ಗಾಜಿನ ಫಲಕ",
  "block.minecraft.light_blue_terracotta": "ಲೈಟ್ ಬ್ಲೂ ಟೆರಾಕೋಟಾ",
  "block.minecraft.light_blue_wool": "ಲೈಟ್ ಬ್ಲೂ ಗ್ಲೋಬ್",
  "block.minecraft.light_gray_banner": "ತಿಳಿ ಬೂದು ಬ್ಯಾನರ್",
  "block.minecraft.light_gray_bed": "\nತಿಳಿ ಬೂದು ಹಾಸಿಗೆ",
  "block.minecraft.light_gray_candle": "ತಿಳಿ ಬೂದು ಕ್ಯಾಂಡಲ್",
  "block.minecraft.light_gray_candle_cake": "Tiḷi būdu mēṇadabattiyondige kēk",
  "block.minecraft.light_gray_carpet": "\nತಿಳಿ ಬೂದು ಕಾರ್ಪೆಟ್",
  "block.minecraft.light_gray_concrete": "ತಿಳಿ ಬೂದು ಕಾಂಕ್ರೀಟ್",
  "block.minecraft.light_gray_concrete_powder": "\nತಿಳಿ ಬೂದು ಕಾಂಕ್ರೀಟ್ ಪುಡಿ",
  "block.minecraft.light_gray_glazed_terracotta": "ಲೈಟ್ ಗ್ರೇ ಮೆರುಗುಗೊಳಿಸಲಾದ ಟೆರಾಕೋಟಾ",
  "block.minecraft.light_gray_shulker_box": "\nತಿಳಿ ಬೂದು ಶಲ್ಕರ್ ಬಾಕ್ಸ್",
  "block.minecraft.light_gray_stained_glass": "ತಿಳಿ ಬೂದು ಬಣ್ಣದ ಗಾಜು",
  "block.minecraft.light_gray_stained_glass_pane": "ತಿಳಿ ಬೂದು ಬಣ್ಣದ ಗಾಜಿನ ಫಲಕ",
  "block.minecraft.light_gray_terracotta": "ಲೈಟ್ ಗ್ರೇ ಟೆರಾಕೋಟಾ",
  "block.minecraft.light_gray_wool": "ಲೈಟ್ ಗ್ರೇ ಗ್ಲೋಬ್",
  "block.minecraft.light_weighted_pressure_plate": "\nಕಡಿಮೆ ತೂಕದ ಒತ್ತಡದ ಫಲಕ",
  "block.minecraft.lightning_rod": "ಮಿಂಚಿನ ರಾಡ್",
  "block.minecraft.lilac": "ನೀಲಕ",
  "block.minecraft.lily_of_the_valley": "ಲಿಲಿ ಆಫ್ ದಿ ವ್ಯಾಲಿ",
  "block.minecraft.lily_pad": "ಲಿಲಿ ಪ್ಯಾಡ್",
  "block.minecraft.lime_banner": "ನಿಂಬೆ ಬ್ಯಾನರ್",
  "block.minecraft.lime_bed": "\nನಿಂಬೆ ಹಾಸಿಗೆ",
  "block.minecraft.lime_candle": "ಸುಣ್ಣ ಮೋಂಬತ್ತಿ",
  "block.minecraft.lime_candle_cake": "Nimbe kyāṇḍalnondige kēk",
  "block.minecraft.lime_carpet": "\nನಿಂಬೆ ಕಾರ್ಪೆಟ್",
  "block.minecraft.lime_concrete": "\nನಿಂಬೆ ಕಾಂಕ್ರೀಟ್",
  "block.minecraft.lime_concrete_powder": "\nನಿಂಬೆ ಕಾಂಕ್ರೀಟ್ ಪುಡಿ",
  "block.minecraft.lime_glazed_terracotta": "ನಿಂಬೆ ಮೆರುಗಿನ ಟೆರಾಕೋಟಾ",
  "block.minecraft.lime_shulker_box": "ನಿಂಬೆ ಶಲ್ಕರ್ ಬಾಕ್ಸ್",
  "block.minecraft.lime_stained_glass": "ನಿಂಬೆ ಬಣ್ಣದ ಗಾಜು",
  "block.minecraft.lime_stained_glass_pane": "ನಿಂಬೆ ಬಣ್ಣದ ಗಾಜಿನ ಫಲಕ",
  "block.minecraft.lime_terracotta": "ನಿಂಬೆ ಟೆರಾಕೋಟಾ",
  "block.minecraft.lime_wool": "ಬಿಳಿ ಉಣ್ಣೆ",
  "block.minecraft.lodestone": "ಲೋಡೆಸ್ಟೋನ್",
  "block.minecraft.loom": "ಲೂಮ್",
  "block.minecraft.magenta_banner": "\nಮೆಜೆಂಟಾ ಬ್ಯಾನರ್",
  "block.minecraft.magenta_bed": "ಮೆಜೆಂತಾ ಡೈ",
  "block.minecraft.magenta_candle": "ಮೆಜೆಂಟಾ ಕ್ಯಾಂಡಲ್",
  "block.minecraft.magenta_candle_cake": "Mejeṇṭā kyāṇḍalnondige kēk",
  "block.minecraft.magenta_carpet": "\nಕಿತ್ತಳೆ ಕಾರ್ಪೆಟ್",
  "block.minecraft.magenta_concrete": "ಮೆಜೆಂಟಾ ಕಾಂಕ್ರೀಟ್",
  "block.minecraft.magenta_concrete_powder": "ಹಸಿರು ಕಾಂಕ್ರೀಟ್ ಪುಡಿ",
  "block.minecraft.magenta_glazed_terracotta": "ಮೆಜೆಂಟಾ ಮೆರುಗುಗೊಳಿಸಲಾದ ಟೆರಾಕೋಟಾ",
  "block.minecraft.magenta_shulker_box": "\nಮೆಜೆಂಟಾ ಶುಲ್ಕರ್ ಬಾಕ್ಸ್",
  "block.minecraft.magenta_stained_glass": "ಕೆನ್ನೇರಳೆ ಬಣ್ಣದ ಗಾಜು",
  "block.minecraft.magenta_stained_glass_pane": "ಮೆಜೆಂಟಾ ಸ್ಟೇನ್ಡ್ ಗ್ಲಾಸ್ ಪೇನ್",
  "block.minecraft.magenta_terracotta": "ಮೆಜೆಂಟಾ ಟೆರಾಕೋಟಾ",
  "block.minecraft.magenta_wool": "\nಕೆನ್ನೇರಳೆ ಉಣ್ಣೆ",
  "block.minecraft.magma_block": "ಶಿಲಾಪಾಕ ಬ್ಲಾಕ್",
  "block.minecraft.mangrove_button": "ಮ್ಯಾಂಗ್ರೋವ್ ಬಟನ್",
  "block.minecraft.mangrove_door": "ಮ್ಯಾಂಗ್ರೋವ್ ಬಾಗಿಲು",
  "block.minecraft.mangrove_fence": "ಮ್ಯಾಂಗ್ರೋವ್ ಬೇಲಿ",
  "block.minecraft.mangrove_fence_gate": "ಮ್ಯಾಂಗ್ರೋವ್ ಬೇಲಿ ಗೇಟ್",
  "block.minecraft.mangrove_hanging_sign": "ಮ್ಯಾಂಗ್ರೋವ್ ಹ್ಯಾಂಗಿಂಗ್ ಚಿಹ್ನೆ",
  "block.minecraft.mangrove_leaves": "ಮ್ಯಾಂಗ್ರೋವ್ ಎಲೆಗಳು",
  "block.minecraft.mangrove_log": "ಮ್ಯಾಂಗ್ರೋವ್ ಲಾಗ್",
  "block.minecraft.mangrove_planks": "ಮ್ಯಾಂಗ್ರೋವ್ ಹಲಗೆಗಳು",
  "block.minecraft.mangrove_pressure_plate": "ಮ್ಯಾಂಗ್ರೋವ್ ಪ್ರೆಶರ್ ಪ್ಲೇಟ್",
  "block.minecraft.mangrove_propagule": "ಮ್ಯಾಂಗ್ರೋವ್ ಪ್ರಚಾರ",
  "block.minecraft.mangrove_roots": "ಮ್ಯಾಂಗ್ರೋವ್ ಬೇರುಗಳು",
  "block.minecraft.mangrove_shelf": "Mangrove Shelf",
  "block.minecraft.mangrove_sign": "ಮ್ಯಾಂಗ್ರೋವ್ ಚಿಹ್ನೆ",
  "block.minecraft.mangrove_slab": "ಮ್ಯಾಂಗ್ರೋವ್ ಚಪ್ಪಡಿ",
  "block.minecraft.mangrove_stairs": "ಮ್ಯಾಂಗ್ರೋವ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.mangrove_trapdoor": "ಮ್ಯಾಂಗ್ರೋವ್ ಟ್ರ್ಯಾಪ್ಡೋರ್",
  "block.minecraft.mangrove_wall_hanging_sign": "ಮ್ಯಾಂಗ್ರೋವ್ ಗೋಡೆಯ ನೇತಾಡುವ ಚಿಹ್ನೆ",
  "block.minecraft.mangrove_wall_sign": "ಮ್ಯಾಂಗ್ರೋವ್ ಗೋಡೆಯ ಚಿಹ್ನೆ",
  "block.minecraft.mangrove_wood": "ಮ್ಯಾಂಗ್ರೋವ್ ವುಡ್",
  "block.minecraft.medium_amethyst_bud": "ಮಧ್ಯಮ ಅಮೆಥಿಸ್ಟ್ ಬಡ್",
  "block.minecraft.melon": "ಕಲ್ಲಂಗಡಿ",
  "block.minecraft.melon_stem": "ಕಲ್ಲಂಗಡಿ ಕಾಂಡ",
  "block.minecraft.moss_block": "ಮಾಸ್ ಬ್ಲಾಕ್",
  "block.minecraft.moss_carpet": "ಪಾಚಿ ಕಾರ್ಪೆಟ್",
  "block.minecraft.mossy_cobblestone": "\nಮೊಸ್ಸಿ ಕೋಬ್ಲೆಸ್ಟೋನ್",
  "block.minecraft.mossy_cobblestone_slab": "ಮೊಸ್ಸಿ ಕೊಬ್ಲೆಸ್ಟೋನ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.mossy_cobblestone_stairs": "ಮೊಸ್ಸಿ ಕೊಬ್ಲೆಸ್ಟೋನ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.mossy_cobblestone_wall": "ಮೊಸ್ಸಿ ಕೋಬ್ಲೆಸ್ಟೋನ್ ವಾಲ್",
  "block.minecraft.mossy_stone_brick_slab": "ಮೊಸ್ಸಿ ಸ್ಟೋನ್ ಬ್ರಿಕ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.mossy_stone_brick_stairs": "ಮೊಸ್ಸಿ ಸ್ಟೋನ್ ಬ್ರಿಕ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.mossy_stone_brick_wall": "ಮೊಸ್ಸಿ ಸ್ಟೋನ್ ಬ್ರಿಕ್ ವಾಲ್",
  "block.minecraft.mossy_stone_bricks": "ಪಾಚಿ ಕಲ್ಲು ಇಟ್ಟಿಗೆಗಳು",
  "block.minecraft.moving_piston": "ಮೂವಿಂಗ್ ಪಿಸ್ಟನ್",
  "block.minecraft.mud": "ಕೆಸರು",
  "block.minecraft.mud_brick_slab": "ಮಣ್ಣಿನ ಇಟ್ಟಿಗೆ ಚಪ್ಪಡಿ",
  "block.minecraft.mud_brick_stairs": "ಮಣ್ಣಿನ ಇಟ್ಟಿಗೆ ಮೆಟ್ಟಿಲು",
  "block.minecraft.mud_brick_wall": "ಮಣ್ಣಿನ ಇಟ್ಟಿಗೆ ಗೋಡೆ",
  "block.minecraft.mud_bricks": "ಮಣ್ಣಿನ ಇಟ್ಟಿಗೆಗಳು",
  "block.minecraft.muddy_mangrove_roots": "ಮಡ್ಡಿ ಮ್ಯಾಂಗ್ರೋವ್ ಬೇರುಗಳು",
  "block.minecraft.mushroom_stem": "\nಮಶ್ರೂಮ್ ಕಾಂಡ",
  "block.minecraft.mycelium": "ಕವಕಜಾಲ",
  "block.minecraft.nether_brick_fence": "ನೆದರ್ ಬ್ರಿಕ್ ಬೇಲಿ",
  "block.minecraft.nether_brick_slab": "ನೆದರ್ ಬ್ರಿಕ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.nether_brick_stairs": "ನೆದರ್ ಬ್ರಿಕ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.nether_brick_wall": "ನೆದರ್ ಇಟ್ಟಿಗೆ ಗೋಡೆ",
  "block.minecraft.nether_bricks": "ನೆದರ್ ಇಟ್ಟಿಗೆಗಳು",
  "block.minecraft.nether_gold_ore": "ಹೆಲ್ ನ ಚಿನ್ನದ ಅದಿರು",
  "block.minecraft.nether_portal": "ನೆದರ್ ಪೋರ್ಟಲ್",
  "block.minecraft.nether_quartz_ore": "ನೆದರ್ ಸ್ಫಟಿಕ ಅದಿರು",
  "block.minecraft.nether_sprouts": "ನೆದರ್ ಮೊಗ್ಗುಗಳು",
  "block.minecraft.nether_wart": "ನೆದರ್ ನರಹುಲಿ",
  "block.minecraft.nether_wart_block": "ನೆದರ್ ವಾರ್ಟ್ ಬ್ಲಾಕ್",
  "block.minecraft.netherite_block": "ನೆದರೈಟ್ನ ಬ್ಲಾಕ್",
  "block.minecraft.netherrack": "ನೆದರ್ರಾಕ್",
  "block.minecraft.note_block": "ಟಿಪ್ಪಣಿ ಬ್ಲಾಕ್",
  "block.minecraft.oak_button": "ಓಕ್ ಬಟನ್",
  "block.minecraft.oak_door": "ಓಕ್ ಬಾಗಿಲು",
  "block.minecraft.oak_fence": "ಓಕ್ ಬೇಲಿ",
  "block.minecraft.oak_fence_gate": "ಓಕ್ ಫೆನ್ಸ್ ಗೇಟ್",
  "block.minecraft.oak_hanging_sign": "Oak Hanging Sign",
  "block.minecraft.oak_leaves": "ಓಕ್ ಎಲೆಗಳು",
  "block.minecraft.oak_log": "ಓಕ್ ಲಾಗ್",
  "block.minecraft.oak_planks": "ಓಕ್ ಹಲಗೆಗಳು",
  "block.minecraft.oak_pressure_plate": "ಓಕ್ ಒತ್ತಡದ ಪ್ಲೇಟ್",
  "block.minecraft.oak_sapling": "ಓಕ್ ಸಸಿಲಿಂಗ್",
  "block.minecraft.oak_shelf": "Oak Shelf",
  "block.minecraft.oak_sign": "ಓಕ್ ಚಿಹ್ನೆ",
  "block.minecraft.oak_slab": "ಓಕ್ ಚಪ್ಪಡಿ",
  "block.minecraft.oak_stairs": "ಓಕ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.oak_trapdoor": "ಓಕ್ ಟ್ರ್ಯಾಪ್ಡೂರ್",
  "block.minecraft.oak_wall_hanging_sign": "Oak Wall Hanging Sign",
  "block.minecraft.oak_wall_sign": "ಓಕ್ ವಾಲ್ ಚಿಹ್ನೆ",
  "block.minecraft.oak_wood": "ಓಕ್ ಕಟ್ಟಿಗೆ",
  "block.minecraft.observer": "ವೀಕ್ಷಕ",
  "block.minecraft.obsidian": "ಒಬ್ಸಿಡಿಯನ್",
  "block.minecraft.ochre_froglight": "ಓಚರ್ ಫ್ರಾಗ್ಲೈಟ್",
  "block.minecraft.ominous_banner": "ಅಶುಭ ಬ್ಯಾನರ್",
  "block.minecraft.open_eyeblossom": "Open Eyeblossom",
  "block.minecraft.orange_banner": "\nಕಿತ್ತಳೆ ಬ್ಯಾನರ್",
  "block.minecraft.orange_bed": "ಕಿತ್ತಳೆ ಹಾಸಿಗೆ",
  "block.minecraft.orange_candle": "ಕಿತ್ತಳೆ ಕ್ಯಾಂಡಲ್",
  "block.minecraft.orange_candle_cake": "Kittaḷe kyāṇḍalnondige kēk",
  "block.minecraft.orange_carpet": "\nಕಿತ್ತಳೆ ಕಾರ್ಪೆಟ್",
  "block.minecraft.orange_concrete": "\nಕಿತ್ತಳೆ ಕಾಂಕ್ರೀಟ್",
  "block.minecraft.orange_concrete_powder": "ಕಿತ್ತಳೆ ಕಾಂಕ್ರೀಟ್ ಪುಡಿ",
  "block.minecraft.orange_glazed_terracotta": "ಕಿತ್ತಳೆ ಮೆರುಗಿನ ಟೆರಾಕೋಟಾ",
  "block.minecraft.orange_shulker_box": "\nಕಿತ್ತಳೆ ಶಲ್ಕರ್ ಬಾಕ್ಸ್",
  "block.minecraft.orange_stained_glass": "ಕಿತ್ತಳೆ ಬಣ್ಣದ ಗಾಜು",
  "block.minecraft.orange_stained_glass_pane": "ಕಿತ್ತಳೆ ಬಣ್ಣದ ಗಾಜಿನ ಫಲಕ",
  "block.minecraft.orange_terracotta": "ಕಿತ್ತಳೆ ಟೆರಾಕೋಟಾ",
  "block.minecraft.orange_tulip": "ಕಿತ್ತಳೆ ತುಲಿಪ್",
  "block.minecraft.orange_wool": "ಕಿತ್ತಳೆ ಉಣ್ಣೆ",
  "block.minecraft.oxeye_daisy": "\nಆಕ್ಸೀ ಡೈಸಿ",
  "block.minecraft.oxidized_chiseled_copper": "Oxidized Chiseled Copper",
  "block.minecraft.oxidized_copper": "ಉತ್ಕರ್ಷಿಸು ಎರವೆ",
  "block.minecraft.oxidized_copper_bars": "Oxidized Copper Bars",
  "block.minecraft.oxidized_copper_bulb": "Oxidized Copper Bulb",
  "block.minecraft.oxidized_copper_chain": "Oxidized Copper Chain",
  "block.minecraft.oxidized_copper_chest": "Oxidized Copper Chest",
  "block.minecraft.oxidized_copper_door": "Oxidized Copper Door",
  "block.minecraft.oxidized_copper_golem_statue": "Oxidized Copper Golem Statue",
  "block.minecraft.oxidized_copper_grate": "Oxidized Copper Grate",
  "block.minecraft.oxidized_copper_lantern": "Oxidized Copper Lantern",
  "block.minecraft.oxidized_copper_trapdoor": "Oxidized Copper Trapdoor",
  "block.minecraft.oxidized_cut_copper": "ಉತ್ಕರ್ಷಿಸು ಗಾಯ ಎರವೆ",
  "block.minecraft.oxidized_cut_copper_slab": "ಆಕ್ಸಿಡೀಕೃತ ಕಟ್ ಕಾಪರ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.oxidized_cut_copper_stairs": "ಆಕ್ಸಿಡೀಕೃತ ಕಟ್ ಕಾಪರ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.oxidized_lightning_rod": "Oxidized Lightning Rod",
  "block.minecraft.packed_ice": "ಪ್ಯಾಕ್ಡ್ ಐಸ್",
  "block.minecraft.packed_mud": "ಪ್ಯಾಕ್ ಮಾಡಿದ ಮಣ್ಣು",
  "block.minecraft.pale_hanging_moss": "Pale Hanging Moss",
  "block.minecraft.pale_moss_block": "Pale Moss Block",
  "block.minecraft.pale_moss_carpet": "Pale Moss Carpet",
  "block.minecraft.pale_oak_button": "Pale Oak Button",
  "block.minecraft.pale_oak_door": "Pale Oak Door",
  "block.minecraft.pale_oak_fence": "Pale Oak Fence",
  "block.minecraft.pale_oak_fence_gate": "Pale Oak Fence Gate",
  "block.minecraft.pale_oak_hanging_sign": "Pale Oak Hanging Sign",
  "block.minecraft.pale_oak_leaves": "Pale Oak Leaves",
  "block.minecraft.pale_oak_log": "Pale Oak Log",
  "block.minecraft.pale_oak_planks": "Pale Oak Planks",
  "block.minecraft.pale_oak_pressure_plate": "Pale Oak Pressure Plate",
  "block.minecraft.pale_oak_sapling": "Pale Oak Sapling",
  "block.minecraft.pale_oak_shelf": "Pale Oak Shelf",
  "block.minecraft.pale_oak_sign": "Pale Oak Sign",
  "block.minecraft.pale_oak_slab": "Pale Oak Slab",
  "block.minecraft.pale_oak_stairs": "Pale Oak Stairs",
  "block.minecraft.pale_oak_trapdoor": "Pale Oak Trapdoor",
  "block.minecraft.pale_oak_wall_hanging_sign": "Pale Oak Wall Hanging Sign",
  "block.minecraft.pale_oak_wall_sign": "Pale Oak Wall Sign",
  "block.minecraft.pale_oak_wood": "Pale Oak Wood",
  "block.minecraft.pearlescent_froglight": "ಪಿಯರ್ಲೆಸೆಂಟ್ ಫ್ರಾಗ್ಲೈಟ್",
  "block.minecraft.peony": "ಪಿಯೋನಿ",
  "block.minecraft.petrified_oak_slab": "ಪೆಟ್ರಿಫೈಡ್ ಓಕ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.piglin_head": "Piglin Head",
  "block.minecraft.piglin_wall_head": "Piglin Wall Head",
  "block.minecraft.pink_banner": "ಪಿಂಕ್ ಬ್ಯಾನರ್",
  "block.minecraft.pink_bed": "ಗುಲಾಬಿ ಹಾಸಿಗೆ",
  "block.minecraft.pink_candle": "ಗುಲಾಬಿ ಕ್ಯಾಂಡಲ್",
  "block.minecraft.pink_candle_cake": "Piṅk kyāṇḍalnondige kēk",
  "block.minecraft.pink_carpet": "ಗುಲಾಬಿ ಕಾರ್ಪೆಟ್",
  "block.minecraft.pink_concrete": "ಗುಲಾಬಿ ಕಾಂಕ್ರೀಟ್",
  "block.minecraft.pink_concrete_powder": "ಗುಲಾಬಿ ಕಾಂಕ್ರೀಟ್ ಪುಡಿ",
  "block.minecraft.pink_glazed_terracotta": "ಪಿಂಕ್ ಮೆರುಗುಗೊಳಿಸಲಾದ ಟೆರಾಕೋಟಾ",
  "block.minecraft.pink_petals": "Pink Petals",
  "block.minecraft.pink_shulker_box": "ಗುಲಾಬಿ ಶಲ್ಕರ್ ಬಾಕ್ಸ್",
  "block.minecraft.pink_stained_glass": "ಗುಲಾಬಿ ಬಣ್ಣದ ಗಾಜು",
  "block.minecraft.pink_stained_glass_pane": "ಗುಲಾಬಿ ಬಣ್ಣದ ಗಾಜಿನ ಫಲಕ",
  "block.minecraft.pink_terracotta": "ಪಿಂಕ್ ಟೆರಾಕೋಟಾ",
  "block.minecraft.pink_tulip": "\nಗುಲಾಬಿ ತುಲಿಪ್",
  "block.minecraft.pink_wool": "ಗುಲಾಬಿ ಉಣ್ಣೆ",
  "block.minecraft.piston": "\nಪಿಸ್ಟನ್",
  "block.minecraft.piston_head": "ಪಿಸ್ಟನ್ ಹೆಡ್",
  "block.minecraft.pitcher_crop": "ಹೂಜಿ ಬೆಳೆ",
  "block.minecraft.pitcher_plant": "ಪಿಚರ್ ಪ್ಲಾಂಟ್",
  "block.minecraft.player_head": "ಆಟಗಾರನ ತಲೆ",
  "block.minecraft.player_head.named": "%s ತಲೆ",
  "block.minecraft.player_wall_head": "ಪ್ಲೇಯರ್ ವಾಲ್ ಹೆಡ್",
  "block.minecraft.podzol": "ಪೊಡ್ಜೋಲ್",
  "block.minecraft.pointed_dripstone": "ಪಾಯಿಂಟ್ ಡ್ರಿಪ್ಸ್ಟೋನ್",
  "block.minecraft.polished_andesite": "ನಯಗೊಳಿಸಿದ ಅಂಡಿಸೈಟ್",
  "block.minecraft.polished_andesite_slab": "ನಯಗೊಳಿಸಿದ ಅಂಡಿಸೈಟ್ ಚಪ್ಪಡಿ",
  "block.minecraft.polished_andesite_stairs": "ಪಾಲಿಶ್ ಆಂಡೆಸೈಟ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.polished_basalt": "ನಯಗೊಳಿಸಿದ ಬಸಾಲ್ಟ್",
  "block.minecraft.polished_blackstone": "ನಯಗೊಳಿಸಿದ ಬ್ಲಾಕ್‌ಸ್ಟೋನ್",
  "block.minecraft.polished_blackstone_brick_slab": "ನಯಗೊಳಿಸಿದ ಬ್ಲಾಕ್‌ಸ್ಟೋನ್ ಇಟ್ಟಿಗೆಗಳು",
  "block.minecraft.polished_blackstone_brick_stairs": "ನಯಗೊಳಿಸಿದ ಬ್ಲಾಕ್‌ಸ್ಟೋನ್ ಇಟ್ಟಿಗೆ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.polished_blackstone_brick_wall": "ನಯಗೊಳಿಸಿದ ಬ್ಲಾಕ್‌ಸ್ಟೋನ್ ಇಟ್ಟಿಗೆ ಗೋಡೆ",
  "block.minecraft.polished_blackstone_bricks": "ನಯಗೊಳಿಸಿದ ಬ್ಲಾಕ್‌ಸ್ಟೋನ್ ಇಟ್ಟಿಗೆಗಳು",
  "block.minecraft.polished_blackstone_button": "ನಯಗೊಳಿಸಿದ ಬ್ಲಾಕ್‌ಸ್ಟೋನ್ ಬಟನ್",
  "block.minecraft.polished_blackstone_pressure_plate": "ನಯಗೊಳಿಸಿದ ಬ್ಲಾಕ್‌ಸ್ಟೋನ್ ಪ್ರೆಶರ್ ಪ್ಲೇಟ್",
  "block.minecraft.polished_blackstone_slab": "ನಯಗೊಳಿಸಿದ ಬ್ಲಾಕ್‌ಸ್ಟೋನ್ ಚಪ್ಪಡಿ",
  "block.minecraft.polished_blackstone_stairs": "ನಯಗೊಳಿಸಿದ ಬ್ಲಾಕ್‌ಸ್ಟೋನ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.polished_blackstone_wall": "ನಯಗೊಳಿಸಿದ ಬ್ಲಾಕ್‌ಸ್ಟೋನ್ ವಾಲ್",
  "block.minecraft.polished_deepslate": "ನಯಗೊಳಿಸಿದ ಡೀಪ್ಸ್ಲೇಟ್",
  "block.minecraft.polished_deepslate_slab": "ನಯಗೊಳಿಸಿದ ಡೀಪ್ಸ್ಲೇಟ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.polished_deepslate_stairs": "ನಯಗೊಳಿಸಿದ ಆಳವಾದ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.polished_deepslate_wall": "ನಯಗೊಳಿಸಿದ ಆಳವಾದ ಗೋಡೆ",
  "block.minecraft.polished_diorite": "ಪಾಲಿಶ್ಡ್ ಡಿಯೊರೈಟ್",
  "block.minecraft.polished_diorite_slab": "ಪಾಲಿಶ್ಡ್ ಡಿಯೊರೈಟ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.polished_diorite_stairs": "ಪಾಲಿಶ್ಡ್ ಡಿಯೊರೈಟ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.polished_granite": "ನಯಗೊಳಿಸಿದ ಗ್ರಾನೈಟ್",
  "block.minecraft.polished_granite_slab": "ನಯಗೊಳಿಸಿದ ಗ್ರಾನೈಟ್ ಚಪ್ಪಡಿ",
  "block.minecraft.polished_granite_stairs": "ನಯಗೊಳಿಸಿದ ಗ್ರಾನೈಟ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.polished_tuff": "Polished Tuff",
  "block.minecraft.polished_tuff_slab": "Polished Tuff Slab",
  "block.minecraft.polished_tuff_stairs": "Polished Tuff Stairs",
  "block.minecraft.polished_tuff_wall": "Polished Tuff Wall",
  "block.minecraft.poppy": "ಗಸಗಸೆ",
  "block.minecraft.potatoes": "ಆಲೂಗಡ್ಡೆ",
  "block.minecraft.potted_acacia_sapling": "ಪಾಟ್ ಅಕೇಶಿಯ ಸಪ್ಲಿಂಗ್",
  "block.minecraft.potted_allium": "ಪಾಟ್ ಆಲಿಯಮ್",
  "block.minecraft.potted_azalea_bush": "Pāṭḍ ajēliyā",
  "block.minecraft.potted_azure_bluet": "ಪಾಟ್ಡ್ ಅಜುರೆ ಬ್ಲೂಟ್",
  "block.minecraft.potted_bamboo": "ಪಾಟ್ ಬಿದಿರು",
  "block.minecraft.potted_birch_sapling": "ಪಾಟ್ ಬಿರ್ಚ್ ಸಪ್ಲಿಂಗ್",
  "block.minecraft.potted_blue_orchid": "ಪಾಟ್ಡ್ ಬ್ಲೂ ಆರ್ಕಿಡ್",
  "block.minecraft.potted_brown_mushroom": "ಪಾಟ್ ಬ್ರೌನ್ ಮಶ್ರೂಮ್",
  "block.minecraft.potted_cactus": "ಪಾಟ್ಡ್ ಕಳ್ಳಿ",
  "block.minecraft.potted_cherry_sapling": "Potted Cherry Sapling",
  "block.minecraft.potted_closed_eyeblossom": "Potted Closed Eyeblossom",
  "block.minecraft.potted_cornflower": "ಪುಸ್ತಕಗಳು ಕಾರ್ನ್ ಫ್ಲವರ್",
  "block.minecraft.potted_crimson_fungus": "ಪಾಟ್ ಮಾಡಿದ ಕ್ರಿಮ್ಸನ್ ಶಿಲೀಂಧ್ರ",
  "block.minecraft.potted_crimson_roots": "ಪಾಟ್ಡ್ ಕ್ರಿಮ್ಸನ್ ರೂಟ್ಸ್",
  "block.minecraft.potted_dandelion": "ಪಾಕೆಟ್ ಡಾಂಡೇಲಿಯನ್",
  "block.minecraft.potted_dark_oak_sapling": "ಪಾಟ್ ಡಾರ್ಕ್ ಓಕ್ ಸಸಿಲಿಂಗ್",
  "block.minecraft.potted_dead_bush": "ಪಾಟ್ಡ್ ಡೆಡ್ ಬುಷ್",
  "block.minecraft.potted_fern": "ಪಾಟ್ಡ್ ಫರ್ನ್",
  "block.minecraft.potted_flowering_azalea_bush": "Pāṭḍ hūbiḍuva ajēliyā",
  "block.minecraft.potted_golden_dandelion": "Potted Golden Dandelion",
  "block.minecraft.potted_jungle_sapling": "ಪುಸ್ತಕಗಳು ಜಂಗಲ್ ಸಪ್ಲಿಂಗ್",
  "block.minecraft.potted_lily_of_the_valley": "ಕಣಿವೆಯ ಪಾಟ್ ಲಿಲಿ",
  "block.minecraft.potted_mangrove_propagule": "ಕುಂಡದಲ್ಲಿ ಹಾಕಿದ ಮ್ಯಾಂಗ್ರೋವ್ ಪ್ರೊಪಗುಲ್ಗಳು",
  "block.minecraft.potted_oak_sapling": "ಪುಸ್ತಕಗಳು ಓಕ್ ಸಸಿ",
  "block.minecraft.potted_open_eyeblossom": "Potted Open Eyeblossom",
  "block.minecraft.potted_orange_tulip": "ಪಾಟ್ಡ್ ಆರೆಂಜ್ ಟುಲಿಪ್",
  "block.minecraft.potted_oxeye_daisy": "ಪಾಟ್ಡ್ ಆಕ್ಸೀ ಡೈಸಿ",
  "block.minecraft.potted_pale_oak_sapling": "Potted Pale Oak Sapling",
  "block.minecraft.potted_pink_tulip": "ಪಾಟ್ಡ್ ಪಿಂಕ್ ಟುಲಿಪ್",
  "block.minecraft.potted_poppy": "ಪಾಟ್ ಗಸಗಸೆ",
  "block.minecraft.potted_red_mushroom": "ಪಾಟ್ ಮಾಡಿದ ಕೆಂಪು ಮಶ್ರೂಮ್",
  "block.minecraft.potted_red_tulip": "ಪಾಟ್ಡ್ ರೆಡ್ ಟುಲಿಪ್",
  "block.minecraft.potted_spruce_sapling": "ಪಾಟ್ ಸ್ಪ್ರೂಸ್ ಸಪ್ಲಿಂಗ್",
  "block.minecraft.potted_torchflower": "Potted Torchflower",
  "block.minecraft.potted_warped_fungus": "ಪಾಟ್ಡ್ ವಾರ್ಪ್ಡ್ ಫಂಗಸ್",
  "block.minecraft.potted_warped_roots": "ಪಾಟ್ಡ್ ವಾರ್ಪ್ಡ್ ರೂಟ್ಸ್",
  "block.minecraft.potted_white_tulip": "ಪಾಟ್ ವೈಟ್ ಟುಲಿಪ್",
  "block.minecraft.potted_wither_rose": "ಪುಸ್ತಕಗಳು ವಿದರ್ಸ್ ರೋಸ್",
  "block.minecraft.powder_snow": "ಪುಡಿ ಹಿಮ",
  "block.minecraft.powder_snow_cauldron": "ಪೌಡರ್ ಸ್ನೋ ಕೌಲ್ಡ್ರಾನ್",
  "block.minecraft.powered_rail": "\nಚಾಲಿತ ರೈಲು",
  "block.minecraft.prismarine": "ಪ್ರಿಸ್ಮರಿನ್",
  "block.minecraft.prismarine_brick_slab": "ಪ್ರಿಸ್ಮರಿನ್ ಬ್ರಿಕ್ ಚಪ್ಪಡಿ",
  "block.minecraft.prismarine_brick_stairs": "ಪ್ರಿಸ್ಮರಿನ್ ಬ್ರಿಕ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.prismarine_bricks": "ಪ್ರಿಸ್ಮರಿನ್ ಬ್ರಿಕ್ಸ್",
  "block.minecraft.prismarine_slab": "ಪ್ರಿಸ್ಮರಿನ್ ಚಪ್ಪಡಿ",
  "block.minecraft.prismarine_stairs": "ಪ್ರಿಸ್ಮರಿನ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.prismarine_wall": "ಪ್ರಿಸ್ಮರಿನ್ ಗೋಡೆ",
  "block.minecraft.pumpkin": "ಕುಂಬಳಕಾಯಿ",
  "block.minecraft.pumpkin_stem": "\nಕುಂಬಳಕಾಯಿ ಕಾಂಡ",
  "block.minecraft.purple_banner": "ನೇರಳೆ ಬ್ಯಾನರ್",
  "block.minecraft.purple_bed": "ನೇರಳೆ ಹಾಸಿಗೆ",
  "block.minecraft.purple_candle": "ನೇರಳೆ ಕ್ಯಾಂಡಲ್",
  "block.minecraft.purple_candle_cake": "Kennēraḷe mēṇadabattiyondige kēk",
  "block.minecraft.purple_carpet": "ನೇರಳೆ ಕಾರ್ಪೆಟ್",
  "block.minecraft.purple_concrete": "ನೇರಳೆ ಕಾಂಕ್ರೀಟ್",
  "block.minecraft.purple_concrete_powder": "ನೇರಳೆ ಕಾಂಕ್ರೀಟ್ ಪುಡಿ",
  "block.minecraft.purple_glazed_terracotta": "ಪರ್ಪಲ್ ಗ್ಲೇಜ್ಡ್ ಟೆರಾಕೋಟಾ",
  "block.minecraft.purple_shulker_box": "\nಪರ್ಪಲ್ ಶಲ್ಕರ್ ಬಾಕ್ಸ್",
  "block.minecraft.purple_stained_glass": "ಕೆನ್ನೇರಳೆ ಬಣ್ಣದ ಗಾಜು",
  "block.minecraft.purple_stained_glass_pane": "ಪರ್ಪಲ್ ಸ್ಟೇನ್ಡ್ ಗ್ಲಾಸ್ ಪೇನ್",
  "block.minecraft.purple_terracotta": "ಪರ್ಪಲ್ ಟೆರಾಕೋಟಾ",
  "block.minecraft.purple_wool": "ನೇರಳೆ ಉಣ್ಣೆ",
  "block.minecraft.purpur_block": "\nಪುರ್ಪುರ್ ಬ್ಲಾಕ್",
  "block.minecraft.purpur_pillar": "ಪುರ್ಪುರ್ ಕಂಬ",
  "block.minecraft.purpur_slab": "ಪುರ್ಪುರ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.purpur_stairs": "ಪುರ್ಪುರ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.quartz_block": "ಸ್ಫಟಿಕ ಶಿಲೆ",
  "block.minecraft.quartz_bricks": "ಸ್ಫಟಿಕ ಇಟ್ಟಿಗೆಗಳು",
  "block.minecraft.quartz_pillar": "\nಸ್ಫಟಿಕ ಕಂಬ",
  "block.minecraft.quartz_slab": "\nಸ್ಫಟಿಕ ಚಪ್ಪಡಿ",
  "block.minecraft.quartz_stairs": "\nಸ್ಫಟಿಕ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.rail": "ರೈಲು",
  "block.minecraft.raw_copper_block": "ಬ್ಲಾಕ್ ಕಚ್ಚಾ ತಾಮ್ರದ",
  "block.minecraft.raw_gold_block": "ಕಚ್ಚಾ ಚಿನ್ನದ ನಿರ್ಬಂಧ",
  "block.minecraft.raw_iron_block": "ಬ್ಲಾಕ್ ಕಚ್ಚಾ ಕಬ್ಬಿಣ",
  "block.minecraft.red_banner": "ಕೆಂಪು ಬ್ಯಾನರ್",
  "block.minecraft.red_bed": "ಕೆಂಪು ಹಾಸಿಗೆ",
  "block.minecraft.red_candle": "ಕೆಂಪು ಕ್ಯಾಂಡಲ್",
  "block.minecraft.red_candle_cake": "ಕೆಂಪು ಕ್ಯಾಂಡಲ್ನೊಂದಿಗೆ ಕೇಕ್",
  "block.minecraft.red_carpet": "ಕೆಂಪು ಕಾರ್ಪೆಟ್",
  "block.minecraft.red_concrete": "ಕೆಂಪು ಕಾಂಕ್ರೀಟ್",
  "block.minecraft.red_concrete_powder": "ಕೆಂಪು ಕಾಂಕ್ರೀಟ್ ಪುಡಿ",
  "block.minecraft.red_glazed_terracotta": "ಕೆಂಪು ಮೆರುಗಿನ ಟೆರಾಕೋಟಾ",
  "block.minecraft.red_mushroom": "ಕೆಂಪು ಮಶ್ರೂಮ್",
  "block.minecraft.red_mushroom_block": "ಕೆಂಪು ಮಶ್ರೂಮ್ ಬ್ಲಾಕ್",
  "block.minecraft.red_nether_brick_slab": "ಕೆಂಪು ನೆದರ್ ಇಟ್ಟಿಗೆ ಚಪ್ಪಡಿ",
  "block.minecraft.red_nether_brick_stairs": "ಕೆಂಪು ನೆದರ್ ಇಟ್ಟಿಗೆ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.red_nether_brick_wall": "ಕೆಂಪು ನೆದರ್ ಇಟ್ಟಿಗೆ ಗೋಡೆ",
  "block.minecraft.red_nether_bricks": "ಕೆಂಪು ನೆದರ್ ಇಟ್ಟಿಗೆಗಳು",
  "block.minecraft.red_sand": "ಕೆಂಪು ಮರಳು",
  "block.minecraft.red_sandstone": "ಕೆಂಪು ಮರಳುಗಲ್ಲು",
  "block.minecraft.red_sandstone_slab": "ಕೆಂಪು ಮರಳುಗಲ್ಲಿನ ಚಪ್ಪಡಿ",
  "block.minecraft.red_sandstone_stairs": "\nಕೆಂಪು ಮರಳುಗಲ್ಲಿನ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.red_sandstone_wall": "ಕೆಂಪು ಮರಳುಗಲ್ಲು ಗೋಡೆ",
  "block.minecraft.red_shulker_box": "ಕೆಂಪು ಶಲ್ಕರ್ ಬಾಕ್ಸ್",
  "block.minecraft.red_stained_glass": "ಕೆಂಪು ಬಣ್ಣದ ಗಾಜು",
  "block.minecraft.red_stained_glass_pane": "ಕೆಂಪು ಬಣ್ಣದ ಗಾಜಿನ ಫಲಕ",
  "block.minecraft.red_terracotta": "ಕೆಂಪು ಟೆರಾಕೋಟಾ",
  "block.minecraft.red_tulip": "ಕೆಂಪು ಟುಲಿಪ್",
  "block.minecraft.red_wool": "ಕೆಂಪು ಉಣ್ಣೆ",
  "block.minecraft.redstone_block": "ರೆಡ್ಸ್ಟೋನ್ ಘನಗ",
  "block.minecraft.redstone_lamp": "ರೆಡ್ಸ್ಟೋನ್ ಲ್ಯಾಂಪ್",
  "block.minecraft.redstone_ore": "ರೆಡ್‌ಸ್ಟೋನ್ ಅದಿರು",
  "block.minecraft.redstone_torch": "ರೆಡ್ಸ್ಟೋನ್ ಟಾರ್ಚ್",
  "block.minecraft.redstone_wall_torch": "ರೆಡ್‌ಸ್ಟೋನ್ ವಾಲ್ ಟಾರ್ಚ್",
  "block.minecraft.redstone_wire": "ರೆಡ್ಸ್ಟೋನ್ ವೈರ್",
  "block.minecraft.reinforced_deepslate": "ಬಲವರ್ಧಿತ ಡೀಪ್ಸ್ಲೇಟ್",
  "block.minecraft.repeater": "ರೆಡ್ಸ್ಟೋನ್ ರೆಡಿ",
  "block.minecraft.repeating_command_block": "ಕಮಾಂಡ್ ಬ್ಲಾಕ್ ಅನ್ನು ಪುನರಾವರ್ತಿಸಲಾಗುತ್ತಿದೆ",
  "block.minecraft.resin_block": "Block of Resin",
  "block.minecraft.resin_brick_slab": "Resin Brick Slab",
  "block.minecraft.resin_brick_stairs": "Resin Brick Stairs",
  "block.minecraft.resin_brick_wall": "Resin Brick Wall",
  "block.minecraft.resin_bricks": "Resin Bricks",
  "block.minecraft.resin_clump": "Resin Clump",
  "block.minecraft.respawn_anchor": "ರೆಸ್ಪಾನ್ ಆಂಕರ್",
  "block.minecraft.rooted_dirt": "ಬ್ಲಾಕ್ಮಿ. ನೆಕ್ರಾಫ್ಟ್ಬೇ. ರೂರಿದೆ. ಕೊಳಕು",
  "block.minecraft.rose_bush": "\nರೋಸ್ ಬುಷ್",
  "block.minecraft.sand": "ಕೆಂಪು",
  "block.minecraft.sandstone": "ಮರಳುಗಲ್ಲು",
  "block.minecraft.sandstone_slab": "ಮರಳುಗಲ್ಲು ಚಪ್ಪಡಿ",
  "block.minecraft.sandstone_stairs": "ಮರಳುಗಲ್ಲಿನ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.sandstone_wall": "ಮರಳುಗಲ್ಲಿನ ಗೋಡೆ",
  "block.minecraft.scaffolding": "ಸ್ಕ್ಯಾಫೋಲ್ಡಿಂಗ್",
  "block.minecraft.sculk": "ಸ್ಕಲ್ಕ್",
  "block.minecraft.sculk_catalyst": "ಸ್ಕಲ್ಕ್ ಕ್ಯಾಟಲಿಸ್ಟ್",
  "block.minecraft.sculk_sensor": "ಸ್ಕಲ್ಕ್ ಸೆನ್ಸರ್",
  "block.minecraft.sculk_shrieker": "ಸ್ಕಲ್ಕ್ ಶ್ರೀಕರ್",
  "block.minecraft.sculk_vein": "ಸ್ಕಲ್ಕ್ ಸಿರೆ",
  "block.minecraft.sea_lantern": "ಸೀ ಲ್ಯಾಂಟರ್ನ್",
  "block.minecraft.sea_pickle": "ಸಮುದ್ರ ಉಪ್ಪಿನಕಾಯಿ",
  "block.minecraft.seagrass": "ಸೀಗ್ರಾಸ್",
  "block.minecraft.set_spawn": "\nರೆಸ್ಪಾನ್ ಪಾಯಿಂಟ್ ಸೆಟ್",
  "block.minecraft.short_dry_grass": "Short Dry Grass",
  "block.minecraft.short_grass": "ಸಣ್ಣ ಹುಲ್ಲು",
  "block.minecraft.shroomlight": "ಶ್ರೂಮ್ಲೈಟ್",
  "block.minecraft.shulker_box": "ಶುಲ್ಕರ್ ಬಾಕ್ಸ್",
  "block.minecraft.skeleton_skull": "ಅಸ್ಥಿಪಂಜರ ತಲೆಬುರುಡೆ",
  "block.minecraft.skeleton_wall_skull": "ಸ್ಕೆಲಿಟನ್ ವಾಲ್ ಸ್ಕಲ್",
  "block.minecraft.slime_block": "\nಲೋಳೆ ಬ್ಲಾಕ್",
  "block.minecraft.small_amethyst_bud": "ಸಣ್ಣ ಅಮೆಥಿಸ್ಟ್ ಬಡ್",
  "block.minecraft.small_dripleaf": "ಸಣ್ಣ ಚುಟುಕು ಎಲೆ",
  "block.minecraft.smithing_table": "ಸ್ಮಿಮಿಂಗ್ ಟೇಬಲ್",
  "block.minecraft.smoker": "ಧೂಮಪಾನಿ",
  "block.minecraft.smooth_basalt": "ಸ್ಮೂತ್ ಬಸಾಲ್ಟ್",
  "block.minecraft.smooth_quartz": "ಸುಗಮ ಸ್ಫಟಿಕ ಬ್ಲಾಕ್",
  "block.minecraft.smooth_quartz_slab": "ಸ್ಮೂತ್ ಸ್ಫಟಿಕ ಚಪ್ಪಡಿ",
  "block.minecraft.smooth_quartz_stairs": "ಸ್ಮೂತ್ ಸ್ಫಟಿಕ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.smooth_red_sandstone": "ನಯವಾದ ಕೆಂಪು ಮರಳುಗಲ್ಲು",
  "block.minecraft.smooth_red_sandstone_slab": "ಸ್ಮೂತ್ ರೆಡ್ ಸ್ಯಾಂಡ್ಸ್ಟೋನ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.smooth_red_sandstone_stairs": "ಸ್ಮೂತ್ ರೆಡ್ ಸ್ಯಾಂಡ್ಸ್ಟೋನ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.smooth_sandstone": "\nನಯವಾದ ಮರಳುಗಲ್ಲು",
  "block.minecraft.smooth_sandstone_slab": "ಸ್ಮೂತ್ ಸ್ಯಾಂಡ್ಸ್ಟೋನ್ ಚಪ್ಪಡಿ",
  "block.minecraft.smooth_sandstone_stairs": "ಸ್ಮೂತ್ ಸ್ಯಾಂಡ್ಸ್ಟೋನ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.smooth_stone": "\nನಯವಾದ ಕಲ್ಲು",
  "block.minecraft.smooth_stone_slab": "ಸ್ಮೂತ್ ಸ್ಟೋನ್ ಚಪ್ಪಡಿ",
  "block.minecraft.sniffer_egg": "ಸ್ನಿಫರ್ ಮೊಟ್ಟೆ",
  "block.minecraft.snow": "ಹಿಮ",
  "block.minecraft.snow_block": "ಹಿಮ ಘನಗ",
  "block.minecraft.soul_campfire": "ಸೋಲ್ ಕ್ಯಾಂಪ್‌ಫೈರ್",
  "block.minecraft.soul_fire": "ಆತ್ಮ ಬೆಂಕಿ",
  "block.minecraft.soul_lantern": "ಸೋಲ್ ಲ್ಯಾಂಟರ್ನ್",
  "block.minecraft.soul_sand": "ಸೋಲ್ ಸ್ಯಾಂಡ್",
  "block.minecraft.soul_soil": "ಆತ್ಮ ಮಣ್ಣು",
  "block.minecraft.soul_torch": "ಸೋಲ್ ಟಾರ್ಚ್",
  "block.minecraft.soul_wall_torch": "ಸೋಲ್ ವಾಲ್ ಟಾರ್ಚ್",
  "block.minecraft.spawn.not_valid": "ನಿಮಗೆ ಮನೆಯ ಹಾಸಿಗೆ ಅಥವಾ ಚಾರ್ಜ್ಡ್ ರೆಸ್ಪಾನ್ ಆಂಕರ್ ಇಲ್ಲ, ಅಥವಾ ಅದು ಅಡ್ಡಿಯಾಗಿದೆ",
  "block.minecraft.spawner": "Monster Spawner",
  "block.minecraft.spawner.desc1": "Interact with Spawn Egg:",
  "block.minecraft.spawner.desc2": "Sets Mob Type",
  "block.minecraft.sponge": "ಸ್ಪಾಂಜ್",
  "block.minecraft.spore_blossom": "ವಿವಾದಗಳು ಕರಗುತ್ತವೆ",
  "block.minecraft.spruce_button": "ಸ್ಪ್ರೂಸ್ ಬಟನ್",
  "block.minecraft.spruce_door": "\nಸ್ಪ್ರೂಸ್ ಡೋರ್",
  "block.minecraft.spruce_fence": "\nಸ್ಪ್ರೂಸ್ ಬೇಲಿ",
  "block.minecraft.spruce_fence_gate": "\nಸ್ಪ್ರೂಸ್ ಬೇಲಿ ಗೇಟ್",
  "block.minecraft.spruce_hanging_sign": "Spruce Hanging Sign",
  "block.minecraft.spruce_leaves": "ಸ್ಪ್ರೂಸ್ ಎಲೆಗಳು",
  "block.minecraft.spruce_log": "ಲಾಗ್ ಸ್ಪ್ರೂಸ್",
  "block.minecraft.spruce_planks": "ಸ್ಪ್ರೂಸ್ ಪ್ಲ್ಯಾಂಕ್ಸ್",
  "block.minecraft.spruce_pressure_plate": "ಸ್ಪ್ರೂಸ್ ಪ್ರೆಶರ್ ಪ್ಲೇಟ್",
  "block.minecraft.spruce_sapling": "ಸ್ಪ್ರೂಸ್ ಸಸಿಂಗ್",
  "block.minecraft.spruce_shelf": "Spruce Shelf",
  "block.minecraft.spruce_sign": "ಸ್ಪ್ರೂಸ್ ಸೈನ್",
  "block.minecraft.spruce_slab": "ಸ್ಪ್ರೂಸ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.spruce_stairs": "ಸ್ಪ್ರೂಸ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.spruce_trapdoor": "\nಸ್ಪ್ರೂಸ್ ಟ್ರ್ಯಾಪ್ಡೋರ್",
  "block.minecraft.spruce_wall_hanging_sign": "Spruce Wall Hanging Sign",
  "block.minecraft.spruce_wall_sign": "ಸ್ಪ್ರೂಸ್ ವಾಲ್ ಸೈನ್",
  "block.minecraft.spruce_wood": "ಸ್ಪ್ರೂಸ್ ವುಡ್",
  "block.minecraft.sticky_piston": "\nಸ್ಟಿಕಿ ಪಿಸ್ಟನ್",
  "block.minecraft.stone": "ಕಲ್ಲು",
  "block.minecraft.stone_brick_slab": "ಸ್ಟೋನ್ ಬ್ರಿಕ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.stone_brick_stairs": "ಕಲ್ಲು ಇಟ್ಟಿಗೆ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.stone_brick_wall": "ಕಲ್ಲಿನ ಇಟ್ಟಿಗೆ ಗೋಡೆ",
  "block.minecraft.stone_bricks": "ಕಲ್ಲು ಇಟ್ಟಿಗೆಗಳು",
  "block.minecraft.stone_button": "ಕಲ್ಲು ಬಟನ್",
  "block.minecraft.stone_pressure_plate": "ಕಲ್ಲು ಒತ್ತಡದ ಫಲಕ",
  "block.minecraft.stone_slab": "\nಸ್ಟೋನ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.stone_stairs": "ಕಲ್ಲಿನ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.stonecutter": "ಸ್ಟಾನ್ಕಾಕಿಟರ್",
  "block.minecraft.stripped_acacia_log": "ಅಕೇಶಿಯ ಲಾಗ್ ಸ್ಟ್ರಿಪ್ಡ್",
  "block.minecraft.stripped_acacia_wood": "ಅಕೇಶಿಯ ವುಡ್ ಸ್ಟ್ರಿಪ್ಡ್",
  "block.minecraft.stripped_bamboo_block": "ಸ್ಟ್ರಿಪ್ಡ್ ಬಿದಿರಿನ ಬ್ಲಾಕ್",
  "block.minecraft.stripped_birch_log": "ಬಿರ್ಚ್ ಲಾಗ್ ಸ್ಟ್ರಿಪ್ಡ್",
  "block.minecraft.stripped_birch_wood": "ಬಿರ್ಚ್ ವುಡ್ ಸ್ಟ್ರಿಪ್ಡ್",
  "block.minecraft.stripped_cherry_log": "ಸ್ಟ್ರಿಪ್ಡ್ ಚೆರ್ರಿ ಲಾಗ್",
  "block.minecraft.stripped_cherry_wood": "ಸ್ಟ್ರಿಪ್ಡ್ ಚೆರ್ರಿ ವುಡ್",
  "block.minecraft.stripped_crimson_hyphae": "ಸ್ಟ್ರಿಪ್ಡ್ ಕ್ರಿಮ್ಸನ್ ಹೈಫೇ",
  "block.minecraft.stripped_crimson_stem": "ಸ್ಟ್ರಿಪ್ಡ್ ಕ್ರಿಮ್ಸನ್ ಸ್ಟೆಮ್",
  "block.minecraft.stripped_dark_oak_log": "ಸ್ಟ್ರೈಪ್ಡ್ ಡಾರ್ಕ್ ಓಕ್ ಲಾಗ್",
  "block.minecraft.stripped_dark_oak_wood": "ಸ್ಟ್ರೈಪ್ಡ್ ಡಾರ್ಕ್ ಓಕ್ ವುಡ್",
  "block.minecraft.stripped_jungle_log": "ಸ್ಟ್ರಿಪ್ಡ್ ಜಂಗಲ್ ಲಾಗ್",
  "block.minecraft.stripped_jungle_wood": "ಸ್ಟ್ರಿಪ್ಡ್ ಜಂಗಲ್ ವುಡ್",
  "block.minecraft.stripped_mangrove_log": "ತೆಗೆದ ಮ್ಯಾಂಗ್ರೋವ್ ಲಾಗ್",
  "block.minecraft.stripped_mangrove_wood": "ಸ್ಟ್ರಿಪ್ಡ್ ಮ್ಯಾಂಗ್ರೋವ್ ವುಡ್",
  "block.minecraft.stripped_oak_log": "ಓಕ್ ಲಾಗ್ ಸ್ಟ್ರಿಪ್ಡ್",
  "block.minecraft.stripped_oak_wood": "ಓಕ್ ವುಡ್ ಸ್ಟ್ರಿಪ್ಡ್",
  "block.minecraft.stripped_pale_oak_log": "Stripped Pale Oak Log",
  "block.minecraft.stripped_pale_oak_wood": "Stripped Pale Oak Wood",
  "block.minecraft.stripped_spruce_log": "ಸ್ಟ್ರಿಪ್ಡ್ ಸ್ಪ್ರೂಸ್ ಲಾಗ್",
  "block.minecraft.stripped_spruce_wood": "ಸ್ಟ್ರಿಪ್ಡ್ ಸ್ಪ್ರೂಸ್ ವುಡ್",
  "block.minecraft.stripped_warped_hyphae": "ಸ್ಟ್ರಿಪ್ಡ್ ವಾರ್ಪ್ಡ್ ಹೈಫೇ",
  "block.minecraft.stripped_warped_stem": "ಸ್ಟ್ರಿಪ್ಡ್ ವಾರ್ಪ್ಡ್ ಕಾಂಡ",
  "block.minecraft.structure_block": "\nರಚನೆ ಬ್ಲಾಕ್",
  "block.minecraft.structure_void": "ರಚನೆಯ ನಿರರ್ಥಕ",
  "block.minecraft.sugar_cane": "ಕಬ್ಬು",
  "block.minecraft.sunflower": "ಸೂರ್ಯಕಾಂತಿ",
  "block.minecraft.suspicious_gravel": "ಅನುಮಾನಾಸ್ಪದ ಜಲ್ಲಿಕಲ್ಲು",
  "block.minecraft.suspicious_sand": "ಅನುಮಾನಾಸ್ಪದ ಮರಳು",
  "block.minecraft.sweet_berry_bush": "ಸ್ವೀಟ್ ಬೆರ್ರಿ ಬುಷ್",
  "block.minecraft.tall_dry_grass": "Tall Dry Grass",
  "block.minecraft.tall_grass": "ಎತ್ತರದ ಹುಲ್ಲು",
  "block.minecraft.tall_seagrass": "\nಎತ್ತರದ ಸೀಗ್ರಾಸ್",
  "block.minecraft.target": "ಗುರಿ",
  "block.minecraft.terracotta": "ಟೆರಾಕೋಟಾ",
  "block.minecraft.test_block": "Test Block",
  "block.minecraft.test_instance_block": "Test Instance Block",
  "block.minecraft.tinted_glass": "ಬಣ್ಣದ ಗಾಜು",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "TNT explosions are disabled",
  "block.minecraft.torch": "ಟಾರ್ಚ್",
  "block.minecraft.torchflower": "ಟಾರ್ಚ್ಫ್ಲವರ್",
  "block.minecraft.torchflower_crop": "ಟಾರ್ಚ್ ಫ್ಲವರ್ ಬೆಳೆ",
  "block.minecraft.trapped_chest": "ಸಿಕ್ಕಿಬಿದ್ದ ಎದೆ",
  "block.minecraft.trial_spawner": "Trial Spawner",
  "block.minecraft.tripwire": "ಟ್ರಿಪ್‌ವೈರ್",
  "block.minecraft.tripwire_hook": "ಟ್ರಿಪ್‌ವೈರ್ ಹುಕ್",
  "block.minecraft.tube_coral": "ಟ್ಯೂಬ್ ಕೋರಲ್",
  "block.minecraft.tube_coral_block": "ಟ್ಯೂಬ್ ಕೋರಲ್ ಬ್ಲಾಕ್",
  "block.minecraft.tube_coral_fan": "\nಟ್ಯೂಬ್ ಕೋರಲ್ ಫ್ಯಾನ್",
  "block.minecraft.tube_coral_wall_fan": "\nಟ್ಯೂಬ್ ಕೋರಲ್ ವಾಲ್ ಫ್ಯಾನ್",
  "block.minecraft.tuff": "ಟಫ್",
  "block.minecraft.tuff_brick_slab": "Tuff Brick Slab",
  "block.minecraft.tuff_brick_stairs": "Tuff Brick Stairs",
  "block.minecraft.tuff_brick_wall": "Tuff Brick Wall",
  "block.minecraft.tuff_bricks": "Tuff Bricks",
  "block.minecraft.tuff_slab": "Tuff Slab",
  "block.minecraft.tuff_stairs": "Tuff Stairs",
  "block.minecraft.tuff_wall": "Tuff Wall",
  "block.minecraft.turtle_egg": "ಆಮೆ ಎಗ್",
  "block.minecraft.twisting_vines": "ಒಂದು ವೇಳೆ",
  "block.minecraft.twisting_vines_plant": "ಟ್ವಿಸ್ಟಿಂಗ್ ವೈನ್ಸ್ ಪ್ಲಾಂಟ್",
  "block.minecraft.vault": "Vault",
  "block.minecraft.verdant_froglight": "ಹಸಿರು ಫ್ರಾಗ್ಲೈಟ್",
  "block.minecraft.vine": "ಬಳ್ಳಿಗಳು",
  "block.minecraft.void_air": "ಶೂನ್ಯ ಏರ್",
  "block.minecraft.wall_torch": "ಗೋಡೆಯ ಟಾರ್ಚ್",
  "block.minecraft.warped_button": "ರ್ಯಾಪ್ಡ್ ಬಟನ್",
  "block.minecraft.warped_door": "ರ್ಯಾಪ್ಡ್ ಡೋರ್",
  "block.minecraft.warped_fence": "ರ್ಯಾಪ್ಡ್ ಬೇಲಿ",
  "block.minecraft.warped_fence_gate": "ರ್ಯಾಪ್ಡ್ ಬೇಲಿ ಗೇಟ್",
  "block.minecraft.warped_fungus": "ರ್ಯಾಪ್ಡ್ ಶಿಲೀಂಧ್ರ",
  "block.minecraft.warped_hanging_sign": "ವಾರ್ಪ್ಡ್ ಹ್ಯಾಂಗಿಂಗ್ ಚಿಹ್ನೆ",
  "block.minecraft.warped_hyphae": "ರ್ಯಾಪ್ಡ್ ಹೈಫೇ",
  "block.minecraft.warped_nylium": "ರ್ಯಾಪ್ಡ್ ನೈಲಿಯಮ್",
  "block.minecraft.warped_planks": "ರ್ಯಾಪ್ಡ್ ಹಲಗೆಗಳು",
  "block.minecraft.warped_pressure_plate": "ರ್ಯಾಪ್ಡ್ ಪ್ರೆಶರ್ ಪ್ಲೇಟ್",
  "block.minecraft.warped_roots": "ರ್ಯಾಪ್ಡ್ ರೂಟ್ಸ್",
  "block.minecraft.warped_shelf": "Warped Shelf",
  "block.minecraft.warped_sign": "ರ್ಯಾಪ್ಡ್ ಚಿಹ್ನೆ",
  "block.minecraft.warped_slab": "ರ್ಯಾಪ್ಡ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.warped_stairs": "ರ್ಯಾಪ್ಡ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.warped_stem": "ರ್ಯಾಪ್ಡ್ ಸ್ಟೆಮ್",
  "block.minecraft.warped_trapdoor": "ರ್ಯಾಪ್ಡ್ ಟ್ರ್ಯಾಪ್ಡೋರ್",
  "block.minecraft.warped_wall_hanging_sign": "ವಾರ್ಪ್ಡ್ ವಾಲ್ ಹ್ಯಾಂಗಿಂಗ್ ಚಿಹ್ನೆ",
  "block.minecraft.warped_wall_sign": "ರ್ಯಾಪ್ಡ್ ವಾಲ್ ಸೈನ್",
  "block.minecraft.warped_wart_block": "ರ್ಯಾಪ್ಡ್ ವಾರ್ಟ್ ಬ್ಲಾಕ್",
  "block.minecraft.water": "ನೀರಿನ",
  "block.minecraft.water_cauldron": "ವಾಟರ್ ಕೌಲ್ಡ್ರಾನ್",
  "block.minecraft.waxed_chiseled_copper": "Waxed Chiseled Copper",
  "block.minecraft.waxed_copper_bars": "Waxed Copper Bars",
  "block.minecraft.waxed_copper_block": "ತಾಮ್ರದ ವ್ಯಾಕ್ಸ್ಡ್ ಬ್ಲಾಕ್",
  "block.minecraft.waxed_copper_bulb": "Waxed Copper Bulb",
  "block.minecraft.waxed_copper_chain": "Waxed Copper Chain",
  "block.minecraft.waxed_copper_chest": "Waxed Copper Chest",
  "block.minecraft.waxed_copper_door": "Waxed Copper Door",
  "block.minecraft.waxed_copper_golem_statue": "Waxed Copper Golem Statue",
  "block.minecraft.waxed_copper_grate": "Waxed Copper Grate",
  "block.minecraft.waxed_copper_lantern": "Waxed Copper Lantern",
  "block.minecraft.waxed_copper_trapdoor": "Waxed Copper Trapdoor",
  "block.minecraft.waxed_cut_copper": "ವ್ಯಾಕ್ಸ್ಡ್ ಕಟ್ ಕಾಪರ್",
  "block.minecraft.waxed_cut_copper_slab": "ವ್ಯಾಕ್ಸ್ಡ್ ಕಟ್ ಕಾಪರ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.waxed_cut_copper_stairs": "ವ್ಯಾಕ್ಸ್ಡ್ ಕಟ್ ಕಾಪರ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.waxed_exposed_chiseled_copper": "Waxed Exposed Chiseled Copper",
  "block.minecraft.waxed_exposed_copper": "ಒಡ್ಡಿದ ತಾಮ್ರ",
  "block.minecraft.waxed_exposed_copper_bars": "Waxed Exposed Copper Bars",
  "block.minecraft.waxed_exposed_copper_bulb": "Waxed Exposed Copper Bulb",
  "block.minecraft.waxed_exposed_copper_chain": "Waxed Exposed Copper Chain",
  "block.minecraft.waxed_exposed_copper_chest": "Waxed Exposed Copper Chest",
  "block.minecraft.waxed_exposed_copper_door": "Waxed Exposed Copper Door",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Waxed Exposed Copper Golem Statue",
  "block.minecraft.waxed_exposed_copper_grate": "Waxed Exposed Copper Grate",
  "block.minecraft.waxed_exposed_copper_lantern": "Waxed Exposed Copper Lantern",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Waxed Exposed Copper Trapdoor",
  "block.minecraft.waxed_exposed_cut_copper": "ವ್ಯಾಕ್ಸ್ ಮಾಡಿದ ಎಕ್ಸ್ಪೋಸ್ಡ್ ಕಟ್ ಕಾಪರ್",
  "block.minecraft.waxed_exposed_cut_copper_slab": "ವ್ಯಾಕ್ಸ್ ಮಾಡಿದ ಎಕ್ಸ್ಪೋಸ್ಡ್ ಕಟ್ ಕಾಪರ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "ವ್ಯಾಕ್ಸ್ ಮಾಡಿದ ಎಕ್ಸ್ಪೋಸ್ಡ್ ಕಟ್ ಕಾಪರ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.waxed_exposed_lightning_rod": "Waxed Exposed Lightning Rod",
  "block.minecraft.waxed_lightning_rod": "Waxed Lightning Rod",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Waxed Oxidized Chiseled Copper",
  "block.minecraft.waxed_oxidized_copper": "ಮೇಣದ ಆಕ್ಸಿಡೀಕೃತ ತಾಮ್ರ",
  "block.minecraft.waxed_oxidized_copper_bars": "Waxed Oxidized Copper Bars",
  "block.minecraft.waxed_oxidized_copper_bulb": "Waxed Oxidized Copper Bulb",
  "block.minecraft.waxed_oxidized_copper_chain": "Waxed Oxidized Copper Chain",
  "block.minecraft.waxed_oxidized_copper_chest": "Waxed Oxidized Copper Chest",
  "block.minecraft.waxed_oxidized_copper_door": "Waxed Oxidized Copper Door",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Waxed Oxidized Copper Golem Statue",
  "block.minecraft.waxed_oxidized_copper_grate": "Waxed Oxidized Copper Grate",
  "block.minecraft.waxed_oxidized_copper_lantern": "Waxed Oxidized Copper Lantern",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Waxed Oxidized Copper Trapdoor",
  "block.minecraft.waxed_oxidized_cut_copper": "ವ್ಯಾಕ್ಸ್ ಮಾಡಿದ ಆಕ್ಸಿಡೀಕೃತ ಕಟ್ ಕಾಪರ್",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "ಮೇಣದ ಆಕ್ಸಿಡೀಕೃತ ಕಟ್ ತಾಮ್ರದ ಚಪ್ಪಡಿ",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "ವ್ಯಾಕ್ಸ್ ಮಾಡಿದ ಆಕ್ಸಿಡೀಕೃತ ಕಟ್ ಕಾಪರ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.waxed_oxidized_lightning_rod": "Waxed Oxidized Lightning Rod",
  "block.minecraft.waxed_weathered_chiseled_copper": "Waxed Weathered Chiseled Copper",
  "block.minecraft.waxed_weathered_copper": "ಮೇಣದ ವಾತಾವರಣದ ತಾಮ್ರ",
  "block.minecraft.waxed_weathered_copper_bars": "Waxed Weathered Copper Bars",
  "block.minecraft.waxed_weathered_copper_bulb": "Waxed Weathered Copper Bulb",
  "block.minecraft.waxed_weathered_copper_chain": "Waxed Weathered Copper Chain",
  "block.minecraft.waxed_weathered_copper_chest": "Waxed Weathered Copper Chest",
  "block.minecraft.waxed_weathered_copper_door": "Waxed Weathered Copper Door",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Waxed Weathered Copper Golem Statue",
  "block.minecraft.waxed_weathered_copper_grate": "Waxed Weathered Copper Grate",
  "block.minecraft.waxed_weathered_copper_lantern": "Waxed Weathered Copper Lantern",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Waxed Weathered Copper Trapdoor",
  "block.minecraft.waxed_weathered_cut_copper": "ಮೇಣದ ವಾತಾವರಣದ ಕತ್ತರಿಸಿದ ತಾಮ್ರ",
  "block.minecraft.waxed_weathered_cut_copper_slab": "ಮೇಣದ ವಾತಾವರಣದ ಕತ್ತರಿಸಿದ ತಾಮ್ರದ ಚಪ್ಪಡಿ",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "ಮೇಣದ ವಾತಾವರಣದ ಕತ್ತರಿಸಿದ ತಾಮ್ರದ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.waxed_weathered_lightning_rod": "Waxed Weathered Lightning Rod",
  "block.minecraft.weathered_chiseled_copper": "Weathered Chiseled Copper",
  "block.minecraft.weathered_copper": "ತಾಮ್ರದ ವಾತಾವರಣ",
  "block.minecraft.weathered_copper_bars": "Weathered Copper Bars",
  "block.minecraft.weathered_copper_bulb": "Weathered Copper Bulb",
  "block.minecraft.weathered_copper_chain": "Weathered Copper Chain",
  "block.minecraft.weathered_copper_chest": "Weathered Copper Chest",
  "block.minecraft.weathered_copper_door": "Weathered Copper Door",
  "block.minecraft.weathered_copper_golem_statue": "Weathered Copper Golem Statue",
  "block.minecraft.weathered_copper_grate": "Weathered Copper Grate",
  "block.minecraft.weathered_copper_lantern": "Weathered Copper Lantern",
  "block.minecraft.weathered_copper_trapdoor": "Weathered Copper Trapdoor",
  "block.minecraft.weathered_cut_copper": "ಹವಾಮಾನ ಕಟ್ ತಾಮ್ರ",
  "block.minecraft.weathered_cut_copper_slab": "ಹವಾಮಾನ ಕಟ್ ಕಾಪರ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.weathered_cut_copper_stairs": "ಹವಾಮಾನ ಕಟ್ ತಾಮ್ರದ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.weathered_lightning_rod": "Weathered Lightning Rod",
  "block.minecraft.weeping_vines": "ಅಳುವ ಬಳ್ಳಿಗಳು",
  "block.minecraft.weeping_vines_plant": "ಅಳುವ ಬಳ್ಳಿಗಳು",
  "block.minecraft.wet_sponge": "\nವೆಟ್ ಸ್ಪಾಂಜ್",
  "block.minecraft.wheat": "ಗೋಧಿ ಬೆಳೆಗಳು",
  "block.minecraft.white_banner": "ಬಿಳಿ ಬ್ಯಾನರ್",
  "block.minecraft.white_bed": "ಬಿಳಿ ಹಾಸಿಗೆ",
  "block.minecraft.white_candle": "ಬಿಳಿ ಮೇಣದ ಬತ್ತಿ",
  "block.minecraft.white_candle_cake": "ಬಿಳಿ ಕ್ಯಾಂಡಲ್ನೊಂದಿಗೆ ಕೇಕ್",
  "block.minecraft.white_carpet": "ಬಿಳಿ ಕಾರ್ಪೆಟ್",
  "block.minecraft.white_concrete": "ಬಿಳಿ ಕಾಂಕ್ರೀಟ್",
  "block.minecraft.white_concrete_powder": "ಬಿಳಿ ಕಾಂಕ್ರೀಟ್ ಪುಡಿ",
  "block.minecraft.white_glazed_terracotta": "ಬಿಳಿ ಮೆರುಗಿನ ಟೆರಾಕೋಟಾ",
  "block.minecraft.white_shulker_box": "ಬಿಳಿ ಶಲ್ಕರ್ ಬಾಕ್ಸ್",
  "block.minecraft.white_stained_glass": "ಬಿಳಿ ಬಣ್ಣದ ಗಾಜು",
  "block.minecraft.white_stained_glass_pane": "ಬಿಳಿ ಬಣ್ಣದ ಗಾಜಿನ ಫಲಕ",
  "block.minecraft.white_terracotta": "ವೈಟ್ ಟೆರಾಕೋಟಾ",
  "block.minecraft.white_tulip": "ಬಿಳಿ ಟುಲಿಪ್",
  "block.minecraft.white_wool": "ಬಿಳಿ ಉಣ್ಣೆ",
  "block.minecraft.wildflowers": "Wildflowers",
  "block.minecraft.wither_rose": "ವಿದರ್ಸ್ ರೋಸ್",
  "block.minecraft.wither_skeleton_skull": "ಅಸ್ಥಿಪಂಜರ ತಲೆಬುರುಡೆ",
  "block.minecraft.wither_skeleton_wall_skull": "ಅಸ್ಥಿಪಂಜರ ಗೋಡೆ ತಲೆಬುರುಡೆ",
  "block.minecraft.yellow_banner": "ಹಳದಿ ಬ್ಯಾನರ್",
  "block.minecraft.yellow_bed": "ಹಳದಿ ಹಾಸಿಗೆ",
  "block.minecraft.yellow_candle": "ಹಳದಿ ಕ್ಯಾಂಡಲ್",
  "block.minecraft.yellow_candle_cake": "Haḷadi kyāṇḍalnondige kēk",
  "block.minecraft.yellow_carpet": "ಹಳದಿ ಕಾರ್ಪೆಟ್",
  "block.minecraft.yellow_concrete": "ಹಳದಿ ಕಾಂಕ್ರೀಟ್",
  "block.minecraft.yellow_concrete_powder": "ಹಳದಿ ಕಾಂಕ್ರೀಟ್ ಪುಡಿ",
  "block.minecraft.yellow_glazed_terracotta": "ಹಳದಿ ಹೊಳಪುಳ್ಳ ಟೆರಾಕೋಟಾ",
  "block.minecraft.yellow_shulker_box": "\nಹಳದಿ ಶಲ್ಕರ್ ಬಾಕ್ಸ್",
  "block.minecraft.yellow_stained_glass": "ಹಳದಿ ಬಣ್ಣದ ಗಾಜು",
  "block.minecraft.yellow_stained_glass_pane": "ಹಳದಿ ಬಣ್ಣದ ಗಾಜಿನ ಫಲಕ",
  "block.minecraft.yellow_terracotta": "ಹಳದಿ ಟೆರಾಕೋಟಾ",
  "block.minecraft.yellow_wool": "ಹಳದಿ ಉಣ್ಣೆ",
  "block.minecraft.zombie_head": "ಝಾಂಬಿ ಹೆಡ್",
  "block.minecraft.zombie_wall_head": "ಝಾಂಬಿ ವಾಲ್ ಹೆಡ್",
  "item.minecraft.acacia_boat": "\nಅಕೇಶಿಯ ಬೋಟ್",
  "item.minecraft.acacia_chest_boat": "ಎದೆಯೊಂದಿಗೆ ಅಕೇಶಿಯ ದೋಣಿ",
  "item.minecraft.allay_spawn_egg": "ಅಲ್ಲೆ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.amethyst_shard": "ಅಮೆಥಿಸ್ಟ್ ಶಾರ್ಡ್",
  "item.minecraft.angler_pottery_shard": "Angler Pottery Shard",
  "item.minecraft.angler_pottery_sherd": "Angler Pottery Sherd",
  "item.minecraft.apple": "ಸೇಬು",
  "item.minecraft.archer_pottery_shard": "Archer Pottery Shard",
  "item.minecraft.archer_pottery_sherd": "Archer Pottery Sherd",
  "item.minecraft.armadillo_scute": "Armadillo Scute",
  "item.minecraft.armadillo_spawn_egg": "Armadillo Spawn Egg",
  "item.minecraft.armor_stand": "ಪ್ರತಿಮೆ",
  "item.minecraft.arms_up_pottery_shard": "Arms Up Pottery Shard",
  "item.minecraft.arms_up_pottery_sherd": "Arms Up Pottery Sherd",
  "item.minecraft.arrow": "ಬಾಣ",
  "item.minecraft.axolotl_bucket": "ಬಕೆಟ್ ಆಫ್ ಆಕ್ಸಿಲೋಟ್ಲ್",
  "item.minecraft.axolotl_spawn_egg": "ಆಕ್ಸಿಲೋಟ್ಲ್ ಮೊಟ್ಟೆ",
  "item.minecraft.baked_potato": "ಬೇಯಿಸಿದ ಆಲೂಗೆಡ್ಡೆ",
  "item.minecraft.bamboo_chest_raft": "Bamboo Raft with Chest",
  "item.minecraft.bamboo_raft": "Bamboo Raft",
  "item.minecraft.bat_spawn_egg": "ಬ್ಯಾಟ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.bee_spawn_egg": "ಬೀ ಸ್ಪಾವ್ನ್ ಎಗ್",
  "item.minecraft.beef": "ಕಚ್ಚಾ ಗೋಮಾಂಸ",
  "item.minecraft.beetroot": "\nಬೀಟ್ರೂಟ್",
  "item.minecraft.beetroot_seeds": "\nಬೀಟ್ರೂಟ್ ಬೀಜಗಳು",
  "item.minecraft.beetroot_soup": "\nಬೀಟ್ರೂಟ್ ಸೂಪ್",
  "item.minecraft.birch_boat": "ಬರ್ಚ್ ದೋಣಿ",
  "item.minecraft.birch_chest_boat": "ಎದೆಯೊಂದಿಗೆ ಬಿರ್ಚ್ ದೋಣಿ",
  "item.minecraft.black_bundle": "Black Bundle",
  "item.minecraft.black_dye": "ಕಪ್ಪು ಬಣ್ಣ",
  "item.minecraft.black_harness": "Black Harness",
  "item.minecraft.blade_pottery_shard": "Blade Pottery Shard",
  "item.minecraft.blade_pottery_sherd": "Blade Pottery Sherd",
  "item.minecraft.blaze_powder": "ಬ್ಲೇಜ್ ಪೌಡರ್",
  "item.minecraft.blaze_rod": "ಬ್ಲೇಜ್ ರಾಡ್",
  "item.minecraft.blaze_spawn_egg": "ಬ್ಲೇಜ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.blue_bundle": "Blue Bundle",
  "item.minecraft.blue_dye": "ನೀಲಿ ಬಣ್ಣ",
  "item.minecraft.blue_egg": "Blue Egg",
  "item.minecraft.blue_harness": "Blue Harness",
  "item.minecraft.bogged_spawn_egg": "Bogged Spawn Egg",
  "item.minecraft.bolt_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Bolt Armor Trim",
  "item.minecraft.bone": "ಮೂಳೆ",
  "item.minecraft.bone_meal": "ಮೂಳೆ .ಟ",
  "item.minecraft.book": "ಪುಸ್ತಕ",
  "item.minecraft.bordure_indented_banner_pattern": "Bordure Indented Banner Pattern",
  "item.minecraft.bow": "ಬಿಲ್ಲು",
  "item.minecraft.bowl": "ಬೌಲ್",
  "item.minecraft.bread": "ಬ್ರೆಡ್",
  "item.minecraft.breeze_rod": "Breeze Rod",
  "item.minecraft.breeze_spawn_egg": "Breeze Spawn Egg",
  "item.minecraft.brewer_pottery_shard": "Brewer Pottery Shard",
  "item.minecraft.brewer_pottery_sherd": "Brewer Pottery Sherd",
  "item.minecraft.brewing_stand": "Brewing Stand",
  "item.minecraft.brick": "ಇಟ್ಟಿಗೆ",
  "item.minecraft.brown_bundle": "Brown Bundle",
  "item.minecraft.brown_dye": "ಕಂದು ಬಣ್ಣ",
  "item.minecraft.brown_egg": "Brown Egg",
  "item.minecraft.brown_harness": "Brown Harness",
  "item.minecraft.brush": "Brush",
  "item.minecraft.bucket": "ಬಕೆಟ್",
  "item.minecraft.bundle": "ಬಂಡಲ್",
  "item.minecraft.bundle.empty": "Empty",
  "item.minecraft.bundle.empty.description": "Can hold a mixed stack of items",
  "item.minecraft.bundle.full": "Full",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Burn Pottery Shard",
  "item.minecraft.burn_pottery_sherd": "Burn Pottery Sherd",
  "item.minecraft.camel_husk_spawn_egg": "Camel Husk Spawn Egg",
  "item.minecraft.camel_spawn_egg": "Camel Spawn Egg",
  "item.minecraft.carrot": "ಕ್ಯಾರೆಟ್",
  "item.minecraft.carrot_on_a_stick": "\nಕಡ್ಡಿ ಕಡ್ಡಿ",
  "item.minecraft.cat_spawn_egg": "ಕ್ಯಾಟ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.cauldron": "Cauldron",
  "item.minecraft.cave_spider_spawn_egg": "ಗುಹೆ ಸ್ಪೈಡರ್ ಸ್ಪಾನ್ ಮೊಟ್ಟೆ",
  "item.minecraft.chainmail_boots": "ಚೈನ್‌ಮೇಲ್ ಬೂಟ್‌ಗಳು",
  "item.minecraft.chainmail_chestplate": "\nಚೈನ್ಮೇಲ್ ಚೆಸ್ಟ್ಪ್ಲೇಟ್",
  "item.minecraft.chainmail_helmet": "\nಚೈನ್ಮೇಲ್ ಹೆಲ್ಮೆಟ್",
  "item.minecraft.chainmail_leggings": "ಚೈನ್ಮೇಲ್ ಲೆಗ್ಗಿಂಗ್ಸ್",
  "item.minecraft.charcoal": "ಇದ್ದಿಲು",
  "item.minecraft.cherry_boat": "Cherry Boat",
  "item.minecraft.cherry_chest_boat": "Cherry Boat with Chest",
  "item.minecraft.chest_minecart": "\nಎದೆಯೊಂದಿಗೆ ಮಿನೆಕಾರ್ಟ್",
  "item.minecraft.chicken": "ಕಚ್ಚಾ ಚಿಕನ್",
  "item.minecraft.chicken_spawn_egg": "ಚಿಕನ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.chorus_fruit": "ಕೋರಸ್ ಹಣ್ಣು",
  "item.minecraft.clay_ball": "ಕ್ಲೇ ಬಾಲ್",
  "item.minecraft.clock": "ಗಡಿಯಾರ",
  "item.minecraft.coal": "ಕಲ್ಲಿದ್ದಲು",
  "item.minecraft.coast_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Coast Armor Trim",
  "item.minecraft.cocoa_beans": "ಕೊಕೊ ಬೀನ್ಸ್",
  "item.minecraft.cod": "ಕಚ್ಚಾ ಕಾಡ್",
  "item.minecraft.cod_bucket": "ಬಕೆಟ್ ಆಫ್ ಕಾಡ್",
  "item.minecraft.cod_spawn_egg": "ಕಾಡ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.command_block_minecart": "\nಕಮಾಂಡ್ ಬ್ಲಾಕ್ನೊಂದಿಗೆ ಮಿನೆಕಾರ್ಟ್",
  "item.minecraft.compass": "ದಿಕ್ಸೂಚಿ",
  "item.minecraft.cooked_beef": "ಸ್ಟೀಕ್",
  "item.minecraft.cooked_chicken": "\nಬೇಯಿಸಿದ ಚಿಕನ್",
  "item.minecraft.cooked_cod": "ಬೇಯಿಸಿದ ಕಾಡ್",
  "item.minecraft.cooked_mutton": "\nಬೇಯಿಸಿದ ಮಟನ್",
  "item.minecraft.cooked_porkchop": "ಬೇಯಿಸಿದ ಹಂದಿಮಾಂಸ",
  "item.minecraft.cooked_rabbit": "ಬೇಯಿಸಿದ ಮೊಲ",
  "item.minecraft.cooked_salmon": "ಬೇಯಿಸಿದ ಸಾಲ್ಮನ್",
  "item.minecraft.cookie": "ಕುಕಿ",
  "item.minecraft.copper_axe": "Copper Axe",
  "item.minecraft.copper_boots": "Copper Boots",
  "item.minecraft.copper_chestplate": "Copper Chestplate",
  "item.minecraft.copper_golem_spawn_egg": "Copper Golem Spawn Egg",
  "item.minecraft.copper_helmet": "Copper Helmet",
  "item.minecraft.copper_hoe": "Copper Hoe",
  "item.minecraft.copper_horse_armor": "Copper Horse Armor",
  "item.minecraft.copper_ingot": "ತಾಮ್ರ ಇಂಗೋಟ್",
  "item.minecraft.copper_leggings": "Copper Leggings",
  "item.minecraft.copper_nautilus_armor": "Copper Nautilus Armor",
  "item.minecraft.copper_nugget": "Copper Nugget",
  "item.minecraft.copper_pickaxe": "Copper Pickaxe",
  "item.minecraft.copper_shovel": "Copper Shovel",
  "item.minecraft.copper_spear": "Copper Spear",
  "item.minecraft.copper_sword": "Copper Sword",
  "item.minecraft.cow_spawn_egg": "ಹಸು ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.creaking_spawn_egg": "Creaking Spawn Egg",
  "item.minecraft.creeper_banner_pattern": "ಬ್ಯಾನರ್ ನಮೂನೆ",
  "item.minecraft.creeper_banner_pattern.desc": "ಕ್ರೀಪರ್ ಚಾರ್ಜ್",
  "item.minecraft.creeper_banner_pattern.new": "Creeper Charge Banner Pattern",
  "item.minecraft.creeper_spawn_egg": "ಕ್ರೀಪರ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.crossbow": "ಅಡ್ಡಬಿಲ್ಲು",
  "item.minecraft.crossbow.projectile": "ಉತ್ಕ್ಷೇಪಕ:",
  "item.minecraft.crossbow.projectile.multiple": "Projectile: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Projectile: %s",
  "item.minecraft.cyan_bundle": "Cyan Bundle",
  "item.minecraft.cyan_dye": "ವೈಡೂರ್ಯ ಬಣ್ಣ",
  "item.minecraft.cyan_harness": "Cyan Harness",
  "item.minecraft.danger_pottery_shard": "Danger Pottery Shard",
  "item.minecraft.danger_pottery_sherd": "Danger Pottery Sherd",
  "item.minecraft.dark_oak_boat": "ಡಾರ್ಕ್ ಓಕ್ ಬೋಟ್",
  "item.minecraft.dark_oak_chest_boat": "ಎದೆಯೊಂದಿಗೆ ಡಾರ್ಕ್ ಓಕ್ ದೋಣಿ",
  "item.minecraft.debug_stick": "ಡೀಬಗ್ ಸ್ಟಿಕ್",
  "item.minecraft.debug_stick.empty": "%s ಯಾವುದೇ ಗುಣಗಳಿಲ್ಲ",
  "item.minecraft.debug_stick.select": "\nಆಯ್ಕೆ ಮಾಡಿದ \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" ನಿಂದ%s ಗೆ",
  "item.minecraft.diamond": "ವಜ್ರ",
  "item.minecraft.diamond_axe": "ಡೈಮಂಡ್ ಏಕ್ಸ್",
  "item.minecraft.diamond_boots": "ಡೈಮಂಡ್ ಬೂಟ್ಸ್",
  "item.minecraft.diamond_chestplate": "ಡೈಮಂಡ್ ಚೆಸ್ಟ್ಲೇಟ್",
  "item.minecraft.diamond_helmet": "ವಜ್ರ ಹೆಲ್ಮೆಟ್",
  "item.minecraft.diamond_hoe": "ಡೈಮಂಡ್ ಹೋ",
  "item.minecraft.diamond_horse_armor": "ಡೈಮಂಡ್ ಹಾರ್ಸ್ ಆರ್ಮರ್",
  "item.minecraft.diamond_leggings": "ಡೈಮಂಡ್ ಲೆಗ್ಗಿಂಗ್ಸ್",
  "item.minecraft.diamond_nautilus_armor": "Diamond Nautilus Armor",
  "item.minecraft.diamond_pickaxe": "ಡೈಮಂಡ್ ಪಿಕಕ್ಸೆ",
  "item.minecraft.diamond_shovel": "ವಜ್ರದ ಸಲಿಕೆ",
  "item.minecraft.diamond_spear": "Diamond Spear",
  "item.minecraft.diamond_sword": "ಡೈಮಂಡ್ ಸ್ವೋರ್ಡ್",
  "item.minecraft.disc_fragment_5": "ಡಿಸ್ಕ್ ತುಣುಕು",
  "item.minecraft.disc_fragment_5.desc": "ಸಂಗೀತ ಡಿಸ್ಕ್ - 5",
  "item.minecraft.dolphin_spawn_egg": "ಡಾಲ್ಫಿನ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.donkey_spawn_egg": "ಕತ್ತೆ ಸ್ಪಾವ್ನ್ ಮೊಟ್ಟೆ",
  "item.minecraft.dragon_breath": "ಡ್ರ್ಯಾಗನ್ ಉಸಿರು",
  "item.minecraft.dried_kelp": "\nಒಣಗಿದ ಕೆಲ್ಪ್",
  "item.minecraft.drowned_spawn_egg": "ಸ್ಪಾನ್ ಎಗ್ ಮುಳುಗಿತು",
  "item.minecraft.dune_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Dune Armor Trim",
  "item.minecraft.echo_shard": "ಎಕೋ ಶಾರ್ಡ್",
  "item.minecraft.egg": "ಮೊಟ್ಟೆ",
  "item.minecraft.elder_guardian_spawn_egg": "ಎಲ್ಡರ್ ಗಾರ್ಡಿಯನ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.elytra": "ಎಲಿತ್ರಾ",
  "item.minecraft.emerald": "ಪಚ್ಚೆ",
  "item.minecraft.enchanted_book": "ಎನ್ಚ್ಯಾಂಟೆಡ್ ಪುಸ್ತಕ",
  "item.minecraft.enchanted_golden_apple": "ಎನ್ಚಾಂಟೆಡ್ ಗೋಲ್ಡನ್ ಆಪಲ್",
  "item.minecraft.end_crystal": "ಎಂಡ್ ಕ್ರಿಸ್ಟಲ್",
  "item.minecraft.ender_dragon_spawn_egg": "Ender Dragon Spawn Egg",
  "item.minecraft.ender_eye": "ಎಂಡರ್ ಕಣ್ಣು",
  "item.minecraft.ender_pearl": "ಎಂಡರ್ ಪರ್ಲ್",
  "item.minecraft.enderman_spawn_egg": "ಎಂಡರ್ಮನ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.endermite_spawn_egg": "ಎಂಡರ್ಮೈಟ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.evoker_spawn_egg": "ಇವೊಕರ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.experience_bottle": "ಬಾಟಲ್ ಒ 'ಮೋಡಿಮಾಡುವ",
  "item.minecraft.explorer_pottery_shard": "Explorer Pottery Shard",
  "item.minecraft.explorer_pottery_sherd": "Explorer Pottery Sherd",
  "item.minecraft.eye_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Eye Armor Trim",
  "item.minecraft.feather": "ಗರಿ",
  "item.minecraft.fermented_spider_eye": "ಹುದುಗಿಸಿದ ಸ್ಪೈಡರ್ ಐ",
  "item.minecraft.field_masoned_banner_pattern": "Field Masoned Banner Pattern",
  "item.minecraft.filled_map": "ನಕ್ಷೆ",
  "item.minecraft.fire_charge": "\nಫೈರ್ ಚಾರ್ಜ್",
  "item.minecraft.firework_rocket": "\nಪಟಾಕಿ ರಾಕೆಟ್",
  "item.minecraft.firework_rocket.flight": "ವಿಮಾನ ಅವಧಿ:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "ಪಟಾಕಿ ಸ್ಟಾರ್",
  "item.minecraft.firework_star.black": "ಕಪ್ಪು",
  "item.minecraft.firework_star.blue": "ನೀಲಿ",
  "item.minecraft.firework_star.brown": "ಬ್ರೌನ್",
  "item.minecraft.firework_star.custom_color": "Custom",
  "item.minecraft.firework_star.cyan": "ವೈಡೂರ್ಯ",
  "item.minecraft.firework_star.fade_to": "\nಗೆ ಫೇಡ್",
  "item.minecraft.firework_star.flicker": "ಟ್ವಿಂಕಲ್",
  "item.minecraft.firework_star.gray": "ಬೂದು",
  "item.minecraft.firework_star.green": "ಹಸಿರು",
  "item.minecraft.firework_star.light_blue": "\nತಿಳಿ ನೀಲಿ",
  "item.minecraft.firework_star.light_gray": "\nತಿಳಿ ಬೂದು",
  "item.minecraft.firework_star.lime": "ಸುಣ್ಣ",
  "item.minecraft.firework_star.magenta": "ಕೆನ್ನೇರಳೆ ಬಣ್ಣ",
  "item.minecraft.firework_star.orange": "ಕಿತ್ತಳೆ",
  "item.minecraft.firework_star.pink": "ಗುಲಾಬಿ",
  "item.minecraft.firework_star.purple": "ಪರ್ಪಲ್",
  "item.minecraft.firework_star.red": "ಕೆಂಪು",
  "item.minecraft.firework_star.shape": "\nಅಜ್ಞಾತ ಆಕಾರ",
  "item.minecraft.firework_star.shape.burst": "ಸ್ಫೋಟ",
  "item.minecraft.firework_star.shape.creeper": "ತೆವಳುವ ಆಕಾರದ",
  "item.minecraft.firework_star.shape.large_ball": "ದೊಡ್ಡ ಚೆಂಡು",
  "item.minecraft.firework_star.shape.small_ball": "ಸಣ್ಣ ಚೆಂಡು",
  "item.minecraft.firework_star.shape.star": "ನಕ್ಷತ್ರಾಕಾರದ",
  "item.minecraft.firework_star.trail": "ಜಾಡು",
  "item.minecraft.firework_star.white": "ಬಿಳಿ",
  "item.minecraft.firework_star.yellow": "ಹಳದಿ",
  "item.minecraft.fishing_rod": "ಫಿಶಿಂಗ್ ರಾಡ್",
  "item.minecraft.flint": "ಫ್ಲಿಂಟ್",
  "item.minecraft.flint_and_steel": "ಫ್ಲಿಂಟ್ ಮತ್ತು ಸ್ಟೀಲ್",
  "item.minecraft.flow_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Flow Armor Trim",
  "item.minecraft.flow_banner_pattern": "Banner Pattern",
  "item.minecraft.flow_banner_pattern.desc": "Flow",
  "item.minecraft.flow_banner_pattern.new": "Flow Banner Pattern",
  "item.minecraft.flow_pottery_sherd": "Flow Pottery Sherd",
  "item.minecraft.flower_banner_pattern": "Banner Pattern",
  "item.minecraft.flower_banner_pattern.desc": "ಹೂ ಚಾರ್ಜ್",
  "item.minecraft.flower_banner_pattern.new": "Flower Charge Banner Pattern",
  "item.minecraft.flower_pot": "Flower Pot",
  "item.minecraft.fox_spawn_egg": "ಫಾಕ್ಸ್ ಎಗ್ ಸ್ಪಾನ್",
  "item.minecraft.friend_pottery_shard": "Friend Pottery Shard",
  "item.minecraft.friend_pottery_sherd": "Friend Pottery Sherd",
  "item.minecraft.frog_spawn_egg": "ಕಪ್ಪೆ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.furnace_minecart": "ಕುಲುಮೆಯೊಂದಿಗೆ ಮಿನೆಕಾರ್ಟ್",
  "item.minecraft.ghast_spawn_egg": "ಘಾಸ್ಟ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.ghast_tear": "\nಘಾಸ್ಟ್ ಟಿಯರ್",
  "item.minecraft.glass_bottle": "ಗಾಜಿನ ಬಾಟಲ್",
  "item.minecraft.glistering_melon_slice": "ಮೆಲೋನ್ ಸ್ಲೈಸ್ ಗ್ಲಿಸ್ಟರ್",
  "item.minecraft.globe_banner_pattern": "Banner Pattern",
  "item.minecraft.globe_banner_pattern.desc": "ಗ್ಲೋಬ್",
  "item.minecraft.globe_banner_pattern.new": "Globe Banner Pattern",
  "item.minecraft.glow_berries": "ಗ್ಲೋ ಹಣ್ಣುಗಳು",
  "item.minecraft.glow_ink_sac": "ಗ್ಲೋ ಇಂಕ್ ಚೀಲ",
  "item.minecraft.glow_item_frame": "ಗ್ಲೋ ಐಟಂ ಫ್ರೇಮ್",
  "item.minecraft.glow_squid_spawn_egg": "ಗ್ಲೋ ಸ್ಕ್ವಿಡ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.glowstone_dust": "ರೆಡ್ಸ್ಟೋನ್ ಧೂಳು",
  "item.minecraft.goat_horn": "ಮೇಕೆ ಕೊಂಬು",
  "item.minecraft.goat_spawn_egg": "ಮೇಕೆ ಮೊಗ್ಗು ಮೊಗ್ಗು",
  "item.minecraft.gold_ingot": "ಗೋಲ್ಡ್ ಇಂಗೊಟ್",
  "item.minecraft.gold_nugget": "ಗೋಲ್ಡ್ ನುಗ್ಗೆಟ್",
  "item.minecraft.golden_apple": "ಗೋಲ್ಡನ್ ಆಪಲ್",
  "item.minecraft.golden_axe": "ಗೋಲ್ಡನ್ ಏಕ್ಸ್",
  "item.minecraft.golden_boots": "ಗೋಲ್ಡನ್ ಬೂಟ್ಸ್",
  "item.minecraft.golden_carrot": "ಗೋಲ್ಡನ್ ಕ್ಯಾರೆಟ್",
  "item.minecraft.golden_chestplate": "ಗೋಲ್ಡನ್ ಚೆಸ್ಟ್ಲೇಟ್",
  "item.minecraft.golden_helmet": "ಚಿನ್ನದ ಹೆಲ್ಮೆಟ್",
  "item.minecraft.golden_hoe": "ಗೋಲ್ಡನ್ ಹೇ",
  "item.minecraft.golden_horse_armor": "ಗೋಲ್ಡನ್ ಹಾರ್ಸ್ ಆರ್ಮರ್",
  "item.minecraft.golden_leggings": "ಗೋಲ್ಡನ್ ಲೆಗ್ಗಿಂಗ್ಸ್",
  "item.minecraft.golden_nautilus_armor": "Golden Nautilus Armor",
  "item.minecraft.golden_pickaxe": "ಗೋಲ್ಡನ್ ಪಿಕ್ಸಾ",
  "item.minecraft.golden_shovel": "ಗೋಲ್ಡನ್ ಷೋವೆಲ್",
  "item.minecraft.golden_spear": "Golden Spear",
  "item.minecraft.golden_sword": "ಗೋಲ್ಡನ್ ಸ್ವೋರ್ಡ್",
  "item.minecraft.gray_bundle": "Gray Bundle",
  "item.minecraft.gray_dye": "ಗ್ರೇ ಡೈ",
  "item.minecraft.gray_harness": "Gray Harness",
  "item.minecraft.green_bundle": "Green Bundle",
  "item.minecraft.green_dye": "ಹಸಿರು ಬಣ್ಣ",
  "item.minecraft.green_harness": "Green Harness",
  "item.minecraft.guardian_spawn_egg": "ಗಾರ್ಡಿಯನ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.gunpowder": "ಗನ್‌ಪೌಡರ್",
  "item.minecraft.guster_banner_pattern": "Banner Pattern",
  "item.minecraft.guster_banner_pattern.desc": "Guster",
  "item.minecraft.guster_banner_pattern.new": "Guster Banner Pattern",
  "item.minecraft.guster_pottery_sherd": "Guster Pottery Sherd",
  "item.minecraft.happy_ghast_spawn_egg": "Happy Ghast Spawn Egg",
  "item.minecraft.harness": "Harness",
  "item.minecraft.heart_of_the_sea": "ಹಾರ್ಟ್ ಆಫ್ ದಿ ಸೀ",
  "item.minecraft.heart_pottery_shard": "Heart Pottery Shard",
  "item.minecraft.heart_pottery_sherd": "Heart Pottery Sherd",
  "item.minecraft.heartbreak_pottery_shard": "Heartbreak Pottery Shard",
  "item.minecraft.heartbreak_pottery_sherd": "Heartbreak Pottery Sherd",
  "item.minecraft.hoglin_spawn_egg": "ಡಾಲ್ಫಿನ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.honey_bottle": "ಹನಿ ಬಾಟಲ್",
  "item.minecraft.honeycomb": "ಜೇನುಗೂಡು",
  "item.minecraft.hopper_minecart": "ಹಾಪರ್ ಜೊತೆ ಮಿನೆಕಾರ್ಟ್",
  "item.minecraft.horse_spawn_egg": "ಕುದುರೆ ಸ್ಪಾನ್ ಮೊಟ್ಟೆ",
  "item.minecraft.host_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.host_armor_trim_smithing_template.new": "Host Armor Trim",
  "item.minecraft.howl_pottery_shard": "Howl Pottery Shard",
  "item.minecraft.howl_pottery_sherd": "Howl Pottery Sherd",
  "item.minecraft.husk_spawn_egg": "ಹೊಟ್ಟು ಸ್ಪಾನ್ ಮೊಟ್ಟೆ",
  "item.minecraft.ink_sac": "ಶಾಯಿ ಚೀಲ",
  "item.minecraft.iron_axe": "ಕಬ್ಬಿಣದ ಏಕ್ಸ್",
  "item.minecraft.iron_boots": "ಐರನ್ ಬೂಟ್ಸ್",
  "item.minecraft.iron_chestplate": "ಕಬ್ಬಿಣದ ಚೆಸ್ಟ್ಲೇಟ್",
  "item.minecraft.iron_golem_spawn_egg": "Iron Golem Spawn Egg",
  "item.minecraft.iron_helmet": "ಕಬ್ಬಿಣದ ಹೆಲ್ಮೆಟ್",
  "item.minecraft.iron_hoe": "ಐರನ್ ಹೋ",
  "item.minecraft.iron_horse_armor": "ಐರನ್ ಹಾರ್ಸ್ ಆರ್ಮರ್",
  "item.minecraft.iron_ingot": "ಐರನ್ ಇಂಗೊಟ್",
  "item.minecraft.iron_leggings": "ಕಬ್ಬಿಣ ಲೆಗ್ಗಿಂಗ್ಸ್",
  "item.minecraft.iron_nautilus_armor": "Iron Nautilus Armor",
  "item.minecraft.iron_nugget": "ಐರನ್ ನುಗ್ಗೆಟ್",
  "item.minecraft.iron_pickaxe": "ಐರನ್ ಪಿಕ್ಸಾ",
  "item.minecraft.iron_shovel": "ಕಬ್ಬಿಣದ ಸಲಿಕೆ",
  "item.minecraft.iron_spear": "Iron Spear",
  "item.minecraft.iron_sword": "ಐರನ್ ಸ್ವೋರ್ಡ್",
  "item.minecraft.item_frame": "ಫ್ರೇಮ್",
  "item.minecraft.jungle_boat": "ಜಂಗಲ್ ಬೋಟ್",
  "item.minecraft.jungle_chest_boat": "ಎದೆಯೊಂದಿಗೆ ಜಂಗಲ್ ಬೋಟ್",
  "item.minecraft.knowledge_book": "ಜ್ಞಾನ ಪುಸ್ತಕ",
  "item.minecraft.lapis_lazuli": "ಲ್ಯಾಪಿಸ್ ಲಾಝುಲಿ",
  "item.minecraft.lava_bucket": "ಲಾವಾ ಬಕೆಟ್",
  "item.minecraft.lead": "ಲೀಡ್",
  "item.minecraft.leather": "ಚರ್ಮ",
  "item.minecraft.leather_boots": "\nಚರ್ಮದ ಬೂಟುಗಳು",
  "item.minecraft.leather_chestplate": "\nಲೆದರ್ ಟ್ಯೂನಿಕ್",
  "item.minecraft.leather_helmet": "ಚರ್ಮದ ಕ್ಯಾಪ್",
  "item.minecraft.leather_horse_armor": "ಲೆದರ್ ಹಾರ್ಸ್ ಆರ್ಮರ್",
  "item.minecraft.leather_leggings": "ಲೆದರ್ ಪ್ಯಾಂಟ್",
  "item.minecraft.light_blue_bundle": "Light Blue Bundle",
  "item.minecraft.light_blue_dye": "ಲೈಟ್ ಬ್ಲೂ ಡೈ",
  "item.minecraft.light_blue_harness": "Light Blue Harness",
  "item.minecraft.light_gray_bundle": "Light Gray Bundle",
  "item.minecraft.light_gray_dye": "ಲೈಟ್ ಗ್ರೇ ಡೈ",
  "item.minecraft.light_gray_harness": "Light Gray Harness",
  "item.minecraft.lime_bundle": "Lime Bundle",
  "item.minecraft.lime_dye": "ಲೈಮ್ ಡೈ",
  "item.minecraft.lime_harness": "Lime Harness",
  "item.minecraft.lingering_potion": "ದೀರ್ಘಕಾಲದ ಮದ್ದು",
  "item.minecraft.lingering_potion.effect.awkward": "\nವಿಚಿತ್ರವಾದ ದೀರ್ಘಕಾಲದ ಮದ್ದು",
  "item.minecraft.lingering_potion.effect.empty": "ಕಾಲಹರಣ ಮಾಡಲಾಗದ ಮದ್ದು",
  "item.minecraft.lingering_potion.effect.fire_resistance": "\nಬೆಂಕಿಯ ಪ್ರತಿರೋಧದ ದೀರ್ಘಕಾಲದ ಮದ್ದು",
  "item.minecraft.lingering_potion.effect.harming": "ಹಾನಿಯ ದೀರ್ಘಕಾಲದ ಮದ್ದು",
  "item.minecraft.lingering_potion.effect.healing": "\nಗುಣಪಡಿಸುವ ದೀರ್ಘಕಾಲದ ಮದ್ದು",
  "item.minecraft.lingering_potion.effect.infested": "Lingering Potion of Infestation",
  "item.minecraft.lingering_potion.effect.invisibility": "\nಅದೃಶ್ಯತೆಯ ದೀರ್ಘಕಾಲದ ಮದ್ದು",
  "item.minecraft.lingering_potion.effect.leaping": "\nಜಿಗಿಯುವ ದೀರ್ಘಕಾಲದ ಮದ್ದು",
  "item.minecraft.lingering_potion.effect.levitation": "ಕಾಲಹರಣದ ಮದ್ದು",
  "item.minecraft.lingering_potion.effect.luck": "\nಅದೃಷ್ಟದ ದೀರ್ಘಕಾಲದ ಮದ್ದು",
  "item.minecraft.lingering_potion.effect.mundane": "ಪ್ರಾಪಂಚಿಕ ಕಾಲಹರಣ ಮದ್ದು\n",
  "item.minecraft.lingering_potion.effect.night_vision": "ನೈಟ್ ವಿಷನ್ ನ ದೀರ್ಘಕಾಲದ ಮದ್ದು",
  "item.minecraft.lingering_potion.effect.oozing": "Lingering Potion of Oozing",
  "item.minecraft.lingering_potion.effect.poison": "\nವಿಷದ ದೀರ್ಘಕಾಲದ ಮದ್ದು",
  "item.minecraft.lingering_potion.effect.regeneration": "\nಪುನರುತ್ಪಾದನೆಯ ದೀರ್ಘಕಾಲದ ಮದ್ದು",
  "item.minecraft.lingering_potion.effect.slow_falling": "ನಿಧಾನವಾಗಿ ಬೀಳುವ ದೀರ್ಘಕಾಲದ ಮದ್ದು",
  "item.minecraft.lingering_potion.effect.slowness": "ನಿಧಾನಗತಿಯ ದೀರ್ಘಕಾಲದ ಮದ್ದು",
  "item.minecraft.lingering_potion.effect.strength": "ಕಾಲಹರಣ ಶಕ್ತಿ",
  "item.minecraft.lingering_potion.effect.swiftness": "\nವೇಗದ ದೀರ್ಘಕಾಲದ ಮದ್ದು",
  "item.minecraft.lingering_potion.effect.thick": "\nದಪ್ಪ ಕಾಲಹರಣ ಮದ್ದು",
  "item.minecraft.lingering_potion.effect.turtle_master": "ಆಮೆ ಮಾಸ್ಟರ್ನ ಲಿಂಗರಿಂಗ್ ಪೋಶನ್",
  "item.minecraft.lingering_potion.effect.water": "ಕಾಲಹರಣ ಮಾಡುವ ನೀರಿನ ಬಾಟಲ್",
  "item.minecraft.lingering_potion.effect.water_breathing": "ನೀರಿನ ಉಸಿರಾಟದ ದೀರ್ಘಕಾಲದ ಮದ್ದು",
  "item.minecraft.lingering_potion.effect.weakness": "ದುರ್ಬಲತೆಯ ದೀರ್ಘಕಾಲದ ಮದ್ದು",
  "item.minecraft.lingering_potion.effect.weaving": "Lingering Potion of Weaving",
  "item.minecraft.lingering_potion.effect.wind_charged": "Lingering Potion of Wind Charging",
  "item.minecraft.llama_spawn_egg": "ಲಾಮಾ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.lodestone_compass": "ಲೋಡೆಸ್ಟೋನ್ ಕಂಪಾಸ್",
  "item.minecraft.mace": "Mace",
  "item.minecraft.magenta_bundle": "Magenta Bundle",
  "item.minecraft.magenta_dye": "ಮೆಜೆಂತಾ ಡೈ",
  "item.minecraft.magenta_harness": "Magenta Harness",
  "item.minecraft.magma_cream": "\nಶಿಲಾಪಾಕ ಕ್ರೀಮ್",
  "item.minecraft.magma_cube_spawn_egg": "ಮ್ಯಾಗ್ಮಾ ಕ್ಯೂಬ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.mangrove_boat": "ಮ್ಯಾಂಗ್ರೋವ್ ದೋಣಿ",
  "item.minecraft.mangrove_chest_boat": "ಎದೆಯೊಂದಿಗೆ ಮ್ಯಾಂಗ್ರೋವ್ ದೋಣಿ",
  "item.minecraft.map": "ಖಾಲಿ ನಕ್ಷೆ",
  "item.minecraft.melon_seeds": "ಕಲ್ಲಂಗಡಿ ಬೀಜಗಳು",
  "item.minecraft.melon_slice": "ಕಲ್ಲಂಗಡಿ ತುಂಡು",
  "item.minecraft.milk_bucket": "\nಹಾಲು ಬಕೆಟ್",
  "item.minecraft.minecart": "ಮಿನೆಕಾರ್ಟ್",
  "item.minecraft.miner_pottery_shard": "Miner Pottery Shard",
  "item.minecraft.miner_pottery_sherd": "Miner Pottery Sherd",
  "item.minecraft.mojang_banner_pattern": "Banner Pattern",
  "item.minecraft.mojang_banner_pattern.desc": "ವಿಷಯ",
  "item.minecraft.mojang_banner_pattern.new": "Thing Banner Pattern",
  "item.minecraft.mooshroom_spawn_egg": "ಮೂಶ್ರೂಮ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.mourner_pottery_shard": "Mourner Pottery Shard",
  "item.minecraft.mourner_pottery_sherd": "Mourner Pottery Sherd",
  "item.minecraft.mule_spawn_egg": "ಮ್ಯೂಲ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.mushroom_stew": "\nಮಶ್ರೂಮ್ ಸ್ಟ್ಯೂ",
  "item.minecraft.music_disc_11": "Music Disc",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "ಸಂಗೀತ ಡಿಸ್ಕ್",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Music Disc",
  "item.minecraft.music_disc_5.desc": "ಸ್ಯಾಮ್ಯುಯೆಲ್ ಅಬರ್ಗ್ - 5",
  "item.minecraft.music_disc_blocks": "Music Disc",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Music Disc",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Music Disc",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Music Disc",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Music Disc",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Music Box)",
  "item.minecraft.music_disc_far": "Music Disc",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Music Disc",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Music Disc",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Music Disc",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Music Disc",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Music Disc",
  "item.minecraft.music_disc_pigstep.desc": "ಲೆನಾ ರೈನ್ - ಪಿಗ್‌ಸ್ಟೆಪ್",
  "item.minecraft.music_disc_precipice": "Music Disc",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Music Disc",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Music Disc",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Music Disc",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Music Disc",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Music Disc",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Music Disc",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "\nಕಚ್ಚಾ ಮಟನ್",
  "item.minecraft.name_tag": "\nಹೆಸರು ಟ್ಯಾಗ್",
  "item.minecraft.nautilus_shell": "ನಾಟಿಲಸ್ ಶೆಲ್",
  "item.minecraft.nautilus_spawn_egg": "Nautilus Spawn Egg",
  "item.minecraft.nether_brick": "ನೆದರ್ ಬ್ರಿಕ್",
  "item.minecraft.nether_star": "ನೆದರ್ ನಕ್ಷತ್ರ",
  "item.minecraft.nether_wart": "Nether Wart",
  "item.minecraft.netherite_axe": "ನೆದರೈಟ್ ಏಕ್ಸ್",
  "item.minecraft.netherite_boots": "ನೆದರೈಟ್ ಬೂಟ್ಸ್",
  "item.minecraft.netherite_chestplate": "ನೆದರೈಟ್ ಚೆಸ್ಟ್ಪ್ಲೇಟ್",
  "item.minecraft.netherite_helmet": "ನೆದರೈಟ್ ಹೆಲ್ಮೆಟ್",
  "item.minecraft.netherite_hoe": "ನೆದರೈಟ್ ಏಕ್ಸ್",
  "item.minecraft.netherite_horse_armor": "Netherite Horse Armor",
  "item.minecraft.netherite_ingot": "ನೆದರೈಟ್ ಇಂಗೋಟ್",
  "item.minecraft.netherite_leggings": "ನೆದರೈಟ್ ಏಕ್ಸ್",
  "item.minecraft.netherite_nautilus_armor": "Netherite Nautilus Armor",
  "item.minecraft.netherite_pickaxe": "ನೆದರೈಟ್ ಪಿಕಾಕ್ಸ್",
  "item.minecraft.netherite_scrap": "ನೆದರೈಟ್ ಸ್ಕ್ರ್ಯಾಪ್",
  "item.minecraft.netherite_shovel": "ನೆದರೈಟ್ ಏಕ್ಸ್",
  "item.minecraft.netherite_spear": "Netherite Spear",
  "item.minecraft.netherite_sword": "ನೆದರೈಟ್ ಏಕ್ಸ್",
  "item.minecraft.netherite_upgrade_smithing_template": "Smithing Template",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netherite Upgrade",
  "item.minecraft.oak_boat": "ಓಕ್ ದೋಣಿ",
  "item.minecraft.oak_chest_boat": "ಎದೆಯೊಂದಿಗೆ ಓಕ್ ದೋಣಿ",
  "item.minecraft.ocelot_spawn_egg": "ಒಸೆಲಾಟ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.ominous_bottle": "Ominous Bottle",
  "item.minecraft.ominous_trial_key": "Ominous Trial Key",
  "item.minecraft.orange_bundle": "Orange Bundle",
  "item.minecraft.orange_dye": "ಕಿತ್ತಳೆ ಬಣ್ಣ",
  "item.minecraft.orange_harness": "Orange Harness",
  "item.minecraft.painting": "ಚಿತ್ರಕಲೆ",
  "item.minecraft.pale_oak_boat": "Pale Oak Boat",
  "item.minecraft.pale_oak_chest_boat": "Pale Oak Boat with Chest",
  "item.minecraft.panda_spawn_egg": "ಪಾಂಡ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.paper": "ಕಾಗದ",
  "item.minecraft.parched_spawn_egg": "Parched Spawn Egg",
  "item.minecraft.parrot_spawn_egg": "ಗಿಳಿ ಮೊಟ್ಟೆಯ ಮೊಟ್ಟೆ",
  "item.minecraft.phantom_membrane": "\nಫ್ಯಾಂಟಮ್ ಮೆಂಬರೇನ್",
  "item.minecraft.phantom_spawn_egg": "ಫ್ಯಾಂಟಮ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.pig_spawn_egg": "ಪಿಗ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.piglin_banner_pattern": "Banner Pattern",
  "item.minecraft.piglin_banner_pattern.desc": "ಗೊರಕೆ",
  "item.minecraft.piglin_banner_pattern.new": "Snout Banner Pattern",
  "item.minecraft.piglin_brute_spawn_egg": "ಪಿಗ್ಲಿನ್ ಬ್ರೂಟ್ ಸ್ಪಾವ್ನ್ ಎಗ್",
  "item.minecraft.piglin_spawn_egg": "ಡಾಲ್ಫಿನ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.pillager_spawn_egg": "ಪಿಲ್ಲರ್ ಎಗ್ ಸ್ಪಾನ್",
  "item.minecraft.pink_bundle": "Pink Bundle",
  "item.minecraft.pink_dye": "ಗುಲಾಬಿ ಬಣ್ಣ",
  "item.minecraft.pink_harness": "Pink Harness",
  "item.minecraft.pitcher_plant": "Pitcher Plant",
  "item.minecraft.pitcher_pod": "Pitcher Pod",
  "item.minecraft.plenty_pottery_shard": "Plenty Pottery Shard",
  "item.minecraft.plenty_pottery_sherd": "Plenty Pottery Sherd",
  "item.minecraft.poisonous_potato": "ವಿಷಕಾರಿ ಆಲೂಗೆಡ್ಡೆ",
  "item.minecraft.polar_bear_spawn_egg": "ಹಿಮಕರಡಿ ಸ್ಪಾವ್ನ್ ಮೊಟ್ಟೆ",
  "item.minecraft.popped_chorus_fruit": "ಬೇಯಿಸಿದ ಕೋರಸ್ ಹಣ್ಣು",
  "item.minecraft.porkchop": "ಕಚ್ಚಾ ಪೋರ್ಕ್‌ಚಾಪ್",
  "item.minecraft.potato": "ಆಲೂಗೆಡ್ಡೆ",
  "item.minecraft.potion": "ಮದ್ದು",
  "item.minecraft.potion.effect.awkward": "ವಿಚಿತ್ರ ಮದ್ದು",
  "item.minecraft.potion.effect.empty": "\nರಚಿಸಲಾಗದ ಮದ್ದು",
  "item.minecraft.potion.effect.fire_resistance": "ಬೆಂಕಿಯ ಪ್ರತಿರೋಧದ ಮದ್ದು",
  "item.minecraft.potion.effect.harming": "\nಹಾನಿಯ ಮದ್ದು",
  "item.minecraft.potion.effect.healing": "\nಗುಣಪಡಿಸುವ ಮದ್ದು",
  "item.minecraft.potion.effect.infested": "Potion of Infestation",
  "item.minecraft.potion.effect.invisibility": "ಅದೃಶ್ಯತೆಯ ಮದ್ದು",
  "item.minecraft.potion.effect.leaping": "\nಕುಣಿತದ ಮದ್ದು",
  "item.minecraft.potion.effect.levitation": "ಲೆವಿಟೇಶನ್ ಮದ್ದು",
  "item.minecraft.potion.effect.luck": "\nಅದೃಷ್ಟದ ಮದ್ದು",
  "item.minecraft.potion.effect.mundane": "\nಪ್ರಾಪಂಚಿಕ ಮದ್ದು",
  "item.minecraft.potion.effect.night_vision": "ನೈಟ್ ವಿಷನ್ ಮದ್ದು",
  "item.minecraft.potion.effect.oozing": "Potion of Oozing",
  "item.minecraft.potion.effect.poison": "\nವಿಷದ ಮದ್ದು",
  "item.minecraft.potion.effect.regeneration": "ಪುನರುತ್ಪಾದನೆಯ ಮದ್ದು",
  "item.minecraft.potion.effect.slow_falling": "\nನಿಧಾನವಾಗಿ ಬೀಳುವ ಮದ್ದು",
  "item.minecraft.potion.effect.slowness": "ನಿಧಾನಗತಿಯ ಮದ್ದು",
  "item.minecraft.potion.effect.strength": "ಸಾಮರ್ಥ್ಯದ ಮದ್ದು",
  "item.minecraft.potion.effect.swiftness": "ವೇಗದ ಮದ್ದು",
  "item.minecraft.potion.effect.thick": "ದಪ್ಪ ಮದ್ದು",
  "item.minecraft.potion.effect.turtle_master": "ಆಮೆ ಮಾಸ್ಟರ್ನ ಪೋಶನ್",
  "item.minecraft.potion.effect.water": "ನೀರಿನ ಶೀಶೆ",
  "item.minecraft.potion.effect.water_breathing": "\nನೀರಿನ ಉಸಿರಾಟದ ಮದ್ದು",
  "item.minecraft.potion.effect.weakness": "ದೌರ್ಬಲ್ಯದ ಮದ್ದು",
  "item.minecraft.potion.effect.weaving": "Potion of Weaving",
  "item.minecraft.potion.effect.wind_charged": "Potion of Wind Charging",
  "item.minecraft.pottery_shard_archer": "Archer Pottery Shard",
  "item.minecraft.pottery_shard_arms_up": "Arms Up Pottery Shard",
  "item.minecraft.pottery_shard_prize": "Prize Pottery Shard",
  "item.minecraft.pottery_shard_skull": "Skull Pottery Shard",
  "item.minecraft.powder_snow_bucket": "ಪೌಡರ್ ಸ್ನೋ ಬಕೆಟ್",
  "item.minecraft.prismarine_crystals": "ಪ್ರಿಸ್ಮರಿನ್ ಕ್ರಿಸ್ಟಲ್ಸ್",
  "item.minecraft.prismarine_shard": "ಪ್ರಿಸ್ಮರಿನ್ ಶಾರ್ಡ್",
  "item.minecraft.prize_pottery_shard": "Prize Pottery Shard",
  "item.minecraft.prize_pottery_sherd": "Prize Pottery Sherd",
  "item.minecraft.pufferfish": "ಪಫರ್ ಫಿಶ್",
  "item.minecraft.pufferfish_bucket": "ಬಫರ್ ಆಫ್ ಪಫರ್ ಫಿಶ್",
  "item.minecraft.pufferfish_spawn_egg": "ಪಫರ್ ಫಿಶ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.pumpkin_pie": "ಕುಂಬಳಕಾಯಿ ಕೇಕ್",
  "item.minecraft.pumpkin_seeds": "ಕುಂಬಳಕಾಯಿ ಬೀಜಗಳು",
  "item.minecraft.purple_bundle": "Purple Bundle",
  "item.minecraft.purple_dye": "ಪರ್ಪಲ್ ಡೈ",
  "item.minecraft.purple_harness": "Purple Harness",
  "item.minecraft.quartz": "\nನೆದರ್ ಸ್ಫಟಿಕ ಶಿಲೆ",
  "item.minecraft.rabbit": "ಕಚ್ಚಾ ಮೊಲ",
  "item.minecraft.rabbit_foot": "ಮೊಲದ ಕಾಲು",
  "item.minecraft.rabbit_hide": "\nಮೊಲ ಮರೆಮಾಡು",
  "item.minecraft.rabbit_spawn_egg": "ಮೊಲ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.rabbit_stew": "ಮೊಲ ಸ್ಟ್ಯೂ",
  "item.minecraft.raiser_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Raiser Armor Trim",
  "item.minecraft.ravager_spawn_egg": "ರಾವೆಗರ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.raw_copper": "ಕಚ್ಚಾ ತಾಮ್ರ",
  "item.minecraft.raw_gold": "ಕಚ್ಚಾ ಚಿನ್ನ",
  "item.minecraft.raw_iron": "ಕಚ್ಚಾ ಕಬ್ಬಿಣ",
  "item.minecraft.recovery_compass": "ರಿಕವರಿ ಕಂಪಾಸ್",
  "item.minecraft.red_bundle": "Red Bundle",
  "item.minecraft.red_dye": "ಕೆಂಪು ಬಣ್ಣ",
  "item.minecraft.red_harness": "Red Harness",
  "item.minecraft.redstone": "ರೆಡ್ಸ್ಟೋನ್ ಧೂಳು",
  "item.minecraft.resin_brick": "Resin Brick",
  "item.minecraft.resin_clump": "Resin Clump",
  "item.minecraft.rib_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rib Armor Trim",
  "item.minecraft.rotten_flesh": "ಕೊಳೆತ ಮಾಂಸ",
  "item.minecraft.saddle": "ತಡಿ",
  "item.minecraft.salmon": "ಕಚ್ಚಾ ಸಾಲ್ಮನ್",
  "item.minecraft.salmon_bucket": "\nಸಾಲ್ಮನ್ ಬಕೆಟ್",
  "item.minecraft.salmon_spawn_egg": "ಸಾಲ್ಮನ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.scrape_pottery_sherd": "Scrape Pottery Sherd",
  "item.minecraft.scute": "Scute",
  "item.minecraft.sentry_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Sentry Armor Trim",
  "item.minecraft.shaper_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Shaper Armor Trim",
  "item.minecraft.sheaf_pottery_shard": "Sheaf Pottery Shard",
  "item.minecraft.sheaf_pottery_sherd": "Sheaf Pottery Sherd",
  "item.minecraft.shears": "\nಕತ್ತರಿ",
  "item.minecraft.sheep_spawn_egg": "ಕುರಿ ಸ್ಪಾನ್ ಮೊಟ್ಟೆ",
  "item.minecraft.shelter_pottery_shard": "Shelter Pottery Shard",
  "item.minecraft.shelter_pottery_sherd": "Shelter Pottery Sherd",
  "item.minecraft.shield": "ಗುರಾಣಿ",
  "item.minecraft.shield.black": "ಕಪ್ಪು ಗುರಾಣಿ",
  "item.minecraft.shield.blue": "\nನೀಲಿ ಗುರಾಣಿ",
  "item.minecraft.shield.brown": "\nಬ್ರೌನ್ ಶೀಲ್ಡ್",
  "item.minecraft.shield.cyan": "ಸಯಾನ್ ಶೀಲ್ಡ್",
  "item.minecraft.shield.gray": "\nಗ್ರೇ ಶೀಲ್ಡ್",
  "item.minecraft.shield.green": "ಹಸಿರು ಶೀಲ್ಡ್",
  "item.minecraft.shield.light_blue": "ತಿಳಿ ನೀಲಿ ಗುರಾಣಿ",
  "item.minecraft.shield.light_gray": "\nತಿಳಿ ಬೂದು ಗುರಾಣಿ\n",
  "item.minecraft.shield.lime": "\nಸುಣ್ಣದ ಗುರಾಣಿ",
  "item.minecraft.shield.magenta": "\nಮೆಜೆಂಟಾ ಶೀಲ್ಡ್",
  "item.minecraft.shield.orange": "ಕಿತ್ತಳೆ ಗುರಾಣಿ",
  "item.minecraft.shield.pink": "ಗುಲಾಬಿ ಗುರಾಣಿ",
  "item.minecraft.shield.purple": "ನೇರಳೆ ಗುರಾಣಿ",
  "item.minecraft.shield.red": "\nಕೆಂಪು ಗುರಾಣಿ",
  "item.minecraft.shield.white": "\nಬಿಳಿ ಗುರಾಣಿ",
  "item.minecraft.shield.yellow": "\nಹಳದಿ ಗುರಾಣಿ",
  "item.minecraft.shulker_shell": "ಶುಲ್ಕರ್ ಶೆಲ್",
  "item.minecraft.shulker_spawn_egg": "ಶಲ್ಕರ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.sign": "Sign",
  "item.minecraft.silence_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Silence Armor Trim",
  "item.minecraft.silverfish_spawn_egg": "ಸಿಲ್ವರ್‌ಫಿಶ್ ಸ್ಪಾವ್ನ್ ಎಗ್",
  "item.minecraft.skeleton_horse_spawn_egg": "ಅಸ್ಥಿಪಂಜರ ಕುದುರೆ ಸ್ಪಾನ್ ಮೊಟ್ಟೆ",
  "item.minecraft.skeleton_spawn_egg": "ಅಸ್ಥಿಪಂಜರ ಸ್ಪಾವ್ನ್ ಮೊಟ್ಟೆ",
  "item.minecraft.skull_banner_pattern": "Banner Pattern",
  "item.minecraft.skull_banner_pattern.desc": "ಸ್ಕಲ್ ಚಾರ್ಜ್",
  "item.minecraft.skull_banner_pattern.new": "Skull Charge Banner Pattern",
  "item.minecraft.skull_pottery_shard": "Skull Pottery Shard",
  "item.minecraft.skull_pottery_sherd": "Skull Pottery Sherd",
  "item.minecraft.slime_ball": "ಸ್ಲಿಮ್‌ಬಾಲ್",
  "item.minecraft.slime_spawn_egg": "ಲೋಳೆ ಸ್ಪಾವ್ನ್ ಮೊಟ್ಟೆ",
  "item.minecraft.smithing_template": "Smithing Template",
  "item.minecraft.smithing_template.applies_to": "Applies to:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Add ingot or crystal",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Armor",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Add a piece of armor",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Ingots & Crystals",
  "item.minecraft.smithing_template.ingredients": "Ingredients:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Add Netherite Ingot",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diamond Equipment",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Add diamond armor, weapon, or tool",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netherite Ingot",
  "item.minecraft.smithing_template.upgrade": "Upgrade: ",
  "item.minecraft.sniffer_spawn_egg": "Sniffer Spawn Egg",
  "item.minecraft.snort_pottery_shard": "Snort Pottery Shard",
  "item.minecraft.snort_pottery_sherd": "Snort Pottery Sherd",
  "item.minecraft.snout_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Snout Armor Trim",
  "item.minecraft.snow_golem_spawn_egg": "Snow Golem Spawn Egg",
  "item.minecraft.snowball": "ಸ್ನೋಬಾಲ್",
  "item.minecraft.spectral_arrow": "ಸ್ಪೆಕ್ಟ್ರಲ್ ಬಾಣ",
  "item.minecraft.spider_eye": "ಜೇಡ ಕಣ್ಣು",
  "item.minecraft.spider_spawn_egg": "ಸ್ಪೈಡರ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.spire_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Spire Armor Trim",
  "item.minecraft.splash_potion": "\nಸ್ಪ್ಲಾಶ್ ಮದ್ದು",
  "item.minecraft.splash_potion.effect.awkward": "ವಿಚಿತ್ರ ಸ್ಪ್ಲಾಶ್ ಮದ್ದು",
  "item.minecraft.splash_potion.effect.empty": "\nಸ್ಪ್ಲಾಶ್ ಅನ್ಕ್ರಾಫ್ಟಬಲ್ ಮದ್ದು",
  "item.minecraft.splash_potion.effect.fire_resistance": "\nಬೆಂಕಿಯ ಪ್ರತಿರೋಧದ ಸ್ಪ್ಲಾಶ್ ಮದ್ದು",
  "item.minecraft.splash_potion.effect.harming": "\nಹಾನಿಯ ಸ್ಪ್ಲಾಶ್ ಮದ್ದು",
  "item.minecraft.splash_potion.effect.healing": "ಗುಣಪಡಿಸುವಿಕೆಯ ಸ್ಪ್ಲಾಶ್ ಮದ್ದು",
  "item.minecraft.splash_potion.effect.infested": "Splash Potion of Infestation",
  "item.minecraft.splash_potion.effect.invisibility": "ಅದೃಶ್ಯತೆಯ ಸ್ಪ್ಲಾಶ್ ಮದ್ದು",
  "item.minecraft.splash_potion.effect.leaping": "ಜಿಗಿಯುವ ಸ್ಪ್ಲಾಶ್ ಮದ್ದು",
  "item.minecraft.splash_potion.effect.levitation": "\nಸ್ಪ್ಲಾಶ್ ಮದ್ದು ಆಫ್ ಲೆವಿಟೇಶನ್",
  "item.minecraft.splash_potion.effect.luck": "ಅದೃಷ್ಟದ ಸ್ಪ್ಲಾಶ್ ಮದ್ದು",
  "item.minecraft.splash_potion.effect.mundane": "ಪ್ರಾಪಂಚಿಕ ಸ್ಪ್ಲಾಶ್ ಮದ್ದು",
  "item.minecraft.splash_potion.effect.night_vision": "ನೈಟ್ ವಿಷನ್‌ನ ಸ್ಪ್ಲಾಶ್ ಮದ್ದು",
  "item.minecraft.splash_potion.effect.oozing": "Splash Potion of Oozing",
  "item.minecraft.splash_potion.effect.poison": "\nವಿಷದ ಸ್ಪ್ಲಾಶ್ ಮದ್ದು",
  "item.minecraft.splash_potion.effect.regeneration": "ಪುನರುತ್ಪಾದನೆಯ ಸ್ಪ್ಲಾಶ್ ಮದ್ದು",
  "item.minecraft.splash_potion.effect.slow_falling": "\nನಿಧಾನವಾಗಿ ಬೀಳುವ ಸ್ಪ್ಲಾಶ್ ಮದ್ದು",
  "item.minecraft.splash_potion.effect.slowness": "ನಿಧಾನತೆಯ ಸ್ಪ್ಲಾಶ್ ಮದ್ದು",
  "item.minecraft.splash_potion.effect.strength": "ಸಾಮರ್ಥ್ಯದ ಸ್ಪ್ಲಾಶ್ ಮದ್ದು",
  "item.minecraft.splash_potion.effect.swiftness": "ಸ್ಪ್ಲಾಶ್ ಪೋಶನ್ ಆಫ್ ಸ್ವಿಫ್ಟ್ನೆಸ್",
  "item.minecraft.splash_potion.effect.thick": "ದಪ್ಪ ಸ್ಪ್ಲಾಶ್ ಮದ್ದು",
  "item.minecraft.splash_potion.effect.turtle_master": "ಆಮೆ ಮಾಸ್ಟರ್ನ ಸ್ಪ್ಲಾಷ್ ಪೋಶನ್",
  "item.minecraft.splash_potion.effect.water": "ಸ್ಪ್ಲಾಶ್ ವಾಟರ್ ಬಾಟಲ್",
  "item.minecraft.splash_potion.effect.water_breathing": "\nನೀರಿನ ಉಸಿರಾಟದ ಸ್ಪ್ಲಾಶ್ ಮದ್ದು",
  "item.minecraft.splash_potion.effect.weakness": "\nದೌರ್ಬಲ್ಯದ ಸ್ಪ್ಲಾಶ್ ಮದ್ದು",
  "item.minecraft.splash_potion.effect.weaving": "Splash Potion of Weaving",
  "item.minecraft.splash_potion.effect.wind_charged": "Splash Potion of Wind Charging",
  "item.minecraft.spruce_boat": "\nಸ್ಪ್ರೂಸ್ ಬೋಟ್",
  "item.minecraft.spruce_chest_boat": "ಎದೆಯೊಂದಿಗೆ ಸ್ಪ್ರೂಸ್ ದೋಣಿ",
  "item.minecraft.spyglass": "ಸ್ಪೈಗ್ಲಾಸ್",
  "item.minecraft.squid_spawn_egg": "ಸ್ಕ್ವಿಡ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.stick": "ಸ್ಟಿಕ್",
  "item.minecraft.stone_axe": "ಸ್ಟೋನ್ ಏಕ್ಸ್",
  "item.minecraft.stone_hoe": "ಶಿಲಾಯುಗ",
  "item.minecraft.stone_pickaxe": "ಸ್ಟೋನ್ ಪಿಕ್ಸಾ",
  "item.minecraft.stone_shovel": "ಕಲ್ಲಿನ ಸಲಿಕೆ",
  "item.minecraft.stone_spear": "Stone Spear",
  "item.minecraft.stone_sword": "ಸ್ಟೋನ್ ಸ್ವೋರ್ಡ್",
  "item.minecraft.stray_spawn_egg": "ದಾರಿತಪ್ಪಿ ಸ್ಪಾನ್ ಮೊಟ್ಟೆ",
  "item.minecraft.strider_spawn_egg": "ಸ್ಪೈಡರ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.string": "ಥ್ರೆಡ್",
  "item.minecraft.sugar": "ಸಕ್ಕರೆ",
  "item.minecraft.suspicious_stew": "ಅನುಮಾನಾಸ್ಪದ ಸ್ಟ್ಯೂ",
  "item.minecraft.sweet_berries": "ಸಿಹಿ ಹಣ್ಣುಗಳು",
  "item.minecraft.tadpole_bucket": "ಗೊದಮೊಟ್ಟೆಯ ಬಕೆಟ್",
  "item.minecraft.tadpole_spawn_egg": "ಟ್ಯಾಡ್ಪೋಲ್ ಸ್ಪಾನ್ ಮೊಟ್ಟೆ",
  "item.minecraft.tide_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Tide Armor Trim",
  "item.minecraft.tipped_arrow": "ಪರಿಣಾಮದೊಂದಿಗೆ ಬಾಣ",
  "item.minecraft.tipped_arrow.effect.awkward": "Tipped Arrow",
  "item.minecraft.tipped_arrow.effect.empty": "\nಕ್ರಾಫ್ಟಬಲ್ ಟಿಪ್ಡ್ ಬಾಣ",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "ಬೆಂಕಿಯ ಪ್ರತಿರೋಧದ ಬಾಣ",
  "item.minecraft.tipped_arrow.effect.harming": "ಹಾನಿಯ ಬಾಣ",
  "item.minecraft.tipped_arrow.effect.healing": "ಗುಣಪಡಿಸುವ ಬಾಣ",
  "item.minecraft.tipped_arrow.effect.infested": "Arrow of Infestation",
  "item.minecraft.tipped_arrow.effect.invisibility": "ಅದೃಶ್ಯತೆಯ ಬಾಣ",
  "item.minecraft.tipped_arrow.effect.leaping": "ಜಿಗಿಯುವ ಬಾಣ",
  "item.minecraft.tipped_arrow.effect.levitation": "\nಲೆವಿಟೇಶನ್ ಬಾಣ",
  "item.minecraft.tipped_arrow.effect.luck": "ಅದೃಷ್ಟದ ಬಾಣ",
  "item.minecraft.tipped_arrow.effect.mundane": "Tipped Arrow",
  "item.minecraft.tipped_arrow.effect.night_vision": "ನೈಟ್ ವಿಷನ್ ಬಾಣ",
  "item.minecraft.tipped_arrow.effect.oozing": "Arrow of Oozing",
  "item.minecraft.tipped_arrow.effect.poison": "ವಿಷದ ಬಾಣ",
  "item.minecraft.tipped_arrow.effect.regeneration": "ಪುನರುತ್ಪಾದನೆಯ ಬಾಣ",
  "item.minecraft.tipped_arrow.effect.slow_falling": "ನಿಧಾನವಾಗಿ ಬೀಳುವ ಬಾಣ",
  "item.minecraft.tipped_arrow.effect.slowness": "\nನಿಧಾನಗತಿಯ ಬಾಣ",
  "item.minecraft.tipped_arrow.effect.strength": "ಸಾಮರ್ಥ್ಯದ ಬಾಣ",
  "item.minecraft.tipped_arrow.effect.swiftness": "\nಸ್ವಿಫ್ಟ್ನೆಸ್ ಬಾಣ",
  "item.minecraft.tipped_arrow.effect.thick": "Tipped Arrow",
  "item.minecraft.tipped_arrow.effect.turtle_master": "ಆಮೆ ಮಾಸ್ಟರ್ನ ಬಾಣ",
  "item.minecraft.tipped_arrow.effect.water": "\nಸ್ಪ್ಲಾಶಿಂಗ್ ಬಾಣ",
  "item.minecraft.tipped_arrow.effect.water_breathing": "ನೀರಿನ ಉಸಿರಾಟದ ಬಾಣ",
  "item.minecraft.tipped_arrow.effect.weakness": "\nದೌರ್ಬಲ್ಯದ ಬಾಣ",
  "item.minecraft.tipped_arrow.effect.weaving": "Arrow of Weaving",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Arrow of Wind Charging",
  "item.minecraft.tnt_minecart": "ಟಿಎನ್‌ಟಿಯೊಂದಿಗೆ ಮೈನ್‌ಕಾರ್ಟ್",
  "item.minecraft.torchflower_seeds": "Torchflower Seeds",
  "item.minecraft.totem_of_undying": "ಅಂತ್ಯವಿಲ್ಲದ ಟೋಟೆಂ",
  "item.minecraft.trader_llama_spawn_egg": "ವ್ಯಾಪಾರಿ ಲಾಮಾ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.trial_key": "Trial Key",
  "item.minecraft.trident": "ತ್ರಿಶೂಲ",
  "item.minecraft.tropical_fish": "ಉಷ್ಣವಲಯದ ಮೀನು",
  "item.minecraft.tropical_fish_bucket": "ಉಷ್ಣವಲಯದ ಮೀನುಗಳ ಬಕೆಟ್",
  "item.minecraft.tropical_fish_spawn_egg": "ಉಷ್ಣವಲಯದ ಮೀನು ಸ್ಪಾವ್ನ್ ಮೊಟ್ಟೆ",
  "item.minecraft.turtle_helmet": "ಟರ್ಟಲ್ ಶೆಲ್",
  "item.minecraft.turtle_scute": "Turtle Scute",
  "item.minecraft.turtle_spawn_egg": "ಟರ್ಟಲ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.vex_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Vex Armor Trim",
  "item.minecraft.vex_spawn_egg": "ವೆಕ್ಸ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.villager_spawn_egg": "ಗ್ರಾಮಸ್ಥ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.vindicator_spawn_egg": "ವಿಂಡಿಕೇಟರ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.wandering_trader_spawn_egg": "ವ್ಯಾಂಡರ್ ವ್ಯಾಪಾರಿ ಟ್ರೇಡರ್ ಮೊಟ್ಟೆ ಮೊಟ್ಟೆ",
  "item.minecraft.ward_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Ward Armor Trim",
  "item.minecraft.warden_spawn_egg": "ವಾರ್ಡನ್ ಸ್ಪಾನ್ ಮೊಟ್ಟೆ",
  "item.minecraft.warped_fungus_on_a_stick": "ಒಂದು ಕೋಲಿನ ಮೇಲೆ ರ್ಯಾಪ್ಡ್ ಶಿಲೀಂಧ್ರ",
  "item.minecraft.water_bucket": "ನೀರಿನ ಬಕೆಟ್",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Wayfinder Armor Trim",
  "item.minecraft.wheat": "ಗೋಧಿ",
  "item.minecraft.wheat_seeds": "\nಗೋಧಿ ಬೀಜಗಳು",
  "item.minecraft.white_bundle": "White Bundle",
  "item.minecraft.white_dye": "ಬಿಳಿ ಬಣ್ಣ",
  "item.minecraft.white_harness": "White Harness",
  "item.minecraft.wild_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Wild Armor Trim",
  "item.minecraft.wind_charge": "Wind Charge",
  "item.minecraft.witch_spawn_egg": "ಮಾಟಗಾತಿ ಮೊಟ್ಟೆ ಮೊಟ್ಟೆ",
  "item.minecraft.wither_skeleton_spawn_egg": "ಅಸ್ಥಿಪಂಜರ ಸ್ಪಾವ್ನ್ ಮೊಟ್ಟೆ",
  "item.minecraft.wither_spawn_egg": "Wither Spawn Egg",
  "item.minecraft.wolf_armor": "Wolf Armor",
  "item.minecraft.wolf_spawn_egg": "ತೋಳ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.wooden_axe": "ಮರದ ಏಕ್ಸ್",
  "item.minecraft.wooden_hoe": "ವುಡನ್ ಹೇ",
  "item.minecraft.wooden_pickaxe": "ಮರದ ಪಿಕಕ್ಸೆ",
  "item.minecraft.wooden_shovel": "ಮರದ ಸಲಿಕೆ",
  "item.minecraft.wooden_spear": "Wooden Spear",
  "item.minecraft.wooden_sword": "ಮರದ ಸ್ವೋರ್ಡ್",
  "item.minecraft.writable_book": "ಪುಸ್ತಕ ಮತ್ತು ಕ್ವಿಲ್",
  "item.minecraft.written_book": "\nಲಿಖಿತ ಪುಸ್ತಕ",
  "item.minecraft.yellow_bundle": "Yellow Bundle",
  "item.minecraft.yellow_dye": "ಹಳದಿ ಬಣ್ಣ",
  "item.minecraft.yellow_harness": "Yellow Harness",
  "item.minecraft.zoglin_spawn_egg": "ಡಾಲ್ಫಿನ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.zombie_horse_spawn_egg": "ಝಾಂಬಿ ಹಾರ್ಸ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombie Nautilus Spawn Egg",
  "item.minecraft.zombie_spawn_egg": "ಝಾಂಬಿ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.zombie_villager_spawn_egg": "ಝಾಂಬಿ ವಿಲೇಜರ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.zombified_piglin_spawn_egg": "ಝಾಂಬಿ ಪಿಗ್ಮನ್ ಸ್ಪಾನ್ ಎಗ್"
}
export const kn_in = items; 
